<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<h1 class="chapter">PROJECTS</h1>
<p class="pagebreak"> </p>
<h1 class="section" id="sec1">The Bunny Bunch</h1>
<p class="center">Rating <img alt="" src="OEBPS/images/11-2.jpg"/></p>
<p class="center"><strong><em>This simple project is just right to get a beginner started on making toys</em></strong></p>
<p class="center">Two little baby bunnies and their mummy live in Polly Dolly’s garden and sleep in a big wooden hutch. They love to jump and play silly games. They like chasing butterflies and eating dandelions and daisies.</p>
<p class="center">The bunnies’ heads and bodies are made in one piece from very soft, towelling-type yarn. The boy bunny has a white muzzle, so you will have to change colours to make him. Fluffy pompoms make the bunnies’ tails, and fabric scraps line their ears. They are perfect projects for beginners as they introduce you to very simple shaping.</p>
<div class="box">
<p class="nonindent"><strong>yarn</strong></p>
<p class="nonindent">Lightweight (DK) 100% polyester with <br/>towelling or chenille texture</p>
<p class="nonindent">Mummy bunny – 1 x 1¾oz (50g) ball in white (<strong>A</strong>)</p>
<p class="nonindent">Baby boy bunny – 1 x 1¾oz (50g) ball in white (<strong>A</strong>), 1 x 1¾oz (50g) ball in pale blue (<strong>B</strong>)</p>
<p class="nonindent">Baby girl bunny – 1 x 1¾oz (50g) ball in pale pink (<strong>C</strong>)</p>
<br/>
<p class="nonindent"><strong>needles</strong></p>
<p class="nonindent">Size 6 (4mm) knitting needles</p>
<br/>
<p class="nonindent"><strong>gauge</strong></p>
<p class="nonindent">16 sts and 31 rows to 4in (10cm)</p>
<p class="nonindent"><em>Don’t worry if the gauge is not exact –it doesn’t matter if the bunnies are a little bigger or smaller than shown</em></p>
<br/>
<p class="nonindent"><strong>finished size</strong></p>
<p class="nonindent">Mummy bunny – 5½in (14cm) long (not including tail) and 4¼in (11cm) tall</p>
<p class="nonindent">Baby bunnies – 3½in (9cm) long (not including tail) and 3½in (9cm) tall</p>
</div>
<p class="center"><img alt="" src="OEBPS/images/11-1.jpg"/></p>
<p class="center"><img alt="" src="OEBPS/images/12-1.jpg"/></p>
<h2 class="section">Baby bunnies pattern</h2>
<p class="extract">HEAD AND BODY</p>
<p class="nonindent">Cast on 5 sts in <strong>yarn A</strong> if you are knitting the boy bunny or <strong>yarn C</strong> if knitting the girl bunny, using size 6 (4mm) knitting needles.</p>
<p class="nonindent"><strong>Row 1</strong> [kfb] 4 times, k1. 9 sts.</p>
<p class="nonindent"><strong>Row 2</strong> P.</p>
<p class="nonindent"><strong>Row 3</strong> [kfb, k1] 4 times, k1. 13 sts.</p>
<p class="nonindent"><strong>Row 4</strong> P.</p>
<p class="nonindent"><strong>Row 5</strong> [kfb, k1, kfb] 4 times, k1. 21 sts.</p>
<p class="nonindent"><strong>Row 6</strong> P.</p>
<p class="nonindent">Change to <strong>yarn B</strong> if knitting the boy bunny and continue knitting in <strong>yarn C</strong> if you are knitting the girl bunny.</p>
<p class="nonindent"><strong>Row 7</strong> [kfb, k3, kfb] 4 times, k1. 29 sts.</p>
<p class="nonindent"><strong>Row 8</strong> P.</p>
<p class="nonindent"><strong>Row 9</strong> [kfb, k5, kfb] 4 times, k1. 37 sts.</p>
<p class="nonindent"><strong>Row 10</strong> P.</p>
<p class="nonindent">Cont in st st for 4 rows.</p>
<p class="nonindent"><strong>Row 15</strong> [kfb, k7, kfb] 4 times, k1. 45 sts.</p>
<p class="nonindent"><strong>Row 16</strong> P.</p>
<p class="nonindent">Cont in st st for 8 rows.</p>
<p class="nonindent"><strong>Row 25</strong> [k2tog, k7, skpo] 4 times, k1.</p>
<p class="nonindent"><strong>Row 26</strong> P.</p>
<p class="nonindent"><strong>Row 27</strong> [k2tog, k5, skpo] 4 times, k1.</p>
<p class="nonindent"><strong>Row 28</strong> P.</p>
<p class="nonindent"><strong>Row 29</strong> [k2tog] rep to last st, k1.</p>
<p class="nonindent"><strong>Row 30</strong> P.</p>
<p class="nonindent"><strong>Row 31</strong> [k2tog] rep to last st, k1.</p>
<p class="nonindent"><strong>Row 32</strong> P.</p>
<p class="nonindent">Thread yarn through rem sts.</p>
<p class="center"><img alt="" src="OEBPS/images/13-1.jpg"/></p>
<p class="extract">EARS (MAKE 2)</p>
<p class="nonindent">Cast on 3 sts in <strong>yarn B</strong> for the boy bunny or <strong>yarn C</strong> for the girl bunny, using size 6 (4mm) knitting needles.</p>
<p class="nonindent"><strong>Row 1</strong> Kfb, kfb, k1. 5 sts.</p>
<p class="nonindent"><strong>Row 2</strong> P.</p>
<p class="nonindent"><strong>Row 3</strong> K1, kfb, kfb, k2. 7 sts.</p>
<p class="nonindent"><strong>Row 4</strong> P.</p>
<p class="nonindent">Cont in st st for 12 rows.</p>
<p class="nonindent"><strong>Row 17</strong> K2, k3tog, k2. 5 sts.</p>
<p class="nonindent"><strong>Row 18</strong> P.</p>
<p class="nonindent"><strong>Row 19</strong> K.</p>
<p class="nonindent"><strong>Row 20</strong> P.</p>
<p class="nonindent">Thread yarn through rem sts.</p>
<h2 class="section">Mummy bunny pattern</h2>
<p class="extract">HEAD AND BODY</p>
<p class="nonindent">Cast on 9 sts using <strong>yarn A</strong> and size 6 (4mm) knitting needles.</p>
<p class="nonindent"><strong>Row 1</strong> [kfb, k1] 4 times, k1. 13 sts.</p>
<p class="nonindent"><strong>Row 2</strong> P.</p>
<p class="nonindent"><strong>Row 3</strong> [kfb, k1, kfb] 4 times, k1. 21 sts.</p>
<p class="nonindent"><strong>Row 4</strong> P.</p>
<p class="nonindent"><strong>Row 5</strong> [kfb, k3, kfb] 4 times, k1. 29 sts.</p>
<p class="nonindent"><strong>Row 6</strong> P.</p>
<p class="nonindent"><strong>Row 7</strong> [kfb, k5, kfb] 4 times, k1. 37 sts.</p>
<p class="nonindent"><strong>Row 8</strong> P.</p>
<p class="nonindent"><strong>Row 9</strong> [kfb, k7, kfb] 4 times, k1. 45 sts.</p>
<p class="nonindent"><strong>Row 10</strong> P.</p>
<p class="nonindent"><strong>Row 11</strong> [kfb, k9, kfb] 4 times, k1. 53 sts.</p>
<p class="nonindent"><strong>Row 12</strong> P.</p>
<p class="nonindent">Cont in st st for 8 rows.</p>
<p class="nonindent"><strong>Row 21</strong> [k2tog, k9, skpo] 4 times, k1. 45 sts.</p>
<p class="nonindent"><strong>Row 22</strong> P.</p>
<p class="nonindent"><strong>Row 23</strong> [k2tog, k7, skpo] 4 times, k1. 37 sts.</p>
<p class="nonindent"><strong>Row 24</strong> P.</p>
<p class="nonindent"><strong>Row 25</strong> K.</p>
<p class="nonindent"><strong>Row 26</strong> P.</p>
<p class="nonindent"><strong>Row 27</strong> [kfb, k7, kfb] 4 times, k1. 45 sts.</p>
<p class="nonindent"><strong>Row 28</strong> P.</p>
<p class="nonindent"><strong>Row 29</strong> [kfb, k9, kfb] 4 times, k1. 53 sts.</p>
<p class="nonindent"><strong>Row 30</strong> P.</p>
<p class="nonindent"><strong>Row 31</strong> [kfb, k11, kfb] 4 times, k1. 61 sts.</p>
<p class="nonindent"><strong>Row 32</strong> P.</p>
<p class="nonindent">Cont in st st for 12 rows.</p>
<p class="nonindent"><strong>Row 45</strong> [k2tog, k11, skpo] 4 times, k1.</p>
<p class="nonindent"><strong>Row 46</strong> P.</p>
<p class="nonindent"><strong>Row 47</strong> [k2tog, k9, skpo] 4 times, k1.</p>
<p class="nonindent"><strong>Row 48</strong> P.</p>
<p class="nonindent"><strong>Row 49</strong> [k2tog, k7, skpo] 4 times, k1.</p>
<p class="nonindent"><strong>Row 50</strong> P.</p>
<p class="nonindent"><strong>Row 51</strong> [k2tog] rep to last st, k1.</p>
<p class="nonindent"><strong>Row 52</strong> P.</p>
<p class="nonindent"><strong>Row 53</strong> [k2tog] rep to last st, k1.</p>
<p class="nonindent"><strong>Row 54</strong> P.</p>
<p class="nonindent">Thread yarn through rem sts.</p>
<p class="extract">EARS (MAKE 2)</p>
<p class="nonindent">Cast on 5 sts using <strong>yarn A</strong> and size 6 (4mm) knitting needles.</p>
<p class="nonindent"><strong>Row 1</strong> K1, kfb, kfb, k2.</p>
<p class="nonindent"><strong>Row 2</strong> P.</p>
<p class="nonindent"><strong>Row 3</strong> K2, kfb, kfb, k3.</p>
<p class="nonindent"><strong>Row 4</strong> P.</p>
<p class="nonindent"><strong>Row 5</strong> K3, kfb, kfb, k4. 11 sts.</p>
<p class="nonindent"><strong>Row 6</strong> P.</p>
<p class="nonindent">Work in st st for 20 rows.</p>
<p class="nonindent"><strong>Row 27</strong> K4, k3tog, k4.</p>
<p class="nonindent"><strong>Row 28</strong> P.</p>
<p class="nonindent"><strong>Row 29</strong> K.</p>
<p class="nonindent"><strong>Row 30</strong> P.</p>
<p class="nonindent"><strong>Row 31</strong> K3, k3tog, k3.</p>
<p class="nonindent"><strong>Row 32</strong> P.</p>
<p class="nonindent">Bind off.</p>
<h2 class="section"><strong>MAKING UP</strong></h2>
<p class="nonindent">Fold the bunny in half with knit sides (right sides) together. Sew up from each end, leaving a gap of approx. ¾in (2cm) in the middle. Turn the bunny the right way out so the knit sides (right sides) are on the outside. Fill with stuffing. Sew up the gap.</p>
<p class="extract">Ears</p>
<p class="nonindent">Cut out two iron-on interfacing-lined fabric ears (see p. 116 for template). Use two pieces of iron-on interfacing on each ear to make them more rigid. Sew each piece of fabric to the inside of the knitted ear (see p. 113). Stitch the ears to each side of the bunny’s head, using the shaping at the top of the head to position them correctly and evenly apart.</p>
<p class="extract">Finishing touches</p>
<p class="nonindent">Embroider the nose in pink or white yarn and the eyes and mouth in brown or black yarn (as shown in the photograph). Make a pompom tail (see p. 115 for instructions and p. 116 for template) using white yarn and attach to the bottom of the bunny.</p>
<p class="center"><img alt="" src="OEBPS/images/14-1.jpg"/></p>
<p class="pagebreak"> </p>
<h1 class="section" id="sec2">Bertie and Beatrice the Birds</h1>
<p class="center">Rating <img alt="" src="OEBPS/images/11-2.jpg"/><img alt="" src="OEBPS/images/11-2.jpg"/></p>
<p class="center"><strong><em>The birds are made up of several small, shaped pieces and involve some intarsia colourwork</em></strong></p>
<p class="center">Bertie and Beatrice love to sing, so they sing all day and night. The problem is they only know one song. Is there anyone who can teach them a new one? Two songs are so much better than one!</p>
<p class="center">These bright little birds are made in pure wool yarn in strong, bold colours with little embroidered details. You can make your birds in one colour if you prefer. The birds’ legs are made from crocheted chains.</p>
<div class="box">
<p class="nonindent"><strong>yarn</strong></p>
<p class="nonindent">Lightweight (DK) 100% wool</p>
<p class="nonindent">1 x 1¾oz (50g) ball in pink (<strong>A</strong>)</p>
<p class="nonindent">1 x 1¾oz (50g) ball in yellow (<strong>B</strong>)</p>
<p class="nonindent">1 x 1¾oz (50g) ball in blue (<strong>C</strong>)</p>
<br/>
<p class="nonindent"><strong>needles</strong></p>
<p class="nonindent">Size 6 (4mm) knitting needles</p>
<p class="nonindent">Size E4 (3.5mm) crochet hook</p>
<br/>
<p class="nonindent"><strong>gauge</strong></p>
<p class="nonindent">22 sts and 30 rows to 4in (10cm)</p>
<p class="nonindent"><em>Don’t worry if the gauge is not exact – it doesn’t matter if the birds are a little bigger or smaller than shown</em></p>
<br/>
<p class="nonindent"><strong>finished size</strong></p>
<p class="nonindent">Approx. 8in (20cm) long and 4in (10cm) tall</p>
</div>
<p class="center"><img alt="" src="OEBPS/images/15-1.jpg"/></p>
<p class="center"><img alt="" src="OEBPS/images/16-1.jpg"/></p>
<div class="block">
<p class="extract"><strong>KNITTING NOTES</strong></p>
<p class="nonindent">• The colourwork for this project is done using the intarsia method (see p. 108). When knitting using two colours, make sure you wrap the yarns around one another when changing from one colour to the next. This prevents holes appearing between colours.</p>
<p class="nonindent">• For this pattern I have written instructions for Beatrice. She has a pink body, a yellow chest and blue wings. To make Bertie, substitute the colours so that:</p>
<p class="nonindent"><strong>yarn A</strong> = blue</p>
<p class="nonindent"><strong>yarn B</strong> = yellow</p>
<p class="nonindent"><strong>yarn C</strong> = green</p>
</div>
<h2 class="section">Bird pattern</h2>
<p class="extract">HEAD AND BODY</p>
<p class="nonindent">Cast on 9 sts using <strong>yarn A</strong> and size 6 (4mm) knitting needles.</p>
<p class="nonindent"><strong>Row 1</strong> [kfb, k1] to last st, k1.</p>
<p class="nonindent"><strong>Row 2</strong> P.</p>
<p class="nonindent"><strong>Row 3</strong> [kfb, k1, kfb] to last st, k1.</p>
<p class="nonindent"><strong>Row 4</strong> P.</p>
<p class="nonindent"><strong>Row 5</strong> [kfb, k3, kfb] to last st, k1.</p>
<p class="nonindent"><strong>Row 6</strong> P.</p>
<p class="nonindent"><strong>Row 7</strong> [kfb, k5, kfb] to last st, k1.</p>
<p class="nonindent"><strong>Row 8</strong> P.</p>
<p class="nonindent"><strong>Row 9</strong> [kfb, k7, kfb] to last st, k1. 45 sts.</p>
<p class="nonindent"><strong>Row 10</strong> P.</p>
<p class="nonindent">Cont in st st for 10 rows.</p>
<p class="nonindent">Beg the colour changes:</p>
<p class="nonindent"><strong>Row 21 A</strong> k16, <strong>B</strong> k13, <strong>A</strong> k16.</p>
<p class="nonindent"><strong>Row 22 A</strong> p15, <strong>B</strong> p15, <strong>A</strong> p15.</p>
<p class="nonindent"><strong>Row 23 A</strong> k2tog, k7, skpo, k2tog, k1, <strong>B</strong> k17, <strong>A</strong> k1, skpo, k2tog, k7, skpo. 39 sts.</p>
<p class="nonindent"><strong>Row 24 A</strong> p10, <strong>B</strong> p19, <strong>A</strong> p10.</p>
<p class="nonindent"><strong>Row 25 A</strong> k2tog, k5, skpo, k1, <strong>B</strong> k19, <strong>A</strong> k1, k2tog, k5, skpo. 35 sts.</p>
<p class="nonindent"><strong>Row 26 A</strong> p8, <strong>B</strong> p19, <strong>A</strong> p8.</p>
<p class="nonindent"><strong>Row 27 A</strong> k8, [<strong>B</strong> k1, kfb] 9 times, k1, <strong>A</strong> k8. 44 sts.</p>
<p class="nonindent"><strong>Row 28 A</strong> p8, <strong>B</strong> p28, <strong>A</strong> p8.</p>
<p class="nonindent"><strong>Row 29 A</strong> k8, <strong>B</strong> k28, <strong>A</strong> k8.</p>
<p class="nonindent"><strong>Row 30 A</strong> p8, <strong>B</strong> p28, <strong>A</strong> p8.</p>
<p class="nonindent"><strong>Row 31 A</strong> k8, <strong>B</strong> k28, <strong>A</strong> k8.</p>
<p class="nonindent"><strong>Row 32 A</strong> p8, <strong>B</strong> p28, <strong>A</strong> p8.</p>
<p class="nonindent"><strong>Row 33 A</strong> k8, <strong>B</strong> k1, kfb, k10, kfb, k1, kfb, k10, kfb, k2, <strong>A</strong> k8. 48 sts.</p>
<p class="nonindent"><strong>Row 34 A</strong> p8, <strong>B</strong> p32, <strong>A</strong> p8.</p>
<p class="nonindent"><strong>Row 35 A</strong> k8, <strong>B</strong> k1, kfb, k12, kfb, k1, kfb, k12, kfb, k2, <strong>A</strong> k8. 52 sts.</p>
<p class="nonindent"><strong>Row 36 A</strong> p8, <strong>B</strong> p36, <strong>A</strong> p8.</p>
<p class="nonindent"><strong>Row 37 A</strong> k8, <strong>B</strong> k36, <strong>A</strong> k8.</p>
<p class="nonindent"><strong>Row 38 A</strong> p8, <strong>B</strong> p36, <strong>A</strong> p8.</p>
<p class="nonindent"><strong>Row 39 A</strong> k1, kfb, k3, kfb, k2, <strong>B</strong> k2, skpo, k11, skpo, k2, k2tog, k11, k2tog, k2, <strong>A</strong> k1, kfb, k3, kfb, k2.</p>
<p class="nonindent"><strong>Row 40 A</strong> p10, <strong>B</strong> p32, <strong>A</strong> p10.</p>
<p class="nonindent"><strong>Row 41 A</strong> k1, kfb, k5, kfb, k2, <strong>B</strong> k2, skpo, k9, skpo, k2, k2tog, k9, k2tog, k2 <strong>A</strong> k1, kfb, k5, kfb, k2.</p>
<p class="nonindent"><strong>Row 42 A</strong> p12, <strong>B</strong> p28, <strong>A</strong> p12.</p>
<p class="nonindent"><strong>Row 43 A</strong> k1, kfb, k7, kfb, k2, <strong>B</strong> k2, skpo, k7, skpo, k2, k2tog, k7, k2tog, k2 <strong>A</strong> k1, kfb, k7, kfb, k2.</p>
<p class="nonindent"><strong>Row 44 A</strong> p14, <strong>B</strong> p24, <strong>A</strong> p14.</p>
<p class="nonindent"><strong>Row 45 A</strong> k1, kfb, k9, kfb, k2, <strong>B</strong> k2, skpo, k5, skpo, k2, k2tog, k5, k2tog, k2 <strong>A</strong> k1, kfb, k9, kfb, k2.</p>
<p class="nonindent"><strong>Row 46 A</strong> p16, <strong>B</strong> p20, <strong>A</strong> p16.</p>
<p class="nonindent"><strong>Row 47 A</strong> k1, kfb, k11, kfb, k2 <strong>B</strong> k2, skpo, k1, skpo, skpo, k2, k2tog, k2tog, k1, k2tog, k2, <strong>A</strong> k1, kfb, k11, kfb, k2.</p>
<p class="nonindent"><strong>Row 48 A</strong> p18, <strong>B</strong> p14, <strong>A</strong> p18.</p>
<p class="nonindent"><strong>Row 49 A</strong> k1, kfb, k16, [<strong>B</strong> k2tog] 7 times, <strong>A</strong> k16, kfb, k1.</p>
<p class="nonindent"><strong>Row 50 A</strong> p19, <strong>B</strong> p2tog, p3tog, p2tog, <strong>A</strong> p19.</p>
<p class="nonindent"><strong>Row 51 A</strong> k1, kfb, k17, k3tog, k17, kfb, k1.</p>
<p class="nonindent"><strong>Row 52</strong> P.</p>
<p class="nonindent"><strong>Row 53</strong> K1, kfb, k11, [k2tog] 3 times, k3tog, [k2tog] 3 times, k11, kfb, k1.</p>
<p class="nonindent"><strong>Row 54</strong> P.</p>
<p class="nonindent">Bind off.</p>
<p class="extract">RIGHT WING</p>
<p class="nonindent">Cast on 3 sts using <strong>yarn C</strong> and size 6 (4mm) knitting needles.</p>
<p class="nonindent"><strong>Row 1</strong> Kfb, kfb, k1.</p>
<p class="nonindent"><strong>Row 2</strong> P.</p>
<p class="nonindent"><strong>Row 3</strong> K1, kfb, kfb, k2.</p>
<p class="nonindent"><strong>Row 4</strong> P.</p>
<p class="nonindent"><strong>Row 5</strong> K2, kfb, kfb, k3.</p>
<p class="nonindent"><strong>Row 6</strong> P.</p>
<p class="nonindent"><strong>Row 7</strong> K3, kfb, kfb, k4.</p>
<p class="nonindent"><strong>Row 8</strong> P.</p>
<p class="nonindent">Cont in st st for 6 rows.</p>
<p class="nonindent"><strong>Row 15</strong> K2tog, k to end.</p>
<p class="nonindent"><strong>Row 16</strong> P.</p>
<p class="nonindent"><strong>Row 17</strong> K2tog, k to end.</p>
<p class="nonindent"><strong>Row 18</strong> P.</p>
<p class="nonindent">Bind off.</p>
<p class="center"><img alt="" src="OEBPS/images/17-1.jpg"/></p>
<p class="center"><img alt="" src="OEBPS/images/18-1.jpg"/></p>
<p class="extract">LEFT WING</p>
<p class="nonindent">Follow instructions for right wing until row 15:</p>
<p class="nonindent"><strong>Row 15</strong> K to last 2 sts, k2tog.</p>
<p class="nonindent"><strong>Row 16</strong> P.</p>
<p class="nonindent"><strong>Row 17</strong> K to last 2 sts, k2tog.</p>
<p class="nonindent"><strong>Row 18</strong> P.</p>
<p class="nonindent">Bind off.</p>
<p class="extract">BEAK (MAKE 2 PIECES)</p>
<p class="nonindent">Cast on 3 sts using <strong>yarn B</strong> and size 6 (4mm) knitting needles.</p>
<p class="nonindent"><strong>Row 1</strong> Kfb, kfb, k1.</p>
<p class="nonindent"><strong>Row 2</strong> P.</p>
<p class="nonindent"><strong>Row 3</strong> K1, kfb, kfb, k2.</p>
<p class="nonindent"><strong>Row 4</strong> P.</p>
<p class="center"><img alt="" src="OEBPS/images/19-1.jpg"/></p>
<p class="nonindent"><strong>Row 5</strong> K2, kfb, kfb, k3.</p>
<p class="nonindent"><strong>Row 6</strong> P.</p>
<p class="nonindent"><strong>Row 7</strong> K3, kfb, kfb, k4.</p>
<p class="nonindent"><strong>Row 8</strong> P.</p>
<p class="nonindent">Bind off.</p>
<p class="extract">FEET (MAKE 2)</p>
<p class="nonindent">Cast on 3 sts using <strong>yarn B</strong> and size 6 (4mm) knitting needles, leaving a long piece of yarn to be used to crochet the legs.</p>
<p class="nonindent"><strong>Row 1</strong> Kfb, kfb, k1.</p>
<p class="nonindent"><strong>Row 2</strong> P.</p>
<p class="nonindent"><strong>Row 3</strong> K1, kfb, kfb, k2.</p>
<p class="nonindent"><strong>Row 4</strong> P.</p>
<p class="nonindent"><strong>Row 5</strong> K2, kfb, kfb, k3.</p>
<p class="nonindent"><strong>Row 6</strong> P.</p>
<p class="nonindent"><strong>Row 7</strong> K3, kfb, kfb, k4.</p>
<p class="nonindent"><strong>Row 8</strong> P.</p>
<p class="nonindent"><strong>Row 9</strong> K4, kfb, kfb, k5.</p>
<p class="nonindent"><strong>Row 10</strong> P.</p>
<p class="nonindent"><strong>Row 11</strong> K4, skpo, k1, k2tog, k4.</p>
<p class="nonindent"><strong>Row 12</strong> P.</p>
<p class="nonindent"><strong>Row 13</strong> K3, skpo, k1, k2tog, k3.</p>
<p class="nonindent"><strong>Row 14</strong> P.</p>
<p class="nonindent"><strong>Row 15</strong> K2, skpo, k1, k2tog, k2.</p>
<p class="nonindent"><strong>Row 16</strong> P.</p>
<p class="nonindent"><strong>Row 17</strong> K1, skpo, k1, k2tog, k1.</p>
<p class="nonindent"><strong>Row 18</strong> P5tog.</p>
<p class="nonindent">Cut off yarn, leaving another length of approx. 12in (30cm) to crochet the legs (the legs are crocheted with 2 strands of yarn, one length from casting on and the other from the other end of the work).</p>
<h2 class="section"><strong>MAKING UP</strong></h2>
<p class="extract">Body</p>
<p class="nonindent">Sew up from the base of the bird to the tip of her tail, leaving the top open.</p>
<p class="nonindent">Fill with stuffing.</p>
<p class="nonindent">Fold the top of the tail over to form a triangle. The tip of this triangle should touch the top of the sewn-up base to form a V-shape.</p>
<p class="nonindent">Sew along the ‘V’ to close the gap.</p>
<p class="extract">Wings</p>
<p class="nonindent">Cut out two iron-on interfacing-lined fabric wings (see p. 119 for template).</p>
<p class="nonindent">Sew each piece of fabric to the inside of the knitted wing (see p. 113).</p>
<p class="nonindent">Stitch the wings to each side of the bird’s body using the shaping at the top of the breast to position them correctly. The fabric enables the wing to bend as though the bird is flying.</p>
<p class="extract">Beak</p>
<p class="nonindent">Sew both pieces together.</p>
<p class="nonindent">Fill with a small amount of stuffing.</p>
<p class="nonindent">Stitch the beak to the bird’s head using the shaping at the front of the head to position it correctly.</p>
<p class="extract">Legs and feet</p>
<p class="nonindent">Fold the feet in half and make a crochet stitch through both sides using the leftover yarn.</p>
<p class="nonindent">Crochet a chain (see p. 114) of 10 rows with the 2 strands of leftover yarn attached to the feet. (Using a double thickness of yarn creates a thicker leg.)</p>
<p class="nonindent">Sew round the edges of the feet.</p>
<p class="nonindent">Thread the crochet chain with foot through the base of the body.</p>
<p class="extract">Finishing touches</p>
<p class="nonindent">Embroider eyes on each side of the head using brown or black yarn (as shown in the photograph).</p>
<p class="nonindent">Using a contrast-colour yarn, embroider details onto the wings.</p>
<p class="center"><img alt="" src="OEBPS/images/20-1.jpg"/></p>
<p class="center"><img alt="" src="OEBPS/images/21-1.jpg"/></p>
<p class="pagebreak"> </p>
<h1 class="section" id="sec3">Frederick the Frog Prince</h1>
<p class="center">Rating <img alt="" src="OEBPS/images/11-2.jpg"/><img alt="" src="OEBPS/images/11-2.jpg"/></p>
<p class="center"><strong><em>Frederick is made from two types of green yarn, and you will need to use intarsia to work the colour changes</em></strong></p>
<p class="center">Frederick Frog has a dream, a dream that he hopes will come true. Many years ago a wicked witch cast a spell on Prince Frederick and he has been a frog ever since. This spell can be broken only by a kiss from a beautiful girl. Every day Frederick Frog sits and dreams that a beautiful girl will come his way.</p>
<p class="center">Have fun making Frederick’s crown fit for a prince and decorate it with little beads to resemble jewels.</p>
<div class="box">
<p class="nonindent"><strong>yarn</strong></p>
<p class="nonindent">Lightweight (DK) 100% wool</p>
<p class="nonindent">1 x 1¾oz (50g) ball in variegated dark greens (<strong>A</strong>)</p>
<p class="nonindent">1 x 1¾oz (50g) ball in light green (<strong>B</strong>)</p>
<p class="nonindent">Oddment of yarn in white (<strong>C</strong>)</p>
<p class="nonindent">Oddment of yarn in black (<strong>D</strong>)</p>
<br/>
<p class="nonindent"><strong>needles</strong></p>
<p class="nonindent">Size 6 (4mm) knitting needles</p>
<p class="nonindent"><em>You will need three needles this size</em></p>
<br/>
<p class="nonindent"><strong>gauge</strong></p>
<p class="nonindent">22 sts and 28 rows to 4in (10cm)</p>
<p class="nonindent"><em>Don’t worry if the gauge is not exact – it doesn’t matter if Frederick is a little bigger or smaller than shown</em></p>
<br/>
<p class="nonindent"><strong>finished size</strong></p>
<p class="nonindent">Approx. 5in (13cm) wide and 8¼in (21cm) tall</p>
</div>
<p class="center"><img alt="" src="OEBPS/images/23-1.jpg"/></p>
<p class="center"><img alt="" src="OEBPS/images/24-1.jpg"/></p>
<div class="block">
<p class="extract"><strong>KNITTING NOTES</strong></p>
<p class="nonindent">• The colourwork for this project is done using the intarsia method (see p. 108). When knitting using two colours, make sure you wrap the yarns around one another when changing from one colour to the next. This prevents holes appearing between colours.</p>
<p class="nonindent">• Frederick is knitted from the head down to the legs in one piece. The arms and hands are also knitted in one piece and then attached to the body.</p>
</div>
<div class="blank">
<h2 class="section">Frederick the Frog</h2>
<h2 class="section">pattern</h2>
<p class="extract">HEAD AND BODY</p>
<p class="nonindent">Cast on 9 sts using <strong>yarn A</strong> and size 6 (4mm) knitting needles.</p>
<p class="nonindent"><strong>Row 1</strong> [kfb, k1] 4 times, k1. 13 sts.</p>
<p class="nonindent"><strong>Row 2</strong> P.</p>
<p class="nonindent"><strong>Row 3</strong> [kfb, k1, kfb] 4 times, k1. 21 sts.</p>
<p class="nonindent"><strong>Row 4</strong> P.</p>
<p class="nonindent"><strong>Row 5</strong> [kfb, k3, kfb] 4 times, k1. 29 sts.</p>
<p class="nonindent"><strong>Row 6</strong> P.</p>
<p class="nonindent"><strong>Row 7</strong> [kfb, k5, kfb] 4 times, k1. 37 sts.</p>
<p class="nonindent"><strong>Row 8</strong> P.</p>
<p class="nonindent"><strong>Row 9</strong> [kfb, k7, kfb] 4 times, k1. 45 sts.</p>
<p class="nonindent"><strong>Row 10</strong> P.</p>
<p class="nonindent"><strong>Row 11</strong> [kfb, k9, kfb] 4 times, k1. 53 sts.</p>
<p class="nonindent"><strong>Row 12</strong> P.</p>
<p class="nonindent">Cont in st st for 8 rows.</p>
<p class="nonindent"><strong>Row 21</strong> [k2tog, k9, skpo] 4 times, k1.</p>
<p class="nonindent"><strong>Row 22</strong> P.</p>
<p class="nonindent"><strong>Row 23</strong> [k2tog, k7, skpo] 4 times, k1.</p>
<p class="nonindent"><strong>Row 24</strong> P.</p>
<p class="nonindent"><strong>Row 25</strong> K.</p>
<p class="nonindent"><strong>Row 26</strong> P.</p>
<p class="nonindent"><strong>Row 27</strong> [kfb, k7, kfb] 4 times, k1.</p>
<p class="nonindent"><strong>Row 28</strong> P.</p>
<p class="nonindent"><strong>Row 29</strong> [kfb, k9, kfb] 4 times, k1.</p>
<p class="nonindent"><strong>Row 30</strong> P.</p>
<p class="nonindent"><strong>Row 31</strong> [kfb, k11, kfb] 4 times, k1. 61 sts.</p>
<p class="nonindent"><strong>Row 32</strong> P.</p>
<p class="nonindent">Beg the colour changes.</p>
<p class="nonindent"><strong>Row 33</strong> K23 in <strong>A</strong>, k15 in <strong>B</strong>, k23 in <strong>A</strong>.</p>
<p class="nonindent"><strong>Row 34</strong> P22 in <strong>A</strong>, p17 in <strong>B</strong>, p22 in <strong>A</strong>.</p>
<p class="nonindent"><strong>Row 35</strong> K21 in <strong>A</strong>, k19 in <strong>B</strong>, k21 in <strong>A</strong>.</p>
<p class="nonindent"><strong>Row 36</strong> P20 in <strong>A</strong>, p21 in <strong>B</strong>, p20 in <strong>A</strong>.</p>
<p class="nonindent"><strong>Row 37</strong> K19 in <strong>A</strong>, k23 in <strong>B</strong>, k19 in <strong>A</strong>.</p>
<p class="nonindent"><strong>Row 38</strong> P19 in <strong>A</strong>, p23 in <strong>B</strong>, p19 in <strong>A</strong>.</p>
<p class="nonindent">Rep rows 37 and 38 two more times.</p>
<p class="nonindent"><strong>Row 43</strong> K20 in <strong>A</strong>, k21 in <strong>B</strong>, k20 in <strong>A</strong>.</p>
<p class="nonindent"><strong>Row 44</strong> P21 in <strong>A</strong>, p19 in <strong>B</strong>, p21 in <strong>A</strong>.</p>
<p class="nonindent"><strong>Row 45</strong> K22 in <strong>A</strong>, k17 in <strong>B</strong>, k22 in <strong>A</strong>.</p>
<p class="nonindent"><strong>Row 46</strong> P23 in <strong>A</strong>, p15 in <strong>B</strong>, p23 in <strong>A</strong>.</p>
<p class="nonindent"><strong>Row 47</strong> K in <strong>A</strong>.</p>
<p class="nonindent"><strong>Row 48</strong> P.</p>
<p class="nonindent"><strong>Row 49</strong> [k2tog, k11, skpo] 4 times, k1.</p>
<p class="nonindent"><strong>Row 50</strong> P.</p>
<p class="nonindent"><strong>Row 51</strong> [k2tog, k9, skpo] 4 times, k1.</p>
<p class="nonindent"><strong>Row 52</strong> P.</p>
<p class="nonindent"><strong>Row 53</strong> [k2tog, k7, skpo] 4 times, k1.</p>
<p class="nonindent"><strong>Row 54</strong> P.</p>
<p class="nonindent"><strong>Row 55</strong> [k1, k2tog] rep to last st, k1. 25 sts.</p>
<p class="nonindent"><strong>Row 56</strong> P.</p>
<p class="center"><img alt="" src="OEBPS/images/25-1.jpg"/></p>
<p class="extract">RIGHT LEG</p>
<p class="nonindent">Cont on rem 25 sts as follows:</p>
<p class="nonindent"><strong>Row 57</strong> K 12 sts and turn; cont on these sts to make right leg.</p>
<p class="nonindent"><strong>Row 58</strong> P.</p>
<p class="nonindent"><strong>Row 59</strong> K.</p>
<p class="nonindent"><strong>Row 60</strong> P.</p>
<p class="nonindent"><strong>Row 61</strong> K in <strong>yarn</strong> <strong>B</strong>.</p>
<p class="nonindent"><strong>Row 62</strong> P.</p>
<p class="nonindent"><strong>Row 63</strong> K.</p>
<p class="nonindent"><strong>Row 64</strong> P.</p>
<p class="nonindent">Rep last 8 rows 5 more times.</p>
<p class="extract">RIGHT FOOT</p>
<p class="nonindent">Cont on sts for leg as follows:</p>
<p class="nonindent"><strong>Row 105</strong> K 6 sts in <strong>yarn A</strong>. Fold sts in half so 1st 6 sts are facing 2nd 6 sts.</p>
<p class="nonindent"><strong>Row 106</strong> Using a 3rd needle, knit together the 1st pair of sts, then the 2nd, and cont in this way to the end of the row. 6 sts.</p>
<p class="nonindent"><strong>Row 107</strong> K2tog, k4.</p>
<p class="nonindent"><strong>Row 108</strong> P.</p>
<p class="nonindent"><strong>Row 109</strong> K1, kfb, kfb, k2.</p>
<p class="nonindent"><strong>Row 100</strong> P.</p>
<p class="nonindent"><strong>Row 111</strong> K2, kfb, kfb, k3.</p>
<p class="nonindent"><strong>Row 112</strong> P.</p>
<p class="nonindent"><strong>Row 113</strong> K3, kfb, kfb, k4.</p>
<p class="nonindent"><strong>Row 114</strong> P.</p>
<p class="nonindent"><strong>Row 115</strong> K4, kfb, kfb, k5.</p>
<p class="nonindent"><strong>Row 116</strong> P.</p>
<p class="nonindent"><strong>Row 117</strong> K5, kfb, kfb, k6. 15 sts.</p>
<p class="nonindent"><strong>Row 118</strong> P.</p>
<p class="nonindent"><strong>Row 119</strong> K5, skpo, k1, k2tog, k5.</p>
<p class="nonindent"><strong>Row 120</strong> P.</p>
<p class="nonindent"><strong>Row 121</strong> K4, skpo, k1, k2tog, k4.</p>
<p class="nonindent"><strong>Row 122</strong> P.</p>
<p class="nonindent"><strong>Row 123</strong> K3, skpo, k1, k2tog, k3.</p>
<p class="nonindent"><strong>Row 124</strong> P.</p>
<p class="nonindent"><strong>Row 125</strong> K2, skpo, k1, k2tog, k2.</p>
<p class="nonindent"><strong>Row 126</strong> P.</p>
<p class="nonindent"><strong>Row 127</strong> K1, skpo, k1, k2tog, k1.</p>
<p class="nonindent"><strong>Row 128</strong> P5tog.</p>
<p class="extract">Tie off yarn.</p>
<p class="center"><img alt="" src="OEBPS/images/26-1.jpg"/></p>
<p class="extract">LEFT LEG AND FOOT</p>
<p class="nonindent">Return to the 13 sts rem on the left side.</p>
<p class="nonindent"><strong>Row 57</strong> K2tog, k. 12 sts.</p>
<p class="nonindent">Cont, repeating patt instructions for right leg and foot.</p>
<p class="extract">RIGHT ARM</p>
<p class="nonindent">Cast on 12 sts using <strong>yarn A</strong> and size 6 (4mm) knitting needles.</p>
<p class="nonindent"><strong>Row 1</strong> K.</p>
<p class="nonindent"><strong>Row 2</strong> P.</p>
<p class="nonindent"><strong>Row 3</strong> K.</p>
<p class="nonindent"><strong>Row 4</strong> P.</p>
<p class="nonindent"><strong>Row 5</strong> K in <strong>yarn B</strong>.</p>
<p class="nonindent"><strong>Row 6</strong> P.</p>
<p class="nonindent"><strong>Row 7</strong> K.</p>
<p class="nonindent"><strong>Row 8</strong> P.</p>
<p class="nonindent">Rep last 8 rows 2 more times.</p>
<p class="extract">RIGHT HAND</p>
<p class="nonindent">Cont on sts for arm as follows:</p>
<p class="nonindent"><strong>Row 25</strong> K 6 sts in <strong>yarn A</strong>. Fold sts in half so 1st 6 sts are facing 2nd 6 sts.</p>
<p class="nonindent"><strong>Row 26</strong> Using a 3rd needle, knit together the 1st pair of sts, then the 2nd. Cont in this way to the end of the row. 6 sts.</p>
<p class="nonindent"><strong>Row 27</strong> K2 tog, k4.</p>
<p class="nonindent"><strong>Row 28</strong> P.</p>
<p class="nonindent"><strong>Row 29</strong> K1, kfb, kfb, k2.</p>
<p class="nonindent"><strong>Row 30</strong> P.</p>
<p class="nonindent"><strong>Row 31</strong> K2, kfb, kfb, k3.</p>
<p class="nonindent"><strong>Row 32</strong> P.</p>
<p class="nonindent"><strong>Row 33</strong> K3, kfb, kfb, k4.</p>
<p class="nonindent"><strong>Row 34</strong> P.</p>
<p class="nonindent"><strong>Row 35</strong> K4, kfb, kfb, k5.</p>
<p class="nonindent"><strong>Row 36</strong> P.</p>
<p class="nonindent"><strong>Row 37</strong> K4, skpo, k1, k2tog, k4.</p>
<p class="nonindent"><strong>Row 38</strong> P.</p>
<p class="nonindent"><strong>Row 39</strong> K3, skpo, k1, k2tog, k3.</p>
<p class="nonindent"><strong>Row 40</strong> P.</p>
<p class="nonindent"><strong>Row 41</strong> K2, skpo, k1, k2tog, k2.</p>
<p class="nonindent"><strong>Row 42</strong> P.</p>
<p class="nonindent"><strong>Row 43</strong> K1, skpo, k1, k2tog, k1.</p>
<p class="nonindent"><strong>Row 44</strong> P5tog.</p>
<p class="nonindent">Tie off yarn.</p>
<p class="extract">LEFT ARM AND HAND</p>
<p class="nonindent">Follow instructions for right arm and hand.</p>
<p class="extract">EYES (MAKE 2)</p>
<p class="nonindent">Cast on 4 sts using <strong>yarn B</strong> and size 6 (4mm) knitting needles.</p>
<p class="nonindent"><strong>Row 1</strong> Kfb in each st.</p>
<p class="nonindent"><strong>Row 2</strong> P.</p>
<p class="nonindent"><strong>Row 3</strong> Kfb in each st.</p>
<p class="nonindent"><strong>Row 4</strong> P.</p>
<p class="nonindent">Cont in st st for 4 rows.</p>
<p class="nonindent"><strong>Row 9</strong> Using <strong>yarn C</strong>, k.</p>
<p class="nonindent"><strong>Row 10</strong> P.</p>
<p class="nonindent"><strong>Row 11</strong> K2tog to end of row.</p>
<p class="nonindent"><strong>Row 12</strong> Using <strong>yarn D</strong>, p.</p>
<p class="nonindent"><strong>Row 13</strong> K2tog to end of row.</p>
<p class="nonindent">Thread yarn through rem sts, pull together to close the gap, and cut yarn.</p>
<h2 class="section"><strong>MAKING UP</strong></h2>
<p class="nonindent">Fold the body of the frog in half with knit sides (right sides) together.</p>
<p class="nonindent">Sew up from the top of the head to the legs.</p>
<p class="nonindent">Turn frog the right way out so the knit sides (right sides) are on the outside.</p>
<p class="nonindent">Fill with stuffing.</p>
<p class="extract">Legs</p>
<p class="nonindent">Sew from each end leaving a gap of approx. 11/8in (3cm) in the middle. Fill with stuffing.</p>
<p class="nonindent">With a few stitches, join the third and fourth dark-green stripe at the seam to bend the frog’s legs at the knees.</p>
<p class="extract">Feet</p>
<p class="nonindent">Fold the feet in half and sew round the edges. With a few stitches, sew the frog’s feet at the ankle end to his legs so they are bent at the ankle.</p>
<p class="extract">Arms</p>
<p class="nonindent">Sew from each end leaving a gap of approx. 11/8in (3cm) in the middle.</p>
<p class="nonindent">Fill with stuffing.</p>
<p class="nonindent">Sew on to the body using shaping to position correctly.</p>
<p class="extract">Hands</p>
<p class="nonindent">Fold the hands in half and sew round the edges.</p>
<p class="nonindent">Sew up gap.</p>
<p class="extract">Eyes</p>
<p class="nonindent">Sew up eyes and fill with stuffing. Sew onto top of the head using shaping to position correctly.</p>
<p class="extract">Finishing touches</p>
<p class="nonindent">Embroider the mouth in black yarn.</p>
<p class="nonindent">Make the crown out of yellow felt (see p. 122 for template). Use gold thread to embroider details or add small beads for the jewels if desired.</p>
<p class="center"><img alt="" src="OEBPS/images/28-1.jpg"/></p>
<p class="pagebreak"> </p>
<h1 class="section" id="sec4">Babushkas</h1>
<p class="center">Rating <img alt="" src="OEBPS/images/11-2.jpg"/><img alt="" src="OEBPS/images/11-2.jpg"/></p>
<p class="center"><strong><em>The colourwork on the babushkas is done using intarsia, which you might need to practise</em></strong></p>
<p class="center">The babushkas are three very pretty Russian dolls. They are good friends with Polly Dolly, but sometimes they play tricks on her by jumping and hiding one inside the other.</p>
<p class="center">The babushkas are fully lined on the inside to give them some stability and to allow you to stack them inside each other, just like real Russian dolls. Each doll is decorated with different styles of flower; you can cut out pieces of felt for the flowers or embroider them.</p>
<p class="center"><img alt="" src="OEBPS/images/29-1.jpg"/></p>
<div class="box">
<p class="nonindent"><strong>yarn</strong></p>
<p class="nonindent">Lightweight (DK) acrylic and wool mix yarn</p>
<p class="nonindent">1 x 3½oz (100g) ball in yellow (<strong>A</strong>)</p>
<p class="nonindent">1 x 3½oz (100g) ball in pink (<strong>B</strong>)</p>
<p class="nonindent">1 x 3½oz (100g) ball in white (<strong>C</strong>)</p>
<p class="nonindent">1 x 3½oz (100g) ball in red (<strong>D</strong>)</p>
<br/>
<p class="nonindent"><strong>needles</strong></p>
<p class="nonindent">Size 6 (4mm) knitting needles</p>
<br/>
<p class="nonindent"><strong>gauge</strong></p>
<p class="nonindent">22 sts and 30 rows to 4in (10cm)</p>
<p class="nonindent"><em>Don’t worry if the gauge is not exact – it doesn’t matter if the babushkas are a little bigger or smaller than shown</em></p>
<br/>
<p class="nonindent"><strong>finished size</strong></p>
<p class="nonindent">Large babushka – 9in (23cm) tall</p>
<p class="nonindent">Medium babushka – 6¾in (17cm) tall</p>
<p class="nonindent">Small babushka – 4in (10cm) tall</p>
</div>
<p class="center"><img alt="" src="OEBPS/images/30-1.jpg"/></p>
<p class="caption">There’s Olga who’s tall, and Tanya who’s small,</p>
<p class="caption">And Nadia who fits in between.</p>
<p class="caption">They are three Russian dollies, who like to be jolly,</p>
<p class="caption">Their smiles are the best ever seen.</p>
</div>
<div class="block">
<p class="extract"><strong>KNITTING NOTES</strong></p>
<p class="nonindent">• The colourwork for this project is done using the intarsia method (see p. 108). When knitting using two colours, make sure you wrap the yarns around one another when changing from one colour to the next. This prevents holes appearing between colours.</p>
<p class="nonindent">• The babushkas are knitted from the head down.</p>
</div>
<p class="center"><img alt="" src="OEBPS/images/31-1.jpg"/></p>
<h2 class="section">Large babushka pattern</h2>
<p class="nonindent">Cast on 9 sts using <strong>yarn A</strong> and size 6 (4mm) knitting needles.</p>
<p class="nonindent"><strong>Row 1</strong> [kfb, k1] 4 times, k1.</p>
<p class="nonindent"><strong>Row 2</strong> P.</p>
<p class="nonindent"><strong>Row 3</strong> [kfb, k1, kfb] 4 times, k1.</p>
<p class="nonindent"><strong>Row 4</strong> P.</p>
<p class="nonindent"><strong>Row 5</strong> [kfb, k3, kfb] 4 times, k1.</p>
<p class="nonindent"><strong>Row 6</strong> P.</p>
<p class="nonindent"><strong>Row 7</strong> [kfb, k5, kfb] 4 times, k1.</p>
<p class="nonindent"><strong>Row 8</strong> P.</p>
<p class="nonindent"><strong>Row 9</strong> [kfb, k7, kfb] 4 times, k1. 45 sts.</p>
<p class="nonindent"><strong>Row 10</strong> P.</p>
<p class="nonindent">Beg the colour changes.</p>
<p class="nonindent"><strong>Row 11</strong> <strong>A</strong> k16, <strong>B</strong> k13, <strong>A</strong> k16.</p>
<p class="nonindent"><strong>Row 12</strong> <strong>A</strong> p15, <strong>B</strong> p15, <strong>A</strong> p15.</p>
<p class="nonindent"><strong>Row 13</strong> <strong>A</strong> k14, <strong>B</strong> k17, <strong>A</strong> k14.</p>
<p class="nonindent"><strong>Row 14</strong> <strong>A</strong> p13, <strong>B</strong> p19, <strong>A</strong> p13.</p>
<p class="nonindent"><strong>Row 15</strong> <strong>A</strong> k13, <strong>B</strong> k19, <strong>A</strong> k13.</p>
<p class="nonindent">Rep rows 14 and 15 3 more times.</p>
<p class="nonindent"><strong>Row 22</strong> <strong>A</strong> p13, <strong>B</strong> p19, <strong>A</strong> p13.</p>
<p class="nonindent"><strong>Row 23</strong> <strong>A</strong> k14, <strong>B</strong> k17, <strong>A</strong> k14.</p>
<p class="nonindent"><strong>Row 24</strong> <strong>A</strong> p15, <strong>B</strong> p15, <strong>A</strong> p15.</p>
<p class="nonindent"><strong>Row 25</strong> <strong>A</strong> k16, <strong>B</strong> k13, <strong>A</strong> k16.</p>
<p class="nonindent"><strong>Row 26</strong> <strong>A</strong> p17, <strong>B</strong> p11, <strong>A</strong> p17.</p>
<p class="nonindent"><strong>Row 27</strong> <strong>A</strong> k.</p>
<p class="nonindent"><strong>Row 28</strong> P.</p>
<p class="nonindent"><strong>Row 29</strong> <strong>C</strong> [skpo, k7, k2tog] 4 times, k1.</p>
<p class="nonindent"><strong>Row 30</strong> P.</p>
<p class="nonindent"><strong>Row 31</strong> [skpo, k5, k2tog] 4 times, k1.</p>
<p class="nonindent"><strong>Row 32</strong> P.</p>
<p class="nonindent"><strong>Row 33</strong> [kfb, k1] rep to last st, kfb. 44 sts.</p>
<p class="nonindent"><strong>Row 34</strong> P.</p>
<p class="nonindent"><strong>Row 35</strong> K.</p>
<p class="nonindent"><strong>Row 36</strong> P.</p>
<p class="nonindent"><strong>Row 37</strong> <strong>D</strong> k18, <strong>C</strong> k8, <strong>D</strong> k18.</p>
<p class="nonindent"><strong>Row 38</strong> <strong>D</strong> p17, <strong>C</strong> p10, <strong>D</strong> k17.</p>
<p class="nonindent"><strong>Row 39</strong> <strong>D</strong> k16, <strong>C</strong> k12, <strong>D</strong> k16.</p>
<p class="nonindent"><strong>Row 40</strong> <strong>D</strong> p15, <strong>C</strong> p14, <strong>D</strong> p15.</p>
<p class="nonindent"><strong>Row 41</strong> <strong>D</strong> kfb, k13, <strong>C</strong> k7, kfb, kfb, k7, <strong>D</strong> k13, kfb.</p>
<p class="nonindent"><strong>Row 42</strong> <strong>D</strong> p14, <strong>C</strong> p20, <strong>D</strong> p14.</p>
<p class="nonindent"><strong>Row 43</strong> <strong>D</strong> k13, <strong>C</strong> k22, <strong>D</strong> k13.</p>
<p class="nonindent"><strong>Row 44</strong> <strong>D</strong> p12, <strong>C</strong> p24, <strong>D</strong> p12.</p>
<p class="nonindent"><strong>Row 45</strong> <strong>D</strong> kfb, k10, <strong>C</strong> k12, kfb, kfb, k12, <strong>D</strong> k10, kfb.</p>
<p class="nonindent"><strong>Row 46</strong> <strong>D</strong> p12, <strong>C</strong> p28, <strong>D</strong> p12.</p>
<p class="nonindent"><strong>Row 47</strong> <strong>D</strong> k12, <strong>C</strong> k28, <strong>D</strong> k12.</p>
<p class="nonindent">Rep rows 46 and 47 5 more times.</p>
<p class="nonindent"><strong>Row 58</strong> <strong>D</strong> p12, <strong>C</strong> p28, <strong>D</strong> p12.</p>
<p class="nonindent"><strong>Row 59</strong> <strong>D</strong> k13, <strong>C</strong> k26, <strong>D</strong> k13.</p>
<p class="nonindent"><strong>Row 60</strong> <strong>D</strong> p14, <strong>C</strong> p24, <strong>D</strong> p14.</p>
<p class="nonindent"><strong>Row 61</strong> <strong>D</strong> k15, <strong>C</strong> k22, <strong>D</strong> k15.</p>
<p class="nonindent"><strong>Row 62</strong> <strong>D</strong> p16, <strong>C</strong> p20, <strong>D</strong> p16.</p>
<p class="nonindent"><strong>Row 63</strong> <strong>D</strong> k17, <strong>C</strong> k18, <strong>D</strong> k17.</p>
<p class="nonindent"><strong>Row 64</strong> <strong>D</strong> p18, <strong>C</strong> p16, <strong>D</strong> p18.</p>
<p class="nonindent"><strong>Row 65</strong> <strong>D</strong> k19, <strong>C</strong> k14, <strong>D</strong> k19.</p>
<p class="nonindent"><strong>Row 66</strong> <strong>D</strong> p20, <strong>C</strong> p12, <strong>D</strong> p20.</p>
<p class="nonindent"><strong>Row 67</strong> <strong>D</strong> k21, <strong>C</strong> k10, <strong>D</strong> k21.</p>
<p class="nonindent"><strong>Row 68</strong> <strong>D</strong> p22, <strong>C</strong> p8, <strong>D</strong> p22.</p>
<p class="nonindent"><strong>Row 69</strong> <strong>D</strong> k.</p>
<p class="nonindent"><strong>Row 70</strong> P.</p>
<p class="nonindent"><strong>Row 71</strong> K.</p>
<p class="nonindent"><strong>Row 72</strong> K.</p>
<p class="nonindent"><strong>Row 73</strong> K.</p>
<p class="nonindent"><strong>Row 74</strong> K.</p>
<p class="nonindent">Bind off.</p>
<h2 class="section">Medium babushka pattern</h2>
<p class="nonindent">Cast on 5 sts using <strong>yarn A</strong> and size 6 (4mm) knitting needles.</p>
<p class="nonindent"><strong>Row 1</strong> [kfb] 4 times, k1.</p>
<p class="nonindent"><strong>Row 2</strong> P.</p>
<p class="nonindent"><strong>Row 3</strong> [kfb, k1] 4 times, k1.</p>
<p class="nonindent"><strong>Row 4</strong> P.</p>
<p class="nonindent"><strong>Row 5</strong> [kfb, k1, kfb] 4 times, k1.</p>
<p class="nonindent"><strong>Row 6</strong> P.</p>
<p class="nonindent"><strong>Row 7</strong> [kfb, k3, kfb] 4 times, k1. 29 sts.</p>
<p class="nonindent"><strong>Row 8</strong> P.</p>
<p class="nonindent">Beg the colour changes.</p>
<p class="nonindent"><strong>Row 9</strong> <strong>A</strong> k10, <strong>B</strong> k9, <strong>A</strong> k10.</p>
<p class="nonindent"><strong>Row 10</strong> <strong>A</strong> p9, <strong>B</strong> p11, <strong>A</strong> p9.</p>
<p class="nonindent"><strong>Row 11</strong> <strong>A</strong> k8, <strong>B</strong> k13, <strong>A</strong> k8.</p>
<p class="nonindent"><strong>Row 12</strong> <strong>A</strong> p8, <strong>B</strong> p13, <strong>A</strong> p8.</p>
<p class="nonindent">Rep rows 11 and 12 3 more times.</p>
<p class="nonindent"><strong>Row 19</strong> <strong>A</strong> k9, <strong>B</strong> k11, <strong>A</strong> k9.</p>
<p class="nonindent"><strong>Row 20</strong> <strong>A</strong> p10, <strong>B</strong> p9, <strong>A</strong> p10.</p>
<p class="nonindent"><strong>Row 21</strong> <strong>A</strong> k11, <strong>B</strong> k7, <strong>A</strong> k11.</p>
<p class="nonindent"><strong>Row 22</strong> <strong>A</strong> p.</p>
<p class="nonindent"><strong>Row 23</strong> [skpo, k3, k2tog] 4 times, k1.</p>
<p class="nonindent"><strong>Row 24</strong> P.</p>
<p class="nonindent"><strong>Row 25</strong> <strong>C</strong> [k1, kfb] rep to last st, k1. 31 sts.</p>
<p class="nonindent"><strong>Row 26</strong> P.</p>
<p class="nonindent"><strong>Row 27</strong> K.</p>
<p class="nonindent"><strong>Row 28</strong> P.</p>
<p class="nonindent"><strong>Row 29</strong> <strong>D</strong> k13, <strong>C</strong> k5, <strong>D</strong> k13.</p>
<p class="nonindent"><strong>Row 30</strong> <strong>D</strong> p12, <strong>C</strong> p7, <strong>D</strong> p12.</p>
<p class="nonindent"><strong>Row 31</strong> <strong>D</strong> kfb, k10, <strong>C</strong> k3, kfb, kfb, k4, <strong>D</strong> k10, kfb.</p>
<p class="nonindent"><strong>Row 32</strong> <strong>D</strong> p11, <strong>C</strong> p13, <strong>D</strong> p11.</p>
<p class="nonindent"><strong>Row 33</strong> <strong>D</strong> k10, <strong>C</strong> k15, <strong>D</strong> k10.</p>
<p class="nonindent"><strong>Row 34</strong> <strong>D</strong> p9, <strong>C</strong> p17, <strong>D</strong> p9.</p>
<p class="nonindent"><strong>Row 35</strong> <strong>D</strong> kfb, k8, <strong>C</strong> k7, kfb, kfb, k8, <strong>D</strong> k8, kfb.</p>
<p class="nonindent"><strong>Row 36</strong> <strong>D</strong> p10, <strong>C</strong> p19, <strong>D</strong> p10.</p>
<p class="nonindent"><strong>Row 37</strong> <strong>D</strong> k10, <strong>C</strong> k19, <strong>D</strong> k10.</p>
<p class="nonindent">Rep row 36 and 37 3 more times.</p>
<p class="nonindent"><strong>Row 44</strong> <strong>D</strong> p10, <strong>C</strong> p19, <strong>D</strong> p10.</p>
<p class="nonindent"><strong>Row 45</strong> <strong>D</strong> k11, <strong>C</strong> k17, <strong>D</strong> k11.</p>
<p class="nonindent"><strong>Row 46</strong> <strong>D</strong> p12, <strong>C</strong> p15, <strong>D</strong> p12.</p>
<p class="nonindent"><strong>Row 47</strong> <strong>D</strong> k13, <strong>C</strong> k13, <strong>D</strong> k13.</p>
<p class="nonindent"><strong>Row 48</strong> <strong>D</strong> p14, <strong>C</strong> p11, <strong>D</strong> p14.</p>
<p class="nonindent"><strong>Row 49</strong> <strong>D</strong> k15, <strong>C</strong> k9, <strong>D</strong> k15.</p>
<p class="center"><img alt="" src="OEBPS/images/32-1.jpg"/></p>
<p class="caption">Olga and Nadia are happy little dolls...</p>
<p class="nonindent"><strong>Row 50</strong> <strong>D</strong> p16, <strong>C</strong> p7, <strong>D</strong> p16.</p>
<p class="nonindent"><strong>Row 51</strong> <strong>D</strong> k.</p>
<p class="nonindent"><strong>Row 52</strong> P.</p>
<p class="nonindent"><strong>Row 53</strong> K.</p>
<p class="nonindent"><strong>Row 54</strong> K.</p>
<p class="nonindent"><strong>Row 55</strong> K.</p>
<p class="nonindent"><strong>Row 56</strong> K.</p>
<p class="nonindent">Bind off.</p>
<p class="center"><img alt="" src="OEBPS/images/33-1.jpg"/></p>
<h2 class="section">Small babushka pattern</h2>
<p class="nonindent">Cast on 5 sts using <strong>yarn A</strong> and size 6 (4mm) knitting needles.</p>
<p class="nonindent"><strong>Row 1</strong> [kfb] 4 times, k1. 9 sts.</p>
<p class="nonindent"><strong>Row 2</strong> P.</p>
<p class="nonindent"><strong>Row 3</strong> [kfb, k1, kfb] 3 times. 15 sts.</p>
<p class="nonindent"><strong>Row 4</strong> P.</p>
<p class="nonindent">Beg the colour changes.</p>
<p class="nonindent"><strong>Row 5</strong> <strong>A</strong> k6, <strong>B</strong> k3, <strong>A</strong> k6.</p>
<p class="nonindent"><strong>Row 6</strong> <strong>A</strong> p5, <strong>B</strong> p5, <strong>A</strong> p5.</p>
<p class="nonindent"><strong>Row 7</strong> <strong>A</strong> k4, <strong>B</strong> k7, <strong>A</strong> k4.</p>
<p class="nonindent"><strong>Row 8</strong> <strong>A</strong> p4, <strong>B</strong> p7, <strong>A</strong> p4.</p>
<p class="nonindent"><strong>Row 9</strong> <strong>A</strong> k4, <strong>B</strong> k7, <strong>A</strong> k4.</p>
<p class="nonindent"><strong>Row 10</strong> <strong>A</strong> p5, <strong>B</strong> p5, <strong>A</strong> p5.</p>
<p class="nonindent"><strong>Row 11</strong> <strong>A</strong> k6, <strong>B</strong> k3, <strong>A</strong> k6.</p>
<p class="nonindent"><strong>Row 12</strong> <strong>A</strong> p.</p>
<p class="nonindent"><strong>Row 13</strong> <strong>C</strong> k1, [kfb, k2] 4 times, kfb, k1.</p>
<p class="nonindent"><strong>Row 14</strong> P.</p>
<p class="nonindent"><strong>Row 15</strong> <strong>D</strong> k8, <strong>C</strong> k4, <strong>D</strong> k8.</p>
<p class="nonindent"><strong>Row 16</strong> <strong>D</strong> p7, <strong>C</strong> p6, <strong>D</strong> p7.</p>
<p class="nonindent"><strong>Row 17</strong> <strong>D</strong> k6, <strong>C</strong> k8, <strong>D</strong> k6.</p>
<p class="nonindent"><strong>Row 18</strong> <strong>D</strong> p5, <strong>C</strong> p10, <strong>D</strong> p5.</p>
<p class="nonindent"><strong>Row 19</strong> <strong>D</strong> kfb, k4, <strong>C</strong> k4, kfb, k5 <strong>D</strong> k4, kfb.</p>
<p class="nonindent"><strong>Row 20</strong> <strong>D</strong> p6, <strong>C</strong> p11, <strong>D</strong> p6.</p>
<p class="nonindent"><strong>Row 21</strong> <strong>D</strong> k6, <strong>C</strong> k11, <strong>D</strong> k6.</p>
<p class="nonindent"><strong>Row 22</strong> <strong>D</strong> p6, <strong>C</strong> p11, <strong>D</strong> p6.</p>
<p class="nonindent"><strong>Row 23</strong> <strong>D</strong> k6, <strong>C</strong> k11, <strong>D</strong> k6.</p>
<p class="nonindent"><strong>Row 24</strong> <strong>D</strong> p6, <strong>C</strong> p11, <strong>D</strong> p6.</p>
<p class="nonindent"><strong>Row 25</strong> <strong>D</strong> k7, <strong>C</strong> k9, <strong>D</strong> k7.</p>
<p class="nonindent"><strong>Row 26</strong> <strong>D</strong> p8, <strong>C</strong> p7, <strong>D</strong> p8.</p>
<p class="nonindent"><strong>Row 27</strong> <strong>D</strong> k9, <strong>C</strong> k5, <strong>D</strong> k9.</p>
<p class="nonindent"><strong>Row 28</strong> <strong>D</strong> p10, <strong>C</strong> p3, <strong>D</strong> p10.</p>
<p class="nonindent"><strong>Row 29</strong> <strong>D</strong> k.</p>
<p class="nonindent"><strong>Row 30</strong> P.</p>
<p class="nonindent"><strong>Row 31</strong> P.</p>
<p class="nonindent"><strong>Row 32</strong> P.</p>
<p class="nonindent">Bind off.</p>
<p class="center"><img alt="" src="OEBPS/images/33-2.jpg"/></p>
<p class="center"><img alt="" src="OEBPS/images/34-1.jpg"/></p>
<p class="center"><img alt="" src="OEBPS/images/34-2.jpg"/></p>
<h2 class="section"><strong>MAKING UP</strong></h2>
<p class="nonindent">Before sewing up the back of the body it is easier to embroider all the details.</p>
<p class="extract">Face</p>
<p class="nonindent">Using brown yarn, embroider round the edge of the babushka’s pink face.</p>
<p class="nonindent">Embroider hair, eyes and nose onto the face using the same brown yarn.</p>
<p class="nonindent">Embroider a few little stitches using red yarn for the mouth and add a few more round the top of the babushka’s neck.</p>
<p class="extract">Body</p>
<p class="nonindent">For the large and medium babushkas, cut out the petals, leaves and flowers from red and green felt (see p. 119 for templates).</p>
<p class="nonindent">Sew these in place (see pp. 112–113).</p>
<p class="nonindent">Add yarn details if desired.</p>
<p class="nonindent">Sew the babushkas down the back of their bodies. Leave the bottom open.</p>
<p class="nonindent">Cut a strip of red felt and tie it in a neat bow at the front of each babushka’s neck.</p>
<p class="nonindent">Neatly sew the bow to the neck.</p>
<p class="extract">Lining</p>
<p class="nonindent">Place each babushka on to double-thickness lining material. It is best to use T-shirt-type material as it has a bit of stretch.</p>
<p class="nonindent">Draw round the edge of each babushka, 3/16in (5mm) bigger than the doll.</p>
<p class="nonindent">Sew round the sides of this fabric, leaving the bottom open. Slip the fabric inside the babushka and neatly sew to the base of the doll. This lining enables you to fit one babushka inside the other, just like real Russian dolls.</p>
<p class="center"><img alt="" src="OEBPS/images/34-3.jpg"/></p>
<p class="center"><img alt="" src="OEBPS/images/35-1.jpg"/></p>
<p class="center"><img alt="" src="OEBPS/images/36-1.jpg"/></p>
<p class="pagebreak"> </p>
<h1 class="section" id="sec5">Three Hungry Bears</h1>
<p class="center">Rating <img alt="" src="OEBPS/images/11-2.jpg"/><img alt="" src="OEBPS/images/11-2.jpg"/></p>
<p class="center"><strong><em>A touch of shaping makes the bears easier to sew up</em></strong></p>
<p class="center">Teddy bears love having breakfast parties, and the more bears you knit, the bigger the party will be! They like to have lots of different food at breakfast time, but don’t forget to make plenty of porridge just in case Goldilocks comes to visit.</p>
<p class="center">Knit these bears in the softest alpaca yarn you can find. Whether you’re making the bears for small or big children, the luxurious feel of the yarn will offer warmth and comfort with every cuddle.</p>
<div class="box">
<p class="nonindent"><strong>yarn</strong></p>
<p class="nonindent">Lightweight (DK) 100% alpaca</p>
<p class="nonindent">Mummy bear – 1 x 13/4oz (50g) ball in light brown (<strong>A</strong>)</p>
<p class="nonindent">Daddy bear – 2 x 13/4oz (50g) balls in cream (<strong>B</strong>)</p>
<p class="nonindent">Baby bear – 1 x 13/4oz (50g) ball in grey-blue (<strong>C</strong>)</p>
<br/>
<p class="nonindent"><strong>needles</strong></p>
<p class="nonindent">Size 6 (4mm) knitting needles</p>
<br/>
<p class="nonindent"><strong>gauge</strong></p>
<p class="nonindent">22 sts and 30 rows to 4in (10cm)</p>
<p class="nonindent"><em>Don’t worry if the tension is not exact – it doesn’t matter if the bears are a little bigger or smaller than shown</em></p>
<br/>
<p class="nonindent"><strong>finished sizes</strong></p>
<p class="nonindent">Mummy bear – approx. 12in (30cm) tall</p>
<p class="nonindent">Daddy bear – approx. 14in (35cm) tall</p>
<p class="nonindent">Baby bear – approx. 9in (23cm) tall</p>
</div>
<p class="center"><img alt="" src="OEBPS/images/37-1.jpg"/></p>
<p class="center"><img alt="" src="OEBPS/images/38-1.jpg"/></p>
<p class="nonindent">Daddy bear likes honey,</p>
<p class="nonindent">Mummy bear likes porridge,</p>
<p class="nonindent">Baby bear loves eggs with jelly,</p>
<p class="nonindent">which must taste rather funny.</p>
<div class="block">
<p class="extract"><strong>KNITTING NOTES</strong></p>
<p class="nonindent">Each component of the teddies is knitted separately and assembled at the end.</p>
</div>
<p class="center"><img alt="" src="OEBPS/images/39-1.jpg"/></p>
<h2 class="section">Mummy bear pattern</h2>
<p class="nonindent">HEAD</p>
<p class="nonindent">Cast on 7 sts using <strong>yarn A</strong> and size 6 (4mm) knitting needles.</p>
<p class="nonindent"><strong>Row 1</strong> P.</p>
<p class="nonindent"><strong>Row 2</strong> Kfb to end of row. 14 sts.</p>
<p class="nonindent"><strong>Row 3</strong> P.</p>
<p class="nonindent"><strong>Row 4</strong> Kfb to end of row. 28 sts.</p>
<p class="nonindent"><strong>Row 5</strong> P.</p>
<p class="nonindent"><strong>Row 6</strong> Kfb to end of row. 56 sts.</p>
<p class="nonindent"><strong>Row 7</strong> P.</p>
<p class="nonindent">Work 16 rows in st st.</p>
<p class="nonindent"><strong>Row 24</strong> [k2tog, k10, skpo] 4 times.</p>
<p class="nonindent"><strong>Row 25</strong> P.</p>
<p class="nonindent"><strong>Row 26</strong> [k2tog, k8, skpo] 4 times.</p>
<p class="nonindent"><strong>Row 27</strong> P.</p>
<p class="nonindent"><strong>Row 28</strong> [k2tog, k6, skpo] 4 times.</p>
<p class="nonindent"><strong>Row 29</strong> P.</p>
<p class="nonindent"><strong>Row 30</strong> [k2tog, k4, skpo] 4 times.</p>
<p class="nonindent"><strong>Row 31</strong> P.</p>
<p class="nonindent"><strong>Row 32</strong> [k2tog, k2, skpo] 4 times.</p>
<p class="nonindent"><strong>Row 33</strong> P.</p>
<p class="nonindent"><strong>Row 34</strong> [k2tog, skpo] 4 times.</p>
<p class="nonindent">Thread yarn through rem sts and pull together.</p>
<br/>
<p class="nonindent">NOSE</p>
<p class="nonindent">Cast on 30 sts using <strong>yarn A</strong> and size 6 (4mm) knitting needles.</p>
<p class="nonindent">Work 6 rows in st st.</p>
<p class="nonindent"><strong>Row 7</strong> [k1, k2tog] rep to end of row.</p>
<p class="nonindent"><strong>Row 8</strong> P.</p>
<p class="nonindent"><strong>Row 9</strong> [k2tog] rep to end of row.</p>
<p class="nonindent">Thread yarn through rem sts and pull together.</p>
<br/>
<p class="nonindent">BODY</p>
<p class="nonindent">Cast on 8 sts using <strong>yarn A</strong> and size 6 (4mm) knitting needles.</p>
<p class="nonindent"><strong>Row 1</strong> P.</p>
<p class="nonindent"><strong>Row 2</strong> Kfb to end of row. 16 sts.</p>
<p class="nonindent"><strong>Row 3</strong> P.</p>
<p class="nonindent"><strong>Row 4</strong> Kfb to end of row. 32 sts.</p>
<p class="nonindent"><strong>Row 5</strong> P.</p>
<p class="nonindent"><strong>Row 6</strong> Kfb to end of row. 64 sts.</p>
<p class="nonindent"><strong>Row 7</strong> P.</p>
<p class="nonindent">Work 20 rows in st st.</p>
<p class="nonindent"><strong>Row 28</strong> [k2tog, k12, skpo] 4 times.</p>
<p class="nonindent"><strong>Row 29</strong> P.</p>
<p class="nonindent"><strong>Row 30</strong> [k2tog, k10, skpo] 4 times.</p>
<p class="nonindent"><strong>Row 31</strong> P.</p>
<p class="nonindent"><strong>Row 32</strong> [k2tog, k8, skpo] 4 times.</p>
<p class="nonindent"><strong>Row 33</strong> P.</p>
<p class="nonindent"><strong>Row 34</strong> [k2tog, k6, skpo] 4 times.</p>
<p class="nonindent"><strong>Row 35</strong> P.</p>
<p class="nonindent"><strong>Row 36</strong> [k2tog, k4, skpo] 4 times.</p>
<p class="nonindent"><strong>Row 37</strong> P.</p>
<p class="nonindent"><strong>Row 38</strong> [k2tog, k2, skpo] 4 times.</p>
<p class="nonindent"><strong>Row 39</strong> P.</p>
<p class="nonindent"><strong>Row 40</strong> [k2tog, skpo] 4 times.</p>
<p class="nonindent">Thread yarn through rem sts and pull together.</p>
<p class="nonindent">LEGS (MAKE 2)</p>
<p class="nonindent">Cast on 25 sts using <strong>yarn A</strong> and size 6 (4mm) knitting needles.</p>
<p class="nonindent">Work 20 rows in st st.</p>
<p class="nonindent">Row 21 K11, kfb, kfb, k12.</p>
<p class="nonindent">Row 22 P.</p>
<p class="nonindent">Row 23 K12, kfb, kfb, k13.</p>
<p class="nonindent">Row 24 P.</p>
<p class="nonindent">Row 25 K13, kfb, kfb, k14.</p>
<p class="nonindent">Row 26 P.</p>
<p class="nonindent">Row 27 K14, kfb, kfb, k15.</p>
<p class="nonindent">Row 28 P.</p>
<p class="nonindent">Row 29 K15, kfb, kfb, k16.</p>
<p class="nonindent">Row 30 P.</p>
<p class="nonindent">Row 31 K2tog, k31, k2tog.</p>
<p class="nonindent">Row 32 P.</p>
<p class="nonindent">Row 33 [k2tog, k1] rep to end.</p>
<p class="nonindent">Row 34 P.</p>
<p class="nonindent">Row 35 [k2tog] rep to end. 11 sts.</p>
<p class="nonindent">Thread yarn through rem sts and pull together.</p>
<br/>
<p class="nonindent">ARMS (MAKE 2)</p>
<p class="nonindent">Cast on 10 sts using <strong>yarn A</strong> and size 6 (4mm) knitting needles.</p>
<p class="nonindent">Row 1 Kfb, k8, kfb.</p>
<p class="nonindent">Row 2 P.</p>
<p class="nonindent">Row 3 Kfb, k10, kfb.</p>
<p class="nonindent">Row 4 P.</p>
<p class="nonindent">Cont in this way until 24 sts on needle.</p>
<p class="nonindent">Row 15 K.</p>
<p class="nonindent">Row 16 P.</p>
<p class="nonindent">Work 18 rows in st st.</p>
<p class="nonindent">Row 35 [k2tog, k1] rep to end.</p>
<p class="nonindent">Row 36 P.</p>
<p class="nonindent">Row 37 K2tog, rep to end.</p>
<p class="nonindent">Row 38 P.</p>
<p class="nonindent">Thread yarn through rem sts and pull together.</p>
<br/>
<p class="nonindent">EARS (MAKE 2)</p>
<p class="nonindent">Cast on 26 sts using <strong>yarn A</strong> and size 6 (4mm) knitting needles.</p>
<p class="nonindent">Work 5 rows in st st.</p>
<p class="nonindent">Row 6 [p2 tog, p1] rep to last 2 sts, p2tog.</p>
<p class="nonindent">Row 7 K.</p>
<p class="nonindent">Row 8 [p2tog] rep to last st. P1.</p>
<p class="nonindent">Thread yarn through rem sts.</p>
<p class="center"><img alt="" src="OEBPS/images/40-1.jpg"/></p>
<h2 class="section">Daddy bear pattern</h2>
<p class="nonindent">HEAD</p>
<p class="nonindent">Refer to the pattern for Mummy bear’s body<br/>(see p. 38) but use <strong>yarn B</strong>.</p>
<br/>
<p class="nonindent">NOSE</p>
<p class="nonindent">Cast on 36 sts using <strong>yarn B</strong> and size 6 (4mm) knitting needles.</p>
<p class="nonindent">Work 6 rows in st st.</p>
<p class="nonindent">Row 7 [k1, k2tog] rep to end of row.</p>
<p class="nonindent">Row 8 P.</p>
<p class="nonindent">Row 9 [k2tog] rep to end of row.</p>
<p class="nonindent">Row 10 P.</p>
<p class="nonindent">Thread yarn through rem sts and pull together.</p>
<br/>
<p class="center"><img alt="" src="OEBPS/images/40-1.jpg"/></p>
<p class="nonindent">BODY</p>
<p class="nonindent">Cast on 9 sts using <strong>yarn B</strong> and size 6 (4mm) knitting needles.</p>
<p class="nonindent">Row 1 P.</p>
<p class="nonindent">Row 2 Kfb to end of row. 18 sts.</p>
<p class="nonindent">Row 3 P.</p>
<p class="nonindent">Row 4 Kfb to end of row. 36 sts.</p>
<p class="nonindent">Row 5 P.</p>
<p class="nonindent">Row 6 Kfb to end of row. 72 sts.</p>
<p class="nonindent">Row 7 P.</p>
<p class="nonindent">Work 20 rows in st st.</p>
<p class="nonindent">Row 28 [k2tog, k14, skpo] 4 times.</p>
<p class="nonindent">Row 29 P.</p>
<p class="nonindent">Row 30 [k2tog, k12, skpo] 4 times.</p>
<p class="nonindent">Row 31 P.</p>
<p class="nonindent">Row 32 [k2tog, k10, skpo] 4 times.</p>
<p class="nonindent">Row 33 P.</p>
<p class="nonindent">Row 34 [k2tog, k8, skpo] 4 times.</p>
<p class="nonindent">Row 35 P.</p>
<p class="nonindent">Row 36 [k2tog, k6, skpo] 4 times.</p>
<p class="nonindent">Row 37 P.</p>
<p class="nonindent">Row 38 [k2tog, k4, skpo] 4 times.</p>
<p class="nonindent">Row 39 P.</p>
<p class="nonindent">Row 40 [k2tog, k2, skpo] 4 times.</p>
<p class="nonindent">Thread yarn through rem sts and pull together.</p>
<br/>
<p class="nonindent">LEGS (MAKE 2)</p>
<p class="nonindent">Cast on 29 sts using <strong>yarn B</strong> and size 6 (4mm) knitting needles.</p>
<p class="nonindent">Work 24 rows in st st.</p>
<p class="nonindent">Row 25 K13, kfb, kfb, k14.</p>
<p class="nonindent">Row 26 P.</p>
<p class="nonindent">Row 27 K14, kfb, kfb, k15.</p>
<p class="nonindent">Row 28 P.</p>
<p class="nonindent">Row 29 K15, kfb, kfb, k16.</p>
<p class="nonindent">Row 30 P.</p>
<p class="nonindent">Row 31 K16, kfb, kfb, k17.</p>
<p class="nonindent">Row 32 P.</p>
<p class="nonindent">Row 33 K17, kfb, kfb, k18.</p>
<p class="nonindent">Row 34 P2 tog, p35, p2tog.</p>
<p class="nonindent">Row 35 [k1, k2tog] rep to last st, k1.</p>
<p class="nonindent">Row 36 P.</p>
<p class="center"><img alt="" src="OEBPS/images/41-1.jpg"/></p>
<p class="nonindent">Row 37 [k2tog] rep to last st, k1.</p>
<p class="nonindent">Thread yarn through rem sts and pull together.</p>
<br/>
<p class="nonindent">ARMS (MAKE 2)</p>
<p class="nonindent">Cast on 12 sts using <strong>yarn B</strong> and size 6 (4mm) knitting needles.</p>
<p class="nonindent">Row 1 Kfb, k10, kfb. 14 sts.</p>
<p class="nonindent">Row 2 P.</p>
<p class="nonindent">Row 3 Kfb, k12, kfb. 16 sts.</p>
<p class="nonindent">Row 4 P.</p>
<p class="nonindent">Cont in this way until 26 sts on needle.</p>
<p class="nonindent">Work 24 rows in st st.</p>
<p class="nonindent">Row 39 [k2tog, k1] rep to last 2 sts, k2tog.</p>
<p class="nonindent">Row 40 P.</p>
<p class="nonindent">Row 41 [k2tog] rep to last st, k1.</p>
<p class="nonindent">Thread yarn through rem sts and pull together.</p>
<br/>
<p class="nonindent">EARS (MAKE 2)</p>
<p class="nonindent">Cast on 28 sts using <strong>yarn B</strong> and size 6 (4mm) knitting needles.</p>
<p class="nonindent">Work 5 rows in st st.</p>
<p class="nonindent">Row 6 [p2tog, p1] rep to last st, p1.</p>
<p class="nonindent">Row 7 K.</p>
<p class="nonindent">Row 8 [p2tog] rep to last st, p1.</p>
<p class="nonindent">Thread yarn through rem sts.</p>
<h2 class="section">Baby bear pattern</h2>
<p class="nonindent">HEAD</p>
<p class="nonindent">Cast on 6 sts using <strong>yarn C</strong> and size 6 (4mm) knitting needles.</p>
<p class="nonindent"><strong>Row 1</strong> P.</p>
<p class="nonindent">Row 2 Kfb to end of row. 12 sts.</p>
<p class="nonindent">Row 3 P.</p>
<p class="nonindent">Row 4 Kfb to end of row. 24 sts.</p>
<p class="nonindent">Row 5 P.</p>
<p class="nonindent">Row 6 Kfb to end of row. 48 sts.</p>
<p class="nonindent">Row 7 P.</p>
<p class="nonindent">Work 12 rows in st st.</p>
<p class="nonindent">Row 20 [k2tog, k8, skpo] 4 times.</p>
<p class="nonindent">Row 21 P.</p>
<p class="nonindent">Row 22 [k2tog, k6, skpo] 4 times.</p>
<p class="nonindent">Row 23 P.</p>
<p class="nonindent">Row 24 [k2tog, k4, skpo] 4 times.</p>
<p class="nonindent">Row 25 P.</p>
<p class="nonindent">Row 26 [k2tog, k2, skpo] 4 times.</p>
<p class="nonindent">Row 27 P.</p>
<p class="nonindent">Row 28 [k2tog, skpo] 4 times.</p>
<p class="nonindent">Thread yarn through rem sts and pull together.</p>
<br/>
<p class="nonindent">NOSE</p>
<p class="nonindent">Cast on 24 sts using <strong>yarn C</strong> and size 6 (4mm) knitting needles.</p>
<p class="nonindent">Work 4 rows in st st.</p>
<p class="nonindent">Row 5 [k1, k2tog] rep to end of row.</p>
<p class="nonindent">Row 6 P.</p>
<p class="nonindent">Row 7 [k2tog] rep to end of row.</p>
<p class="nonindent">Thread yarn through sts and pull together.</p>
<br/>
<p class="nonindent">BODY</p>
<p class="nonindent">Refer to the pattern for Mummy bear’s head (see p. 38) but using <strong>yarn C</strong>.</p>
<br/>
<p class="nonindent">LEGS (MAKE 2)</p>
<p class="nonindent">Cast on 19 sts using <strong>yarn C</strong> and size 6 (4mm) knitting needles.</p>
<p class="nonindent">Work 14 rows in st st.</p>
<p class="nonindent">Row 15 K8, kfb, kfb, k9.</p>
<p class="nonindent">Row 16 P.</p>
<p class="nonindent">Row 17 K9, kfb, kfb, k10.</p>
<p class="nonindent">Row 18 P.</p>
<p class="nonindent">Row 19 K10, kfb, kfb, k11.</p>
<p class="nonindent">Row 20 P.</p>
<p class="nonindent">Row 21 K2tog, k21, k2tog.</p>
<p class="nonindent">Row 22 P.</p>
<p class="nonindent">Row 23 [k2tog, k1] rep to last 2 sts, k2tog.</p>
<p class="nonindent">Row 24 P.</p>
<p class="nonindent">Row 25 [k2tog] rep to last st, k1.</p>
<p class="nonindent">Thread yarn through rem sts and pull together.</p>
<br/>
<p class="nonindent">ARMS (MAKE 2)</p>
<p class="nonindent">Cast on 8 sts using <strong>yarn C</strong> and size 6 (4mm) knitting needles.</p>
<p class="nonindent">Row 1 Kfb, k6, kfb.</p>
<p class="nonindent">Row 2 P.</p>
<p class="nonindent">Row 3 Kfb, k8, kfb.</p>
<p class="nonindent">Row 4 P.</p>
<p class="nonindent">Cont in this way until 18 sts on needle.</p>
<p class="nonindent">Row 11 K.</p>
<p class="nonindent">Row 12 P.</p>
<p class="nonindent">Work 14 rows in st st.</p>
<p class="nonindent">Row 27 [k2tog, k1] rep to end.</p>
<p class="nonindent">Row 28 P.</p>
<p class="nonindent">Row 29 [k2tog] rep to end.</p>
<p class="nonindent">Thread yarn through rem sts and pull together.</p>
<br/>
<p class="nonindent">EARS (MAKE 2)</p>
<p class="nonindent">Cast on 20 sts using <strong>yarn C</strong> and size 6 (4mm) knitting needles.</p>
<p class="nonindent">Work 4 rows in st st.</p>
<p class="nonindent">Row 5 [k2tog, k1] rep to last 2 sts, k2tog.</p>
<p class="nonindent">Row 6 P.</p>
<p class="nonindent">Row 7 [k2tog] rep to last st, k1.</p>
<p class="nonindent">Thread yarn through rem sts.</p>
<h2 class="section"><strong>MAKING UP</strong></h2>
<p class="nonindent">HEAD</p>
<p class="nonindent">Fold the head in half with the knit sides together. Sew from each end of the head, leaving a gap of approx. 11/2in (4cm) in the middle. Turn the right way so that the knit sides are now on the outside. Fill with stuffing and sew up the 11/2in (4cm) gap.</p>
<br/>
<p class="nonindent">NOSE</p>
<p class="nonindent">Fold the nose in half with the knit sides together. Sew up the seam starting from the tip of the nose. Turn the right way so that the knit sides are now on the outside. Loosely fill with stuffing (be careful not to overfill or the nose could look too large). Stitch the nose onto the front of the head.</p>
<br/>
<p class="nonindent">EARS</p>
<p class="nonindent">Fold the ears in half with the knit sides together. Stitch around the sides from the centre of the ear. Turn the right way so that the knit sides are now on the outside. Sew along the bottom straight edge to form a double-sided ear. Stitch the ears to each side of the head using the shaping at the top of the head to position them evenly apart.</p>
<br/>
<p class="nonindent">Body</p>
<p class="nonindent">Fold the body in half with the knit sides together. Sew from each end of the body leaving a gap of approximately 11/2in (4cm) in the middle. Turn the right way so that the knit sides are now on the outside. Fill with stuffing and sew up the 11/2in (4cm) gap.</p>
<p class="center"><img alt="" src="OEBPS/images/42-1.jpg"/></p>
<p class="nonindent">Arms</p>
<p class="nonindent">Fold the arms in half with the knit sides together. Sew from the hand to under the arm. Turn the right way so that the knit sides are on the outside and fill with stuffing. Position the arms to each side of the body and sew, leaving a small gap to insert stuffing for the top of the arm. Sew up the gap.</p>
<br/>
<p class="nonindent">Legs</p>
<p class="nonindent">Fold the legs in half with the knit sides together. Sew from the heel to the top of the leg. Turn the right way so that the knit sides are on the outside and fill with stuffing. Position the legs to the base of the body and sew them on tightly.</p>
<br/>
<p class="nonindent">Finishing touches</p>
<p class="nonindent">Embroider the nose, mouth and eyes using brown yarn. Using the correct size teddy bear templates for the bear you are making (see p. 122), cut out two iron-on interfacing-lined fabric feet pads,<br/>two paw pads and two ear linings. Position them correctly and sew on (see p. 113).</p>
<br/>
<p class="pagebreak"> </p>
<h1 class="section" id="sec6">Polly Dolly’s Dress-up Day</h1>
<p class="center">Rating from <img alt="" src="OEBPS/images/11-2.jpg"/> to <img alt="" src="OEBPS/images/11-2.jpg"/><img alt="" src="OEBPS/images/11-2.jpg"/><img alt="" src="OEBPS/images/11-2.jpg"/></p>
<p class="center"><strong><em>See individual project patterns for more detail</em></strong></p>
<p class="center">Polly Dolly loves dressing up. She is really quite vain and spends a lot of time looking at herself in the mirror. She likes to wear a different dress every day of the week. On Monday she wears a green dress, on Tuesday she wears a blue dress, on Wednesday she wears a purple dress, on Thursday she wears a pink dress, on Friday she wears a yellow dress, and at the weekend she wears her favourite dresses – the red dress on Saturday and the white dress with its little flower on Sunday.</p>
<p class="center">There are various elements to this project. First come the instructions on how to make Polly Dolly herself (pp. 44–47), including her hair. Then there are patterns for her outfits. On pp. 48–49 are the patterns for her red dress with blue stripes, and for her blue shoes. On pp. 50–51 are the instructions to make her white dress. Finally, there are instructions for Polly’s underwear (p.51), which is sewn rather than knitted.</p>
<p class="center"><img alt="" src="OEBPS/images/44-1.jpg"/></p>
<p class="center"><img alt="" src="OEBPS/images/45-1.jpg"/></p>
<h2 class="section">Polly Dolly</h2>
<p class="center">Rating <img alt="" src="OEBPS/images/11-2.jpg"/><img alt="" src="OEBPS/images/11-2.jpg"/><img alt="" src="OEBPS/images/11-2.jpg"/></p>
<p class="center"><strong><em>This is quite an advanced project because of the different components involved <br/>and the importance of getting Polly’s face and hair to look right</em></strong></p>
<p class="center">You start knitting from the top of the doll’s head. The head, shoulders and body are knitted in one piece. The arms are picked up from stitches set aside while making the body. The legs are knitted separately. Take care when adding Polly’s finishing touches, particularly her hair and facial features. Try to make her face look as realistic as you can, and arrange her hair into a pretty style.</p>
<div class="box">
<p class="extract"><strong>yarn</strong></p>
<p class="nonindent">Lightweight (DK) merino wool, microfibre and cashmere mix</p>
<p class="nonindent">1 x 1¾oz (50g) ball in pale pink</p>
<p class="extract"><strong>needles</strong></p>
<p class="nonindent">Size 6 (4mm) knitting needles</p>
<p class="nonindent">2 stitch holders</p>
<p class="extract"><strong>gauge</strong></p>
<p class="nonindent">22 sts and 30 rows to 4in (10cm)</p>
<p class="extract"><strong>finished size</strong></p>
<p class="nonindent">18½in (47cm) from head to toe</p>
</div>
<p class="center"><img alt="" src="OEBPS/images/46-1.jpg"/></p>
<h2 class="section">Polly Dolly pattern</h2>
<p class="extract">HEAD</p>
<p class="nonindent">Cast on 8 sts using size 6 (4mm) knitting needles.</p>
<p class="nonindent"><strong>Row 1</strong> [kfb] 7 times, k1.</p>
<p class="nonindent"><strong>Row 2</strong> P.</p>
<p class="nonindent"><strong>Row 3</strong> [k1, kfb] 7 times, k1. 22 sts.</p>
<p class="nonindent"><strong>Row 4</strong> P.</p>
<p class="nonindent"><strong>Row 5</strong> [k2, kfb] 3 times, k3 [kfb, k2] 2 times, kfb, k3.</p>
<p class="nonindent"><strong>Row 6</strong> P.</p>
<p class="nonindent"><strong>Row 7</strong> K2, kfb, k3, kfb, k3, kfb, k5, kfb, k3, kfb, k3, kfb, k3.</p>
<p class="nonindent"><strong>Row 8</strong> P.</p>
<p class="nonindent"><strong>Row 9</strong> K2, kfb, k4, kfb, k4, kfb, k7, kfb, k4, kfb, k4, kfb, k3. 40 sts.</p>
<p class="nonindent"><strong>Row 1</strong><strong>0</strong> P.</p>
<p class="nonindent">Cont in st st for 18 rows.</p>
<p class="nonindent"><strong>Row 2</strong><strong>9</strong> K2, skpo, k4, skpo, k4, skpo, k7, k2tog, k4, k2tog, k4, k2tog, k3.</p>
<p class="nonindent"><strong>Row 3</strong><strong>0</strong> P.</p>
<p class="nonindent"><strong>Row 3</strong><strong>1</strong> K2, skpo, k3, skpo, k3, skpo, k5, k2tog, k3, k2tog, k3, k2tog, k3.</p>
<p class="nonindent"><strong>Row 3</strong><strong>2</strong> P.</p>
<p class="nonindent"><strong>Row 3</strong><strong>3</strong> K2, skpo, k6, skpo, k3, k2tog, k6, k2tog, <br/>k3. 24 sts.</p>
<p class="nonindent"><strong>Row 3</strong><strong>4</strong> P.</p>
<p class="nonindent"><strong>Row 3</strong><strong>5</strong> K.</p>
<p class="nonindent"><strong>Row 3</strong><strong>6</strong> P.</p>
<p class="nonindent"><strong>Row 3</strong><strong>7</strong> [kfb, k1] 5 times, [kfb] 3 times, [k1, kfb] 5 times, k1. 37 sts.</p>
<p class="nonindent"><strong>Row 3</strong><strong>8</strong> P.</p>
<p class="extract">SHOULDER AND ARMHOLE SHAPING</p>
<p class="nonindent"><strong>Row 3</strong><strong>9</strong> K7, kfb, k1, kfb, k1, kfb, k13, kfb, k1, kfb, k1, kfb, k7.</p>
<p class="nonindent"><strong>Row 4</strong><strong>0</strong> P.</p>
<p class="nonindent"><strong>Row 4</strong><strong>1</strong> K7, [kfb, k1] 4 times, k13, [kfb, k1] 4 times, <br/>k7. 51 sts.</p>
<p class="nonindent"><strong>Row 4</strong><strong>2</strong> P.</p>
<p class="nonindent"><strong>Row 4</strong><strong>3</strong> K.</p>
<p class="nonindent"><strong>Row 4</strong><strong>4</strong> P.</p>
<p class="extract">BODY</p>
<p class="nonindent"><strong>Row 4</strong><strong>5</strong> K7, put next 12 sts (for 1st arm) on a stitch holder, cast 8 sts onto 1st 7 sts, k13, put next 12 sts (for 2nd arm) on a stitch holder, cast on 8 sts to the middle 13 sts, k7.</p>
<p class="nonindent"><strong>Row 4</strong><strong>6</strong> P across 43 sts, leaving arm sts on the stitch holders to be picked up later.</p>
<p class="nonindent"><strong>Row 4</strong><strong>7</strong> K10, kfb, k20, kfb, k11. 45 sts.</p>
<p class="nonindent"><strong>Row 4</strong><strong>8</strong> P.</p>
<p class="nonindent">Cont in st st for 28 rows.</p>
<p class="nonindent"><strong>Row 7</strong><strong>7</strong> [k2tog, k7, skpo] 4 times, k1. 37 sts.</p>
<p class="nonindent"><strong>Row 7</strong><strong>8</strong> P.</p>
<p class="nonindent"><strong>Row 7</strong><strong>9</strong> [k2, k2tog] rep to last st, k1.</p>
<p class="nonindent"><strong>Row 8</strong><strong>0</strong> P.</p>
<p class="nonindent">Bind off loosely.</p>
<p class="center"><img alt="" src="OEBPS/images/47-1.jpg"/></p>
<p class="extract">ARMS (MAKE 2)</p>
<p class="nonindent">Pick up 12 sts from 1st stitch holder.</p>
<p class="nonindent"><strong>Row 1</strong> K.</p>
<p class="nonindent"><strong>Row 2</strong> P.</p>
<p class="nonindent"><strong>Row 3</strong> Kfb, k to last st, kfb.</p>
<p class="nonindent"><strong>Row 4</strong> P.</p>
<p class="nonindent">Cont in st st for 36 rows.</p>
<p class="nonindent"><strong>Row 4</strong><strong>1</strong> [k2, k2tog,] 3 times, k2.</p>
<p class="nonindent"><strong>Row 4</strong><strong>2</strong> P.</p>
<p class="nonindent"><strong>Row 4</strong><strong>3</strong> [k1, k2tog] 3 times, k2.</p>
<p class="nonindent"><strong>Row 4</strong><strong>4</strong> P.</p>
<p class="nonindent"><strong>Row 4</strong><strong>5</strong> [k2tog] 4 times.</p>
<p class="nonindent"><strong>Row 4</strong><strong>6</strong> P.</p>
<p class="nonindent">Thread yarn through rem sts.</p>
<p class="extract">LEGS (MAKE 2)</p>
<p class="nonindent">Cast on 17 sts using size 6 (4mm) knitting needles.</p>
<p class="nonindent">Work in st st for 50 rows.</p>
<p class="nonindent"><strong>Row 5</strong><strong>1</strong> K7, kfb, kfb, k8.</p>
<p class="nonindent"><strong>Row 5</strong><strong>2</strong> P.</p>
<p class="nonindent"><strong>Row 5</strong><strong>3</strong> K8, kfb, kfb, k9.</p>
<p class="nonindent"><strong>Row 5</strong><strong>4</strong> P.</p>
<p class="nonindent"><strong>Row 5</strong><strong>5</strong> K9, kfb, kfb, k10.</p>
<p class="nonindent"><strong>Row 5</strong><strong>6</strong> P.</p>
<p class="center"><img alt="" src="OEBPS/images/48-1.jpg"/></p>
<p class="nonindent"><strong>Row 5</strong><strong>7</strong> K10, kfb, kfb, k11.</p>
<p class="nonindent"><strong>Row 5</strong><strong>8</strong> P.</p>
<p class="nonindent"><strong>Row 5</strong><strong>9</strong> K11, kfb, kfb, k12.</p>
<p class="nonindent"><strong>Row 6</strong><strong>0</strong> P.</p>
<p class="nonindent"><strong>Row 6</strong><strong>1</strong> K2tog, k23, k2tog.</p>
<p class="nonindent"><strong>Row 6</strong><strong>2</strong> P.</p>
<p class="nonindent"><strong>Row 6</strong><strong>3</strong> K2tog, k9, k3tog, k9, k2tog. 21 sts.</p>
<p class="nonindent"><strong>Row 6</strong><strong>4</strong> P.</p>
<p class="nonindent">Bind off.</p>
<p class="center"><img alt="" src="OEBPS/images/48-2.jpg"/></p>
<h2 class="section"><strong>MAKING UP</strong></h2>
<p class="extract">Body</p>
<p class="nonindent">The head, body and arms are knitted all in one piece. Because the arms and legs are thin it is easier not to have to turn the pieces inside out to sew.</p>
<p class="nonindent">Sew along the arms and fill with stuffing.</p>
<p class="nonindent">Sew down the back of the body and head and fill with stuffing, leaving the bottom seam open for the legs.</p>
<p class="extract">Legs</p>
<p class="nonindent">Sew down the back of the legs to the tips of <br/>the toes.</p>
<p class="nonindent">Fill with stuffing.</p>
<p class="nonindent">Sew the legs into the gap left at the bottom of the body with the leg seam at the back.</p>
<p class="extract">Knees</p>
<p class="nonindent">Halfway down the leg, pull up two or three stitches using the pink yarn. Sew the yarn neatly inside the leg so that no yarn is visible.</p>
<p class="extract">Hair</p>
<p class="nonindent">Use two shades of brown yarn for the hair. Wrap the yarn round a large book (the book I used was about 10½in/27cm tall). The bigger the book, the longer the hair. Continue wrapping the yarn around the book until it is approximately 2³/8in (6cm) wide and ³/16–³/8in (5mm–1cm) thick. The more yarn you wrap, the thicker the hair.</p>
<p class="nonindent">Carefully stitch over and under one side of the hair then back again so that every strand of hair is captured in the stitches.</p>
<p class="nonindent">Cut the hair on the other side of the book so <br/>that there is an even amount of hair on each side of <br/>the stitches.</p>
<p class="nonindent">Position the hair at the top of the head with the stitches in the centre. Spread the hair so that it runs down the side and back of Polly’s head.</p>
<p class="nonindent">Sew the hair tightly along the top of her head and round the bottom, back and sides of the head. Every strand of hair needs to be sewn down.</p>
<p class="nonindent">Divide the hair in two and plait each side. Tie the bottom of the plaits with more brown yarn to hold <br/>them in place.</p>
<p class="extract">Facial features</p>
<p class="nonindent">Embroider the eyes using brown or black yarn (as shown in the photograph).</p>
<p class="nonindent">Using the pink yarn, pull up two stitches just below the centre of the eyes and pull tightly (just like the knees, but much smaller). This creates the nose. Sew the pink yarn neatly inside the body so that no thread is visible on the outside.</p>
<p class="nonindent">Using bright pink yarn, make two or three stitches just below the nose. This creates the mouth.</p>
<p class="center"><img alt="" src="OEBPS/images/49-1.jpg"/></p>
<h2 class="section">Polly Dolly’s red dress and blue shoes</h2>
<p class="center">Rating <img alt="" src="OEBPS/images/11-2.jpg"/></p>
<p class="center"><strong><em>Polly Dolly’s red dress and blue shoes are fairly simple to make</em></strong></p>
<p class="center">The red dress is mostly knitted in stockinette stitch, with a few contrast bands in blue and a few textured bands in reverse stockinette stitch to form a waistband and a hem. The blue shoes are worked in garter stitch. You can make any colour dress you like just by altering the yarn from the ones I have suggested. Make lots of different dresses in all shades of colours so Polly Dolly has a new dress to wear every day of the week!</p>
<div class="box">
<p class="extract"><strong>yarn</strong></p>
<p class="nonindent">Lightweight (DK) wool and cotton mix yarn</p>
<p class="nonindent">1 x 1¾oz (50g) ball in red (<strong>A</strong>)</p>
<p class="nonindent">1 x 1¾oz (50g) ball in blue (<strong>B</strong>)</p>
<p class="extract"><strong>needles</strong></p>
<p class="nonindent">Size 6 (4mm) knitting needles</p>
<p class="extract"><strong>gauge</strong></p>
<p class="nonindent">20 sts and 30 rows to 4in (10cm)</p>
<p class="extract"><strong>finished size</strong></p>
<p class="nonindent">8in (20cm) long (not including straps)</p>
</div>
<h2 class="section">Red dress and blue shoes pattern</h2>
<p class="extract">DRESS</p>
<p class="nonindent">Cast on 90 sts using <strong>yarn A</strong> and size 6 (4mm) <br/>knitting needles.</p>
<p class="nonindent"><strong>Row 1</strong> K.</p>
<p class="nonindent"><strong>Row 2</strong> P.</p>
<p class="nonindent"><strong>Row 3</strong> K.</p>
<p class="nonindent"><strong>Row 4</strong> K.</p>
<p class="nonindent"><strong>Row 5</strong> <strong>B</strong> k.</p>
<p class="nonindent"><strong>Row 6</strong> P.</p>
<p class="nonindent"><strong>Row 7</strong> K.</p>
<p class="nonindent"><strong>Row 8</strong> P.</p>
<p class="nonindent"><strong>Row 9</strong> K.</p>
<p class="nonindent"><strong>Row 10</strong> <strong>A</strong> k.</p>
<p class="nonindent">Cont in st st for 24 rows.</p>
<p class="nonindent"><strong>Row 35</strong> [k2tog] rep to end of row. 45 sts.</p>
<p class="nonindent"><strong>Row 36</strong> K.</p>
<p class="nonindent"><strong>Row 37</strong> P.</p>
<p class="nonindent"><strong>Row 38</strong> K.</p>
<p class="nonindent"><strong>Row 39</strong> P.</p>
<p class="nonindent"><strong>Row 40</strong> K.</p>
<p class="nonindent"><strong>Row 41</strong> K.</p>
<p class="nonindent"><strong>Row 42</strong> P.</p>
<p class="nonindent">Cont in st st for 6 rows.</p>
<p class="nonindent"><strong>Row 49</strong> <strong>B</strong> k</p>
<p class="nonindent"><strong>Row 50</strong> P.</p>
<p class="nonindent"><strong>Row 51</strong> <strong>A</strong> k</p>
<p class="nonindent"><strong>Row 52</strong> P.</p>
<p class="nonindent"><strong>Row 53</strong> Bind off 15 sts, k15 (work only on these middle 15 sts).</p>
<p class="nonindent"><strong>Row 54</strong> P.</p>
<p class="nonindent"><strong>Row 55</strong> K.</p>
<p class="nonindent"><strong>Row 56</strong> P.</p>
<p class="nonindent">Bind off middle 15 sts.</p>
<p class="nonindent">Bind off rem 15 sts.</p>
<p class="extract">DRESS STRAPS (MAKE 2)</p>
<p class="nonindent">Cast on 4 sts using <strong>yarn B</strong> and size 6 (4mm) <br/>knitting needles.</p>
<p class="nonindent">Work in st st for 22 rows.</p>
<p class="nonindent">Bind off.</p>
<p class="extract">SHOES (MAKE 2)</p>
<p class="nonindent">Cast on 26 sts using <strong>yarn B</strong> and size 6 (4mm) <br/>knitting needles.</p>
<p class="nonindent">K 6 rows.</p>
<p class="nonindent"><strong>Row 7</strong> K11, skpo, k2tog, k11.</p>
<p class="nonindent"><strong>Row 8</strong> K10, skpo, k2tog, k10.</p>
<p class="nonindent"><strong>Row 9</strong> K9, skpo, k2tog, k9.</p>
<p class="nonindent">Bind off.</p>
<p class="extract">SHOE STRAPS (MAKE 2)</p>
<p class="nonindent">Cast on 3 sts using <strong>yarn B</strong> and size 6 (4mm) <br/>knitting needles.</p>
<p class="nonindent">Work in st st for 22 rows.</p>
<p class="nonindent">Bind off.</p>
<p class="center"><img alt="" src="OEBPS/images/51-1.jpg"/></p>
<h2 class="section"><strong>MAKING UP</strong></h2>
<p class="extract">Dress</p>
<p class="nonindent">Sew down the back of the dress.</p>
<p class="nonindent">Sew each strap to the front and back of the dress.</p>
<p class="extract">Shoes</p>
<p class="nonindent">Sew up the back and bottom of the shoes, attaching both ends of the straps at the top.</p>
<h2 class="section">Polly Dolly’s white dress</h2>
<p class="center">The white dress features a lacy panel around the bottom edge. <br/>It is also decorated with a pretty appliquéd flower motif. Polly Dolly’s underwear is sewn rather than knitted; use the templates on <br/>pp. 120–121 and follow the instructions on p. 51 to make the vest and knickers. We’ve given you a template for the flower (see p. 120), but you could add an appliqué of another pretty design if you like; maybe your Polly would prefer a butterfly or a star shape?</p>
<p class="center">Rating <img alt="" src="OEBPS/images/11-2.jpg"/><img alt="" src="OEBPS/images/11-2.jpg"/><img alt="" src="OEBPS/images/11-2.jpg"/></p>
<p class="center"><strong><em>This dress has more detail than the red dress, so you may find it more challenging</em></strong></p>
<div class="box">
<p class="extract"><strong>yarn</strong></p>
<p class="nonindent">Lightweight (DK) merino wool, microfibre and cashmere mix</p>
<p class="nonindent">1 x 1¾oz (50g) ball in cream</p>
<p class="extract"><strong>needles</strong></p>
<p class="nonindent">Size 6 (4mm) knitting needles</p>
<p class="extract"><strong>gauge</strong></p>
<p class="nonindent">24 sts and 34 rows to 4in (10cm)</p>
<p class="extract"><strong>finished size</strong></p>
<p class="nonindent">7in (18cm) long (not including straps)</p>
</div>
<p class="center"><img alt="" src="OEBPS/images/52-1.jpg"/></p>
<h2 class="section">White dress pattern</h2>
<p class="extract">DRESS</p>
<p class="nonindent">Cast on 93 sts using size 6 (4mm) knitting needles.</p>
<p class="nonindent"><strong>Row 1</strong> K1 [yon, sl1 purlwise, k2tog, psso, yon, k5] rep to last 4 sts, yon, sl1, k2tog, psso, yon, k1.</p>
<p class="nonindent"><strong>Row 2</strong> P.</p>
<p class="nonindent"><strong>Row 3</strong> K1 [yon, sl1 purlwise, k2tog, psso, yon, k5] rep to last 4 sts, yon, sl1, k2tog, psso, yon, k1.</p>
<p class="nonindent"><strong>Row 4</strong> P.</p>
<p class="nonindent"><strong>Row 5</strong> K1 [k3, yon, skpo, k1, k2tog, yon] rep to last 4 sts, k4.</p>
<p class="nonindent"><strong>Row 6</strong> P.</p>
<p class="nonindent"><strong>Row 7</strong> K1 [yon, sl1, k2tog, psso, yon, k1] rep to last 4 sts, yon, sl1, k2tog, psso, yon, k1.</p>
<p class="nonindent"><strong>Row 8</strong> P.</p>
<p class="nonindent"><strong>Row 9</strong> K.</p>
<p class="nonindent"><strong>Row 10</strong> K.</p>
<p class="nonindent"><strong>Row 11</strong> K.</p>
<p class="nonindent"><strong>Row 12</strong> P.</p>
<p class="nonindent">Cont in st st for 24 rows, or 34 rows to make a slightly longer dress, adjusting the foll row numbers by 10.</p>
<p class="nonindent"><strong>Row 37</strong> k3tog [k2tog] rep to end of row. 46 sts.</p>
<p class="nonindent"><strong>Row 38</strong> K.</p>
<p class="nonindent"><strong>Row 39</strong> P.</p>
<p class="nonindent"><strong>Row 40</strong> K.</p>
<p class="nonindent"><strong>Row 41</strong> P.</p>
<p class="nonindent"><strong>Row 42</strong> K.</p>
<p class="nonindent">Cont in st st for 12 rows.</p>
<p class="nonindent"><strong>Row 55</strong> Bind off 15 sts, k16 (work only on these middle 16 sts).</p>
<p class="nonindent"><strong>Row 56</strong> P.</p>
<p class="nonindent"><strong>Row 57</strong> K.</p>
<p class="nonindent"><strong>Row 58</strong> K.</p>
<p class="nonindent"><strong>Row 59</strong> K.</p>
<p class="nonindent"><strong>Row 60</strong> P.</p>
<p class="nonindent">Bind off 16 sts.</p>
<p class="nonindent">Bind off rem 15 sts.</p>
<p class="extract">STRAPS</p>
<p class="nonindent">Cast on 3 sts using size 6 (4mm) knitting needles.</p>
<p class="nonindent">Work in st st for 24 rows.</p>
<p class="nonindent">Bind off.</p>
<h2 class="section"><strong>MAKING UP</strong></h2>
<p class="nonindent">Sew down the back of the dress.</p>
<p class="nonindent">Sew the straps to the front and back of the dress.</p>
<p class="nonindent">Cut out iron-on interfacing-lined fabric petals <br/>(see p. 120 for template).</p>
<p class="nonindent">Sew each petal to the dress (see p. 113). You <br/>could add more flowers if you want the dress <br/>to be more decorated.</p>
<p class="center"><img alt="" src="OEBPS/images/53-1.jpg"/></p>
<h2 class="section">Dolly’s underwear</h2>
<p class="nonindent">The templates for the vest and knickers are <br/>on pp. 120–121.</p>
<p class="extract">KNICKERS</p>
<p class="nonindent">Using the template, cut out the knickers using T-shirt material. This stretchy type of fabric is perfect because it doesn’t fray and has the added stretch that real knickers have.</p>
<p class="nonindent">Sew each side of the knickers together.</p>
<p class="nonindent">Turn the right way and sew a neat running stitch around the top for extra detail.</p>
<p class="extract">VEST</p>
<p class="nonindent">Using the same fabric as the knickers, cut out the vest using the template.</p>
<p class="nonindent">Sew a lace trim round the top of the vest.</p>
<p class="nonindent">Sew along the back of the vest.</p>
<p class="nonindent">Cut out two pieces of ribbon about 3¹/8in (8cm) long.</p>
<p class="nonindent">Sew the ribbon to the top of the vest to form straps.</p>
<p class="center"><img alt="" src="OEBPS/images/54-1.jpg"/></p>
<p class="center"><img alt="" src="OEBPS/images/55-1.jpg"/></p>
<p class="pagebreak"> </p>
<h1 class="section" id="sec7">Simon Snake</h1>
<p class="center">Rating <img alt="" src="OEBPS/images/11-2.jpg"/><img alt="" src="OEBPS/images/11-2.jpg"/></p>
<p class="center"><strong><em>Simon’s colourful patterns are made using the Fair Isle technique, which you might need to practise</em></strong></p>
<p class="center">Simon Snake is a very inquisitive snake. He loves to explore everything around him. He might seem scary, but he is actually a bit clumsy and not good at climbing, which is why he falls out of trees.</p>
<p class="center">Simon’s long, narrow body is knitted in the round using a circular needle, with double-pointed needles for the tip of the tail. You could knit his whole body in stripes if you prefer; use up the oddments in your stash.</p>
<div class="box">
<p class="extract"><strong>yarn</strong></p>
<p class="nonindent">Lightweight (DK) 100% merino wool</p>
<p class="nonindent">3 x 1¾oz (50g) balls in dark green (<strong>A</strong>)</p>
<p class="nonindent">1 x 1¾oz (50g) ball in blue (<strong>B</strong>)</p>
<p class="nonindent">1 x 1¾oz (50g) ball in pink (<strong>C</strong>)</p>
<p class="nonindent">1 x 1¾oz (50g) ball in red (<strong>D</strong>)</p>
<p class="nonindent">1 x 1¾oz (50g) ball in light green (<strong>E</strong>)</p>
<p class="nonindent">Oddment of white yarn (<strong>F</strong>)</p>
<p class="nonindent">Oddment of black yarn (<strong>G</strong>)</p>
<p class="extract"><strong>needles</strong></p>
<p class="nonindent">Size 6 (4mm) knitting needles</p>
<p class="nonindent">Size 10 (6mm) circular needle</p>
<p class="nonindent">3 x size 10 (6mm) double-pointed needles</p>
<p class="extract"><strong>gauge</strong></p>
<p class="nonindent">16 sts and 21 rows to 4in (10cm)</p>
<p class="nonindent"><em>Don’t worry if the gauge is not exact – it <br/>doesn’t matter if Simon is a little bigger or smaller than shown</em></p>
<p class="extract"><strong>finished size</strong></p>
<p class="nonindent">35¼in (90cm) long</p>
</div>
<p class="center"><img alt="" src="OEBPS/images/56-1.jpg"/></p>
<p class="center"><img alt="" src="OEBPS/images/57-1.jpg"/></p>
<p class="caption">Simon Snake lives in the trees,</p>
<p class="caption">He slithers along the bright green leaves.</p>
<p class="caption">You’d better watch out if you’re below,</p>
<p class="caption">He’ll drop on your head and land on your toe.</p>
<div class="block">
<p class="extract"><strong>KNITTING NOTES</strong></p>
<p class="nonindent">• You will be knitting with 2 strands of yarn throughout for the head and body of the snake.</p>
<p class="nonindent">• You start the snake from the straight part of the tail end, but not from the very end. This is finished later.</p>
<p class="nonindent">• Stuff the snake’s head and body while you knit; the longer the tube of the body is, the harder it is to stuff.</p>
<p class="nonindent">• See p. 117 for the chart for the Fair Isle pattern on the snake’s body.</p>
</div>
<h2 class="section">Simon Snake pattern</h2>
<p class="extract">BODY</p>
<p class="nonindent">Using waste yarn, cast on 32 sts on a size 10 <br/>(6mm) circular needle.</p>
<p class="nonindent">K 4 rows.</p>
<p class="nonindent">(This provisional cast-on will be removed later.)</p>
<br/>
<p class="nonindent">Change to <strong>yarn A</strong> using 2 strands. Cont using</p>
<p class="nonindent">2 strands for the entire snake in all colours.</p>
<p class="nonindent"><strong>Row 1</strong> K.</p>
<p class="nonindent"><strong>Row 2</strong> K.</p>
<p class="nonindent"><strong>Row 3</strong> K.</p>
<p class="nonindent"><strong>Row 4</strong> Start pattern in <strong>yarn B</strong> using the chart on <br/>p. 117 (this is an 8-row pattern).</p>
<p class="nonindent">Rep these 8 pattern rows 13 times (14 colour bands <br/>in all).</p>
<p class="nonindent">The colour order is <strong>B</strong>, <strong>C</strong>, <strong>D</strong>, <strong>C</strong>, <strong>B</strong>, <strong>E</strong>, repeating until you get to the head.</p>
<p class="extract">HEAD (CONT FROM BODY)</p>
<p class="nonindent"><strong>Row 1</strong> Using <strong>yarn A</strong> k7, kfb, kfb, k14, kfb, kfb, k7.</p>
<p class="nonindent"><strong>Row 2</strong> K.</p>
<p class="nonindent"><strong>Row 3</strong> K8, kfb, kfb, k16, kfb, kfb, k8.</p>
<p class="nonindent"><strong>Row 4</strong> K.</p>
<p class="nonindent"><strong>Row 5</strong> K9, kfb, kfb, k18, kfb, kfb, k9.</p>
<p class="nonindent">K 11 rows.</p>
<p class="center"><img alt="" src="OEBPS/images/58-1.jpg"/></p>
<p class="nonindent"><strong>Row 17</strong> K8, skpo, k2, k2tog, k16, skpo, k2, k2tog, k8.</p>
<p class="nonindent"><strong>Row 18</strong> K.</p>
<p class="nonindent"><strong>Row 19</strong> K7, skpo, k2, k2tog, k14, skpo, k2, k2tog, k7.</p>
<p class="nonindent"><strong>Row 20</strong> K.</p>
<p class="nonindent"><strong>Row 21</strong> K6, skpo, k2, k2tog, k12, skpo, k2, k2tog, k6.</p>
<p class="nonindent"><strong>Row 22</strong> K.</p>
<p class="nonindent"><strong>Row 23</strong> K5, skpo, k2, k2tog, k10, skpo, k2, k2tog, k5.</p>
<p class="nonindent"><strong>Row 24</strong> K.</p>
<p class="nonindent"><strong>Row 25</strong> K4, skpo, k2, k2tog, k8, skpo, k2, k2tog, k4.</p>
<p class="nonindent"><strong>Row 26</strong> K.</p>
<p class="nonindent"><strong>Row 27</strong> K3, skpo, k2, k2tog, k6, skpo, k2, k2tog, k3.</p>
<p class="nonindent"><strong>Row 28</strong> K.</p>
<p class="nonindent"><strong>Row 29</strong> K2, skpo, k2, k2tog, k4, skpo, k2, k2tog, k2. 16 sts.</p>
<p class="nonindent"><strong>Row 30</strong> K.</p>
<p class="nonindent">Bind off.</p>
<p class="extract">TAIL</p>
<p class="nonindent">Unravel the waste yarn from the start of the snake and slip the green stitches back onto the circular needles. Make sure you start on the 1st stitch.</p>
<p class="nonindent">Keep stuffing the snake as you go along; as you knit, the hole becomes smaller and you won’t be able to stuff it at the end.</p>
<br/>
<p class="nonindent"><strong>Row 1</strong> Using <strong>yarn E</strong>, k. 32 sts.</p>
<p class="nonindent"><strong>Row 2</strong> K.</p>
<p class="nonindent"><strong>Row 3</strong> Using <strong>yarn A</strong>, k.</p>
<p class="nonindent"><strong>Row 4</strong> [k6, k2tog] 4 times. 28 sts.</p>
<p class="nonindent"><strong>Row 5</strong> Using <strong>yarn B</strong>, k.</p>
<p class="nonindent"><strong>Row 6</strong> K.</p>
<p class="nonindent"><strong>Row 7</strong> Using <strong>yarn A</strong>, k.</p>
<p class="nonindent"><strong>Row 8</strong> [k5, k2tog] 4 times. 24 sts.</p>
<p class="nonindent"><strong>Row 9</strong> Using <strong>yarn C</strong> k.</p>
<p class="nonindent"><strong>Row 10</strong> K.</p>
<p class="nonindent"><strong>Row 11</strong> Using <strong>yarn A</strong>, k.</p>
<p class="nonindent"><strong>Row 12</strong> [k4, k2tog] 4 times. 20 sts.</p>
<p class="nonindent"><strong>Row 13</strong> K.</p>
<p class="nonindent"><strong>Row 14</strong> K.</p>
<p class="nonindent"><strong>Row 15</strong> Using <strong>yarn D</strong>, k.</p>
<p class="nonindent"><strong>Row 16</strong> [k3, k2tog] 4 times. 16 sts.</p>
<p class="nonindent"><strong>Row 17</strong> K.</p>
<p class="nonindent"><strong>Row 18</strong> K.</p>
<br/>
<p class="nonindent">Because you have only a few stitches now, <br/>I would advise changing to 3 double-pointed <br/>needles instead of the circular needle as the work <br/>will be easier to manage.</p>
<br/>
<p class="nonindent"><strong>Row 19</strong> [k2, k2tog] 4 times. 12 sts.</p>
<p class="nonindent"><strong>Row 20</strong> K.</p>
<p class="nonindent"><strong>Row 21</strong> K.</p>
<p class="nonindent"><strong>Row 22</strong> [k1, k2tog] to end of row. 8 sts.</p>
<p class="nonindent"><strong>Row 23</strong> K.</p>
<p class="nonindent"><strong>Row 24</strong> K.</p>
<p class="nonindent"><strong>Row 25</strong> K.</p>
<p class="nonindent"><strong>Row 26</strong> K.</p>
<p class="nonindent"><strong>Row 27</strong> K.</p>
<p class="nonindent">Pull yarn through rem sts.</p>
<p class="center"><img alt="" src="OEBPS/images/59-1.jpg"/></p>
<p class="extract">EYES (MAKE 2)</p>
<p class="nonindent">Cast on 4 sts with a single strand of <strong>yarn A</strong> using<br/>size 6 (4mm) knitting needles.</p>
<p class="nonindent"><strong>Row 1</strong> Kfb in each st. 8 sts.</p>
<p class="nonindent"><strong>Row 2</strong> P.</p>
<p class="nonindent"><strong>Row 3</strong> Kfb in each st. 16 sts.</p>
<p class="nonindent"><strong>Row 4</strong> P.</p>
<p class="nonindent">Cont in st st for 4 rows.</p>
<p class="nonindent"><strong>Row 9</strong> Using <strong>yarn F</strong>, k.</p>
<p class="nonindent"><strong>Row 10</strong> P.</p>
<p class="nonindent"><strong>Row 11</strong> K2tog to end of row.</p>
<p class="nonindent"><strong>Row 12</strong> Using <strong>yarn G</strong>, p.</p>
<p class="nonindent"><strong>Row 13</strong> K2tog to end of row.</p>
<p class="nonindent">Thread yarn through needle to close.</p>
<p class="extract">FINISHING TOUCHES</p>
<p class="nonindent">Using the template (see p. 117), cut out the snake’s tongue in red felt and stitch it into the gap at the front of the head.</p>
<p class="nonindent">Close the gap with the tongue included.</p>
<p class="nonindent">Sew eyes onto the head (as shown in the photograph).</p>
<p class="nonindent">Embroider little nose details.</p>
<p class="center"><img alt="" src="OEBPS/images/59-2.jpg"/></p>
<p class="pagebreak"> </p>
<h1 class="section" id="sec8">Piggies at Play</h1>
<p class="center">Rating <img alt="" src="OEBPS/images/11-2.jpg"/><img alt="" src="OEBPS/images/11-2.jpg"/></p>
<p class="center"><strong><em>Easy to knit and assemble with minimal sewing</em></strong></p>
<p class="center">Percy, Penny and Pickle are very happy pigs. Percy likes going to the market and Penny likes making cakes for her friends, the three bears. But watch out for naughty little Pickle; he loves Penny’s cakes and when no one is looking, he will quickly gobble them all up!</p>
<p class="center">Whether you make one or all three of the little pigs, choose <br/>a dusky pink yarn for adorable results. Their cute curly tails can <br/>be crocheted or simply plaited from the same yarn.</p>
<div class="box">
<p class="extract"><strong>yarn</strong></p>
<p class="nonindent">Lightweight (DK) merino wool, microfibre and cashmere mix</p>
<p class="nonindent">1 x 13/4oz (50g) ball per pig in pale pink</p>
<p class="extract"><strong>needles</strong></p>
<p class="nonindent">Size 6 (4mm) knitting needles</p>
<p class="nonindent">Size E4 (3.5mm) crochet hook (optional)</p>
<p class="extract"><strong>gauge</strong></p>
<p class="nonindent">22 sts and 30 rows to 4in (10cm)</p>
<p class="nonindent"><em>Don’t worry if the tension is not exact <br/>– it doesn’t matter if the piggies are a little <br/>bigger or smaller than shown</em></p>
<p class="extract"><strong>finished size</strong></p>
<p class="nonindent">Approx. 7in (18cm) long and 5in (13cm) tall</p>
</div>
<p class="center"><img alt="" src="OEBPS/images/61-1.jpg"/></p>
<div class="block">
<p class="extract"><strong>KNITTING NOTES</strong></p>
<p class="nonindent">You start knitting the piggies from the nose, then the rest of the head, and then the rest of the body, all in one piece. <br/>The piggies’ ears and legs are knitted in separate pieces and attached to the body later.</p>
</div>
<h2 class="section">Piggy pattern</h2>
<br/>
<p class="nonindent">HEAD</p>
<p class="nonindent">Cast on 4 sts using size 6 (4mm) knitting needles.</p>
<p class="nonindent">Row 1 [kfb] 3 times, k1.</p>
<p class="nonindent">Row 2 P.</p>
<p class="nonindent">Row 3 [kfb] 6 times, k1.</p>
<p class="nonindent">Row 4 K.</p>
<p class="nonindent">Row 5 K3, kfb, k4, kfb, k4.</p>
<p class="nonindent">Row 6 P.</p>
<p class="nonindent">Row 7 K4, kfb, k4, kfb, k5.</p>
<p class="nonindent">Row 8 P.</p>
<p class="nonindent">Row 9 K5, kfb, k4, kfb, k6.</p>
<p class="nonindent">Row 10 P.</p>
<p class="nonindent">Row 11 K6, kfb, k4, kfb, k7.</p>
<p class="nonindent">Row 12 P.</p>
<p class="nonindent">Row 13 K2 [kfb, k4] 3 times, kfb, k3.</p>
<p class="nonindent">Row 14 P.</p>
<p class="nonindent">Row 15 K2, kfb, k6, kfb, k4, kfb, k6, kfb, k3.</p>
<p class="nonindent">Row 16 P.</p>
<p class="nonindent">Row 17 K2, kfb, k8, kfb, k4, kfb, k8, kfb, k3.</p>
<p class="nonindent">Row 18 P.</p>
<p class="nonindent">Row 19 K2, kfb, k10, kfb, k4, kfb, k10, kfb, k3.</p>
<p class="nonindent">Row 20 P.</p>
<p class="nonindent">Row 21 K2, kfb, k12, kfb, k4, kfb, k12, kfb, k3. 41 sts.</p>
<p class="nonindent">Row 22 P.</p>
<p class="nonindent">Row 23 K.</p>
<p class="nonindent">Row 24 P.</p>
<p class="center"><img alt="" src="OEBPS/images/62-1.jpg"/></p>
<p class="nonindent">Row 25 K2, skpo, k12, skpo, k5, k2tog, k12, <br/>k2tog, k2.</p>
<p class="nonindent">Row 26 P.</p>
<p class="nonindent">Row 27 K2, skpo, k10, skpo, k5, k2tog, k10, <br/>k2tog, k2.</p>
<p class="nonindent">Row 28 P.</p>
<p class="nonindent">Row 29 K2, skpo, k8, skpo, k5, k2tog, k8, k2tog, <br/>k2. 29 sts.</p>
<p class="nonindent">Row 30 P.</p>
<p class="nonindent">Row 31 K.</p>
<p class="nonindent">Row 32 P.</p>
<br/>
<p class="nonindent">BODY</p>
<p class="nonindent">Row 33 K1 [kfb, k1] rep to end of row. 43 sts.</p>
<p class="nonindent">Row 34 P.</p>
<p class="nonindent">Work 26 rows in st st.</p>
<p class="nonindent">Row 61 K1 [k2tog, k1] rep to end of row.</p>
<p class="nonindent">Row 62 P.</p>
<p class="nonindent">Row 63 K1 [k2tog] rep to end of row. 15 sts.</p>
<p class="nonindent">Row 64 P.</p>
<p class="nonindent">Thread yarn through rem 15 sts and pull together to form the pig’s bottom.</p>
<p class="nonindent">Leave a length of thread to sew the pig up.</p>
<br/>
<p class="nonindent">EARS (MAKE 2)</p>
<p class="nonindent">Cast on 3 sts using size 6 (4mm) knitting needles.</p>
<p class="nonindent">Row 1 Kfb, k2.</p>
<p class="nonindent">Row 2 Kfb, p3.</p>
<p class="nonindent">Row 3 Kfb, k4.</p>
<p class="nonindent">Cont in this way until there are 9 sts.</p>
<p class="nonindent">Work 4 rows in st st.</p>
<p class="nonindent">Run thread through rem sts and pull up to form the base of the pig’s ears.</p>
<br/>
<p class="nonindent">LEGS (MAKE 4)</p>
<p class="nonindent">Cast on 16 sts using size 6 (4mm) knitting needles.</p>
<p class="nonindent">Work 14 rows in st st.</p>
<p class="nonindent">Row 15 [k2tog] rep to end of row.</p>
<p class="nonindent">Row 16 P.</p>
<p class="nonindent">Thread yarn through rem sts to close up feet.</p>
<br/>
<p class="nonindent">TAIL<br/>Use size E4 (3.5mm) crochet hook to make a chain, leaving approx. 4in (10cm) of yarn before 1st <br/>chain stitch. Work 18 chains.</p>
<p class="nonindent">Thread yarn through last sts and sew through all the chain sts until you join the initial 3in (7.5cm) of yarn at beg of pig’s tail. These 2 yarns are used to sew the tail onto the pig.</p>
<br/>
<p class="nonindent">Alternatively, plait 3 ends of yarn together for approx. 4in (10cm) and use this as the tail. Remember to leave some yarn at the end to sew the tail onto the pig.</p>
<br/>
<h2 class="section"><strong>MAKING UP</strong></h2>
<p class="nonindent">BODY</p>
<p class="nonindent">Fold the piggy in half with both knit sides (right sides) together. Sew from each end of the pig (his nose and bottom), leaving a gap of approx. 11/2in (4cm) in the middle. Turn the pig the right way out so that the knit sides (right sides) are on the outside. Fill with stuffing and sew up the gap.</p>
<p class="center"><img alt="" src="OEBPS/images/63-1.jpg"/></p>
<p class="nonindent">LEGS</p>
<p class="nonindent">Fold the legs in half with the knit sides together. Sew up from the feet using the saved yarn. Turn the legs the right way out so that the knit sides are on the outside. Fill with stuffing and sew evenly and tightly to the underside of the body.</p>
<br/>
<p class="nonindent">EARS</p>
<p class="nonindent">Sew the ears onto the top of the head using the shaping as a guide to position them evenly apart.</p>
<br/>
<p class="nonindent">TAIL</p>
<p class="nonindent">Sew the tail onto the centre of the pig’s bottom. <br/>Twist the tail to make it curly and stitch into place.</p>
<br/>
<p class="nonindent">FINISHING TOUCHES</p>
<p class="nonindent">Embroider the eyes and nose using little stitches. Using the templates on p. 117, cut out four iron-on interfacing-lined fabric feet pads and two ear pads. Position as shown in the photograph and sew on (see p. 113).</p>
<p class="pagebreak"> </p>
<h1 class="section" id="sec9">Mischievous Mice</h1>
<p class="center">Rating <img alt="" src="OEBPS/images/11-2.jpg"/></p>
<p class="center"><strong><em>Quick and simple to knit</em></strong></p>
<p class="center">These little mice are very naughty; they love to nibble on your favourite treats. They will happily eat your last cookie or slice of cake, and will even munch on the mouldy bits of cheese found down the side of your favourite armchair – yuck!</p>
<p class="center">Mice are the perfect stash busters. You can enjoy creating lots of lovely mice, each using a mixture of different yarns left over from other knitted toys – this is a great chance to experiment.</p>
<div class="box">
<p class="extract"><strong>yarn</strong></p>
<p class="nonindent">Any small amounts of lightweight (DK) yarn from your stash</p>
<p class="extract"><strong>needles</strong></p>
<p class="nonindent">Size 6 (4mm) knitting needles</p>
<p class="nonindent">Size 4 (3.5mm) knitting needles</p>
<p class="nonindent">Size E4 (3.5mm) crochet hook (optional)</p>
<p class="extract"><strong>gauge</strong></p>
<p class="nonindent">22 sts and 30 rows to 4in (10cm)</p>
<p class="extract"><strong>finished size</strong></p>
<p class="nonindent">Those shown are approx. 4in (10cm) <br/>from nose to tail</p>
<p class="nonindent"><em>The size of your mice and the gauge will vary depending on the type of yarn used</em></p>
</div>
<p class="center"><img alt="" src="OEBPS/images/64-1.jpg"/></p>
<p class="center"><img alt="" src="OEBPS/images/65-1.jpg"/></p>
<p class="nonindent">Little mice cause mischief,</p>
<p class="nonindent">running round and round,</p>
<p class="nonindent">They search for cheese and nibbles,</p>
<p class="nonindent">then hide them underground.</p>
<div class="block">
<p class="extract"><strong>KNITTING NOTES</strong></p>
<p class="nonindent">• You start knitting the mice from the nose all the way along to the bottom.</p>
<p class="nonindent">• To make the stripy mouse, work 2 rows in stockinette stitch in one colour and the next 2 rows in another colour. Continue this 4-row pattern throughout the mouse body. Carry the yarn not in use up the <br/>side of the work rather than cutting and rejoining yarn for each colour change.</p>
</div>
<h2 class="section">Mouse pattern</h2>
<br/>
<p class="nonindent">BODY</p>
<p class="nonindent">Using size 6 (4mm) knitting needles, cast on 7 sts, leaving approx. 4in (10cm) of yarn before the 1st <br/>cast-on st. This is used for sewing up the mouse.</p>
<p class="nonindent">Row 1 K.</p>
<p class="nonindent">Row 2 P.</p>
<p class="nonindent">Row 3 K2, kfb, kfb, k3. 9 sts.</p>
<p class="nonindent">Row 4 P.</p>
<p class="nonindent">Row 5 K3, kfb, kfb, k4. 11 sts.</p>
<p class="nonindent">Row 6 P.</p>
<p class="nonindent">Row 7 K4, kfb, kfb, k5. 13 sts.</p>
<p class="nonindent">Cont in this way until there are 31 sts.</p>
<p class="nonindent">Row 26 P.</p>
<p class="nonindent">Row 27 K.</p>
<p class="nonindent">Row 28 P.</p>
<p class="nonindent">Row 29 K1 [skpo] 7 times, k1 [k2tog] <br/>7 times, k1. 17 sts.</p>
<p class="nonindent">Row 30 P.</p>
<p class="nonindent">Row 31 K1 [skpo] 3 times, k3 [k2tog] <br/>3 times, k1. 11 sts.</p>
<p class="nonindent">Row 32 P.</p>
<p class="nonindent">Slip thread through all 11 sts to close and pull to form the mouse’s bottom.</p>
<p class="center"><img alt="" src="OEBPS/images/66-1.jpg"/></p>
<p class="nonindent">EARS (MAKE 2)</p>
<p class="nonindent">Cast on 3 sts using size 4 (3.5mm) knitting needles.</p>
<p class="nonindent">Row 1 Kfb, k2. 4 sts.</p>
<p class="nonindent">Row 2 Kfb, p3. 5 sts.</p>
<p class="nonindent">Row 3 Kfb, k4. 6 sts.</p>
<p class="nonindent">Row 4 Kfb, p5. 7 sts.</p>
<p class="nonindent">Row 5 K.</p>
<p class="nonindent">Slip thread through all 7 sts to close and pull in to form the base of the ear.</p>
<p class="nonindent">Save approx. 4in (10cm) of yarn to sew the ear onto the body.</p>
<br/>
<p class="nonindent">TAIL</p>
<p class="nonindent">Use size E4 (3.5mm) crochet hook to make a chain, leaving approx. 4in (10cm) of yarn before the 1st <br/>chain stitch.</p>
<p class="nonindent">Work 24 chains.</p>
<p class="nonindent">Thread yarn through the last sts and sew through all the chain sts until you join the initial 4in (10cm) of yarn at the beginning of the tail. These 2 yarns are used to sew the tail onto the mouse.</p>
<br/>
<p class="nonindent">Alternatively, plait 3 ends of yarn together for approx. 4in (10cm) to use as the tail. Remember to leave some yarn at the end to sew the tail onto the mouse.</p>
<h2 class="section"><strong>MAKING UP</strong></h2>
<br/>
<p class="nonindent">BODY</p>
<p class="nonindent">Fold the mouse in half with both knit sides (right sides) together. Sew up from each end, leaving a gap of approx. 1in (2.5cm) in the middle. Turn the mouse the right way out so that the knit sides (right sides) are on the outside. Fill with stuffing and sew up the 1in (2.5cm) gap. Sew on the ears and the tail.</p>
<br/>
<p class="nonindent">FEATURES</p>
<p class="nonindent">Wrap a different coloured yarn several times around the nose of the mouse until it is completely covered. Knot a small piece of yarn above the nose and unravel to create whiskers. Embroider small stitches for the eyes.</p>
<p class="center"><img alt="" src="OEBPS/images/66-2.jpg"/></p>
<p class="center"><img alt="" src="OEBPS/images/67-1.jpg"/></p>
<p class="caption">little mice running round and round ...</p>
<p class="center"><img alt="" src="OEBPS/images/68-1.jpg"/></p>
<p class="center"><img alt="" src="OEBPS/images/69-1.jpg"/></p>
<p class="pagebreak"> </p>
<h1 class="section" id="sec10">Eddie the Friendly Elephant</h1>
<p class="center">Rating <img alt="" src="OEBPS/images/11-2.jpg"/><img alt="" src="OEBPS/images/11-2.jpg"/></p>
<p class="center"><strong><em>Eddie’s head, body and legs feature simple shaping, but you may find his trunk and tusks a little fiddly</em></strong></p>
<p class="center">Eddie Elephant is a gentle giant. He has big flapping ears to hear even the tiniest of sounds, but that doesn’t stop him from getting scared. The naughty little mice always try to make him jump, and when an elephant jumps, everyone knows!</p>
<p class="center">Eddie’s ears and feet are lined with pretty scraps of fabric, and his tail is made from a crocheted chain. Purl ridges make the wrinkles in his trunk.</p>
<div class="box">
<p class="extract"><strong>yarn</strong></p>
<p class="nonindent">Medium-weight (aran) cotton and acrylic mix yarn</p>
<p class="nonindent">1 x 1¾oz (50g) ball in grey (<strong>MC</strong>)</p>
<p class="nonindent">Oddment of white yarn (<strong>CC</strong>)</p>
<p class="extract"><strong>needles</strong></p>
<p class="nonindent">Size 8 (5mm) knitting needles</p>
<p class="nonindent">Size H8 (5mm) crochet hook</p>
<p class="extract"><strong>gauge</strong></p>
<p class="nonindent">17 sts and 24 rows to 4in (10cm)</p>
<p class="nonindent"><em>Don’t worry if the gauge is not exact – it doesn’t matter if Eddie is a little bigger or smaller than shown</em></p>
<p class="extract"><strong>finished size</strong></p>
<p class="nonindent">Approx. 5¾in (15cm) tall, 9in (23cm) <br/>long and 4in (10cm) wide</p>
</div>
<p class="center"><img alt="" src="OEBPS/images/70-1.jpg"/></p>
<p class="center"><img alt="" src="OEBPS/images/71-1.jpg"/></p>
<div class="block">
<p class="extract"><strong>KNITTING NOTES</strong></p>
<p class="nonindent">You start knitting from Eddie’s trunk, then shape his head, then the main part of his body. His ears, legs and tusks are all made separately and attached later.</p>
</div>
<h2 class="section">Eddie Elephant pattern</h2>
<p class="extract">BODY</p>
<p class="nonindent">Cast on 3 sts in <strong>MC yarn</strong> using size 8 (5mm) <br/>knitting needles.</p>
<p class="nonindent"><strong>Row 1</strong> K1, kfb, k1.</p>
<p class="nonindent"><strong>Row 2</strong> Kfb, kfb, kfb, k1.</p>
<p class="nonindent"><strong>Row 3</strong> K.</p>
<p class="nonindent"><strong>Row 4</strong> K.</p>
<p class="nonindent"><strong>Row 5</strong> P.</p>
<p class="nonindent"><strong>Row 6</strong> K.</p>
<p class="nonindent"><strong>Row 7</strong> Kfb, k5, kfb.</p>
<p class="nonindent"><strong>Row 8</strong> K.</p>
<p class="nonindent"><strong>Row 9</strong> P.</p>
<p class="nonindent"><strong>Row 10</strong> K.</p>
<p class="nonindent"><strong>Row 11</strong> Kfb, k7, kfb.</p>
<p class="nonindent"><strong>Row 12</strong> K.</p>
<p class="nonindent"><strong>Row 13</strong> P.</p>
<p class="nonindent"><strong>Row 14</strong> K.</p>
<p class="nonindent"><strong>Row 15</strong> Kfb, k9, kfb.</p>
<p class="nonindent"><strong>Row 16</strong> K.</p>
<p class="nonindent"><strong>Row 17</strong> P.</p>
<p class="nonindent"><strong>Row 18</strong> K.</p>
<p class="nonindent"><strong>Row 19</strong> Kfb, k11, kfb.</p>
<p class="nonindent"><strong>Row 20</strong> K.</p>
<p class="nonindent"><strong>Row 21</strong> P.</p>
<p class="nonindent"><strong>Row 22</strong> K.</p>
<p class="nonindent"><strong>Row 23</strong> K.</p>
<p class="nonindent"><strong>Row 24</strong> K4, kfb, k4, kfb, k5.</p>
<p class="nonindent"><strong>Row 25</strong> P.</p>
<p class="nonindent"><strong>Row 26</strong> K.</p>
<p class="nonindent"><strong>Row 27</strong> K.</p>
<p class="nonindent"><strong>Row 28</strong> K5, kfb, k4, kfb, k6.</p>
<p class="nonindent"><strong>Row 29</strong> P.</p>
<p class="nonindent"><strong>Row 30</strong> K.</p>
<p class="nonindent"><strong>Row 31</strong> K.</p>
<p class="nonindent"><strong>Row 32</strong> K6, kfb, k4, kfb, k7.</p>
<p class="nonindent"><strong>Row 33</strong> P.</p>
<p class="nonindent"><strong>Row 34</strong> K.</p>
<p class="nonindent"><strong>Row 35</strong> K.</p>
<p class="nonindent"><strong>Row 36</strong> K7, kfb, k4, kfb, k8. 23 sts.</p>
<p class="nonindent"><strong>Row 37</strong> P.</p>
<p class="nonindent"><strong>Row 38</strong> K.</p>
<p class="nonindent"><strong>Row 39</strong> K3, [kfb, k4] 4 times.</p>
<p class="nonindent"><strong>Row 40</strong> K.</p>
<p class="nonindent"><strong>Row 41</strong> P.</p>
<p class="nonindent"><strong>Row 42</strong> K5, [kfb, k4] 3 times, kfb, k6.</p>
<p class="nonindent"><strong>Row 43</strong> P.</p>
<p class="nonindent"><strong>Row 44</strong> K7, [kfb, k4] 3 times, kfb, k8.</p>
<p class="nonindent"><strong>Row 45</strong> P.</p>
<p class="nonindent"><strong>Row 46</strong> K9, [kfb, k4] 3 times, kfb, k10.</p>
<p class="nonindent"><strong>Row 47</strong> P.</p>
<p class="nonindent"><strong>Row 48</strong> K11, [kfb, k4] 3 times, kfb, k12.</p>
<p class="nonindent"><strong>Row 49</strong> P.</p>
<p class="nonindent"><strong>Row 50</strong> K13, [kfb, k4] 3 times, kfb, k14.</p>
<p class="nonindent"><strong>Row 51</strong> K.</p>
<p class="nonindent"><strong>Row 52</strong> k15, [kfb, k4] 3 times, kfb, k16.</p>
<p class="nonindent"><strong>Row 53</strong> P.</p>
<p class="nonindent"><strong>Row 54</strong> K17, [kfb, k4] 3 times, kfb, k18. 55 sts.</p>
<p class="nonindent"><strong>Row 55</strong> P.</p>
<p class="nonindent"><strong>Row 56</strong> K.</p>
<p class="nonindent"><strong>Row 57</strong> P.</p>
<p class="nonindent"><strong>Row 58</strong> K17, k2tog, k4, k2tog, k5, skpo, k4, <br/>skpo, k17.</p>
<p class="nonindent"><strong>Row 59</strong> P.</p>
<p class="nonindent"><strong>Row 60</strong> K15, k2tog, k4, k2tog, k5, skpo, k4, <br/>skpo, k15.</p>
<p class="nonindent"><strong>Row 61</strong> P.</p>
<p class="nonindent"><strong>Row 62</strong> K13, k2tog, k4, k2tog, k5, skpo, k4, <br/>skpo, k13.</p>
<p class="nonindent"><strong>Row 63</strong> P.</p>
<p class="nonindent"><strong>Row 64</strong> K11, k2tog, k4, k2tog, k5, skpo, k4, skpo, k11.</p>
<p class="nonindent"><strong>Row 65</strong> P.</p>
<p class="nonindent"><strong>Row 66</strong> K9, k2tog, k4, k2tog, k5, skpo, k4, skpo, <br/>k9. 35 sts.</p>
<p class="nonindent"><strong>Row 67</strong> P.</p>
<p class="nonindent"><strong>Row 68</strong> [kfb, k1] rep to last stitch, kfb. 53 sts.</p>
<p class="nonindent"><strong>Row 69</strong> P.</p>
<p class="nonindent"><strong>Row 70</strong> Kfb, k51, kfb. 55 sts.</p>
<p class="nonindent"><strong>Row 71</strong> P.</p>
<p class="nonindent">Cont in st st for 30 rows.</p>
<p class="nonindent"><strong>Row 10</strong><strong>2</strong> [k1, k2tog] rep to last st, k1.</p>
<p class="nonindent"><strong>Row 10</strong><strong>3</strong> P.</p>
<p class="nonindent"><strong>Row 10</strong><strong>4</strong> [k2tog] rep to last st. 19 sts.</p>
<p class="nonindent"><strong>Row 10</strong><strong>5</strong> P.</p>
<p class="nonindent">Thread yarn through rem sts.</p>
<p class="extract">EARS (MAKE 2)</p>
<p class="nonindent">Cast on 12 sts in <strong>MC yarn</strong> using size 8 (5mm) <br/>knitting needles.</p>
<p class="nonindent"><strong>Row 1</strong> K.</p>
<p class="nonindent"><strong>Row 2</strong> P.</p>
<p class="nonindent"><strong>Row 3</strong> Kfb at beg and end of row.</p>
<p class="nonindent"><strong>Row 4</strong> P.</p>
<p class="nonindent">Rep rows 3 and 4 until there are 20 sts.</p>
<p class="nonindent">Cont in st st for 4 rows.</p>
<p class="nonindent">K2tog at beg and end of row. 18 sts.</p>
<p class="nonindent">Bind off.</p>
<p class="extract">LEGS (MAKE 4)</p>
<p class="nonindent">Cast on 5 sts in <strong>MC yarn</strong> using size 8 (5mm) <br/>knitting needles.</p>
<p class="nonindent"><strong>Row 1</strong> Kfb in all sts. 10 sts.</p>
<p class="nonindent"><strong>Row 2</strong> P.</p>
<p class="nonindent"><strong>Row 3</strong> Kfb in all sts. 20 sts.</p>
<p class="nonindent"><strong>Row 4</strong> K.</p>
<p class="nonindent"><strong>Row 5</strong> K.</p>
<p class="nonindent"><strong>Row 6</strong> P.</p>
<p class="nonindent">Cont in st st for 16 rows.</p>
<p class="nonindent">Bind off.</p>
<p class="extract">TUSKS (MAKE 2)</p>
<p class="nonindent">Cast on 5 sts in <strong>CC yarn</strong> using size 8 (5mm) <br/>knitting needles.</p>
<p class="nonindent">Work in st st for 4 rows.</p>
<p class="nonindent"><strong>Row 5</strong> K1, kfb, kfb, k2.</p>
<p class="center"><img alt="" src="OEBPS/images/73-1.jpg"/></p>
<p class="caption">ssshhhh ... don’t scare Eddie...</p>
<p class="center"><img alt="" src="OEBPS/images/74-1.jpg"/></p>
<p class="caption">...he can hear everything with his big ears!</p>
<p class="nonindent"><strong>Row 6</strong> P.</p>
<p class="nonindent"><strong>Row 7</strong> K.</p>
<p class="nonindent"><strong>Row 8</strong> P.</p>
<p class="nonindent"><strong>Row 9</strong> K2, kfb, kfb, k3.</p>
<p class="nonindent"><strong>Row 10</strong> P.</p>
<p class="nonindent"><strong>Row 11</strong> K.</p>
<p class="nonindent"><strong>Row 12</strong> P.</p>
<p class="nonindent"><strong>Row 13</strong> K3, kfb, kfb, k4.</p>
<p class="nonindent"><strong>Row 14</strong> P.</p>
<p class="nonindent"><strong>Row 15</strong> K2tog, k7, k2tog.</p>
<p class="nonindent"><strong>Row 16</strong> P.</p>
<p class="nonindent"><strong>Row 17</strong> K2tog, k5, k2tog.</p>
<p class="nonindent"><strong>Row 18</strong> P.</p>
<p class="nonindent">Bind off.</p>
<br/>
<p class="nonindent">TAIL<br/>Use size H8 (5mm) crochet hook to make a chain, leaving approx. 4in (10cm) of yarn before 1st chain stitch. Work 18 chains. Thread yarn through last sts and sew through all the chain sts until you join the initial 3in (7.5cm) of yarn at beg of Eddie’s tail. These 2 yarns are used to sew the tail onto the elephant.</p>
<br/>
<p class="nonindent">Alternatively, plait 3 ends of yarn together for approx. 4in (10cm) and use this as the tail. Remember to leave some yarn at the end to sew the tail onto Eddie.</p>
<h2 class="section"><strong>MAKING UP</strong></h2>
<p class="extract">Body</p>
<p class="nonindent">Fold the body in half with knit sides (right <br/>sides) together.</p>
<p class="nonindent">Sew from each end, leaving a gap of approx. <br/>11/8in (3cm) in the middle.</p>
<p class="nonindent">Turn the right way out so the knit sides (right sides) are on the outside.</p>
<p class="nonindent">Fill with stuffing.</p>
<p class="nonindent">Sew up the 11/8in (3cm) gap.</p>
<p class="nonindent">Attach the trunk to the body with a few stitches.</p>
<p class="extract">Legs</p>
<p class="nonindent">Fold the legs in half with knit sides (right <br/>sides) together.</p>
<p class="nonindent">Sew from the heel to top of the leg.</p>
<p class="nonindent">Turn the right way out so the knit sides (right sides) are on the outside.</p>
<p class="nonindent">Fill with stuffing.</p>
<p class="nonindent">Position the legs to the base of the body and sew them on tightly.</p>
<p class="extract">Ears</p>
<p class="nonindent">Cut out two iron-on interfacing-lined fabric ears <br/>(see p. 119 for template).</p>
<p class="nonindent">Sew each piece of fabric to the inside of the knitted ear (see p. 113).</p>
<p class="center"><img alt="" src="OEBPS/images/75-1.jpg"/></p>
<p class="nonindent">Stitch the ears to each side of the elephant’s head using the shaping at the top of the head to position them correctly and evenly apart.</p>
<p class="extract">Tusks</p>
<p class="nonindent">Fold the tusk in half and sew along the edge.</p>
<p class="nonindent">Fill with stuffing.</p>
<p class="nonindent">Position tusks to the sides of the trunk and <br/>attach securely.</p>
<p class="extract">Finishing touches</p>
<p class="nonindent">Embroider eyes above the trunk using brown or black yarn (as shown in the photograph).</p>
<p class="nonindent">Using the template on p. 119, cut out four iron-on interfacing-lined fabric feet pads.</p>
<p class="nonindent">Position correctly and sew on.</p>
<p class="pagebreak"> </p>
<h1 class="section" id="sec11">Three Little Fish</h1>
<p class="center">Rating <img alt="" src="OEBPS/images/11-2.jpg"/></p>
<p class="center"><strong><em>The fish are a simple shape but feature some Fair Isle and intarsia colourwork</em></strong></p>
<p class="center">The three little fish love to dart about in the waves. They dive deep down to the bottom of the seabed. But they had better watch out, because Peter Penguin loves eating fish for his tea!</p>
<p class="center">These fish make the ideal project for using up colourful little scraps of yarn; I used yarn left over from Bertie and Beatrice the Birds <br/>(pp. 14–21). I’ve included some Fair Isle patterning, but you could make these fish in stripes or in plain, bright colours.</p>
<div class="box">
<p class="extract"><strong>yarn</strong></p>
<p class="nonindent">Lightweight (DK) 100% wool</p>
<p class="nonindent">I have given instructions for the fish with the blue tail. You need only small amounts of yarn in:</p>
<p class="nonindent">blue (<strong>A</strong>)</p>
<p class="nonindent">pink (<strong>B</strong>)</p>
<p class="nonindent">yellow (<strong>C</strong>)</p>
<p class="nonindent">green (<strong>D</strong>)</p>
<p class="extract"><strong>needles</strong></p>
<p class="nonindent">Size 6 (4mm) knitting needles</p>
<p class="extract"><strong>gauge</strong></p>
<p class="nonindent">22 sts and 30 rows to 4in (10cm)</p>
<p class="nonindent"><em>Don’t worry if the gauge is not exact – it doesn’t matter if the fish are a little bigger or smaller than shown</em></p>
<p class="extract"><strong>finished size</strong></p>
<p class="nonindent">7in (18cm) long and 2¾in (7cm) across <br/>the widest part of the body</p>
</div>
<p class="center"><img alt="" src="OEBPS/images/76-1.jpg"/></p>
<p class="center"><img alt="" src="OEBPS/images/77-1.jpg"/></p>
<div class="block">
<p class="extract"><strong>KNITTING NOTES</strong></p>
<p class="nonindent">• For this pattern I have written instructions for the fish with the <strong>blue</strong> tail. He has a <strong>pink</strong> nose, <strong>pink</strong> fins, and <strong>green</strong> and <strong>yellow</strong> details. Change the colours as you desire.</p>
<p class="nonindent">• This pattern features both intarsia and Fair Isle colourwork. The tail is worked in intarsia (see p. 108), and the pattern around the fish’s middle is worked in Fair Isle (see <br/>p. 109). I have written out the pattern in full, but there are also templates and a Fair Isle chart on p. 118 if you find that easier to follow.</p>
<p class="nonindent">• The fish is knitted from the tail to the head.</p>
</div>
<h2 class="section">Fish pattern</h2>
<p class="extract">BODY</p>
<p class="nonindent">Cast on 32 sts using <strong>yarn A</strong> and size 6 (4mm) <br/>knitting needles.</p>
<p class="nonindent">Work in st st for 4 rows.</p>
<p class="nonindent">Beg intarsia colour changes.</p>
<p class="nonindent"><strong>Row 5</strong> [<strong>A</strong> k2, <strong>B</strong> k5, <strong>A</strong> k2, <strong>B</strong> k5, <strong>A</strong> k2] rep to end <br/>of row.</p>
<p class="nonindent"><strong>Row 6</strong> [<strong>A</strong> p2, <strong>B</strong> p5, <strong>A</strong> p2, <strong>B</strong> p5, <strong>A</strong> p2] rep to end <br/>of row.</p>
<p class="nonindent"><strong>Row 7</strong> [<strong>A</strong> k2, <strong>B</strong> k5, <strong>A</strong> k2, <strong>B</strong> k5, <strong>A</strong> k2] rep to end <br/>of row.</p>
<p class="nonindent"><strong>Row 8</strong> [<strong>A</strong> p2, <strong>B</strong> p5 <strong>A</strong> p2, <strong>B</strong> p5, <strong>A</strong> p2] rep to end <br/>of row.</p>
<p class="nonindent"><strong>Row 9</strong> [<strong>A</strong> k2, <strong>B</strong> skpo, k1, k2tog, k2, <strong>A</strong> skpo, k1, k2tog, k2] rep to end of row.</p>
<p class="nonindent"><strong>Row 10</strong> [<strong>A</strong> p2, <strong>B</strong> p3, <strong>A</strong> p2, <strong>B</strong> p3, <strong>A</strong> p2] rep to end <br/>of row.</p>
<p class="nonindent"><strong>Row 11</strong> [<strong>A</strong> k2, <strong>B</strong> k3, <strong>A</strong> k2, <strong>B</strong> k3, <strong>A</strong> k2] rep to end <br/>of row.</p>
<p class="nonindent"><strong>Row 12</strong> [<strong>A</strong> p2, <strong>B</strong> p3, <strong>A</strong> p2, <strong>B</strong> p3, <strong>A</strong> p2] rep to end <br/>of row.</p>
<p class="nonindent"><strong>Row 13</strong> [<strong>A</strong> k2, <strong>B</strong> k3tog, <strong>A</strong> k2, <strong>B</strong> k3tog, <strong>A</strong> k2] rep to end of row.</p>
<p class="nonindent"><strong>Row 14</strong> [<strong>A</strong> p2, <strong>B</strong> p1, <strong>A</strong> p2, <strong>B</strong> p1, <strong>A</strong> p2] rep to end <br/>of row.</p>
<p class="nonindent"><strong>Row 15</strong> <strong>A</strong> k.</p>
<p class="nonindent"><strong>Row 16</strong> P.</p>
<p class="nonindent"><strong>Row 17</strong> [kfb, k5, kfb, k1] rep to end of row.</p>
<p class="nonindent"><strong>Row 18</strong> P.</p>
<p class="nonindent"><strong>Row 19</strong> [kfb, k7, kfb, k1] rep to end of row.</p>
<p class="nonindent"><strong>Row 20</strong> <strong>C</strong> p.</p>
<p class="nonindent"><strong>Row 21</strong> [kfb, k9, kfb, k1] rep to end of row.</p>
<p class="nonindent"><strong>Row 22</strong> P.</p>
<p class="nonindent"><strong>Row 23</strong> [kfb, k11, kfb, k1] rep to end of row.</p>
<p class="nonindent"><strong>Row 24</strong> <strong>A</strong> p.</p>
<p class="nonindent"><strong>Row 25</strong> [kfb, k13, kfb, k1] rep to end of row.</p>
<p class="nonindent"><strong>Row 26</strong> <strong>D</strong> p.</p>
<p class="nonindent"><strong>Row 27</strong> [kfb, k15, kfb, k1] rep to end of row. 40 sts.</p>
<p class="nonindent"><strong>Row 28</strong> P.</p>
<p class="nonindent">Beg Fair Isle pattern.</p>
<p class="nonindent"><strong>Row 29</strong> [<strong>B</strong> k2, <strong>D</strong> k2, <strong>B</strong> k2, <strong>D</strong> k2, <strong>B</strong> k2,] 4 times.</p>
<p class="nonindent"><strong>Row 30</strong> [<strong>B</strong> p1, <strong>D</strong> p2, <strong>B</strong> p4, <strong>D</strong> p2, <strong>B</strong> p1] 4 times.</p>
<p class="nonindent"><strong>Row 31</strong> [<strong>D</strong> k2, <strong>B</strong> k2, <strong>D</strong> k2, <strong>B</strong> k2, <strong>D</strong> k2] 4 times.</p>
<p class="nonindent"><strong>Row 32</strong> [<strong>D</strong> p1, <strong>B</strong> p2, <strong>D</strong> p4, <strong>B</strong> p2, <strong>D</strong> p1] 4 times.</p>
<p class="nonindent"><strong>Row 33</strong> [<strong>B</strong> k2, <strong>D</strong> k2, <strong>B</strong> k2, <strong>D</strong> k2, <strong>B</strong> k2] 4 times.</p>
<p class="nonindent"><strong>Row 34</strong> [<strong>B</strong> p1, <strong>D</strong> p2, <strong>B</strong> p4, <strong>D</strong> p2, <strong>B</strong> p1] 4 times.</p>
<p class="nonindent"><strong>Row 35</strong> <strong>D</strong> k.</p>
<p class="nonindent"><strong>Row 36</strong> P.</p>
<p class="nonindent"><strong>Row 37</strong> [<strong>A</strong> skpo, k16, k2tog] rep to end of row.</p>
<p class="nonindent"><strong>Row 38</strong> P.</p>
<p class="nonindent"><strong>Row 39</strong> [skpo, k14, k2tog] rep to end of row.</p>
<p class="nonindent"><strong>Row 40</strong> P.</p>
<p class="nonindent"><strong>Row 41</strong> [<strong>C</strong> skpo, k12, k2tog] rep to end of row.</p>
<p class="nonindent"><strong>Row 42</strong> P.</p>
<p class="nonindent"><strong>Row 43</strong> [<strong>B</strong> skpo, k10, k2tog] rep to end of row.</p>
<p class="nonindent"><strong>Row 44</strong> P.</p>
<p class="nonindent"><strong>Row 45</strong> [skpo, k8, k2tog] rep to end of row.</p>
<p class="nonindent"><strong>Row 46</strong> P.</p>
<p class="nonindent"><strong>Row 47</strong> [skpo, k6, k2tog] rep to end of row.</p>
<p class="nonindent"><strong>Row 48</strong> P. 16 sts.</p>
<p class="nonindent">Thread yarn through rem sts.</p>
<p class="center"><img alt="" src="OEBPS/images/78-1.jpg"/></p>
<p class="extract">FINS (MAKE 2)</p>
<p class="nonindent">Cast on 7 sts using <strong>yarn B</strong> and size 6 (4mm) <br/>knitting needles.</p>
<p class="nonindent"><strong>Row 1</strong> K2, kfb, kfb, k3.</p>
<p class="nonindent"><strong>Row 2</strong> P.</p>
<p class="nonindent"><strong>Row 3</strong> K3, kfb, kfb, k4.</p>
<p class="nonindent"><strong>Row 4</strong> P.</p>
<p class="nonindent"><strong>Row 5</strong> K4, kfb, kfb, k5. 13 sts.</p>
<p class="nonindent"><strong>Row 6</strong> P.</p>
<p class="nonindent">Bind off.</p>
<h2 class="section"><strong>MAKING UP</strong></h2>
<p class="extract">Body</p>
<p class="nonindent">Sew the loose ends in to stop holes forming.</p>
<p class="nonindent">Fold the body in half with knit sides (right <br/>sides) together.</p>
<p class="nonindent">Sew from each end, leaving a gap of approx. <br/>11/8in (3cm) in the middle.</p>
<p class="nonindent">Turn the right way out so the knit sides (right sides) are on the outside.</p>
<p class="nonindent">Fill with stuffing.</p>
<p class="nonindent">Sew up the 1in (3cm) gap.</p>
<p class="extract">Fins</p>
<p class="nonindent">Cut out two iron-on interfacing-lined fabric fins <br/>(see p. 118 for template).</p>
<p class="nonindent">Sew each piece of fabric to the inside of the knitted fin (see p. 113).</p>
<p class="nonindent">Stitch the fins to each side of the fish body using the patterning to position them correctly.</p>
<p class="extract">Finishing touches</p>
<p class="nonindent">Embroider eyes to each side of the head using brown or black yarn in the centre. Edge the eyes with white or cream yarn (as shown in the photograph opposite).</p>
<p class="center"><img alt="" src="OEBPS/images/79-1.jpg"/></p>
<p class="center"><img alt="" src="OEBPS/images/79-2.jpg"/></p>
<p class="pagebreak"> </p>
<h1 class="section" id="sec12">Peter Penguin’s Fishing Trip</h1>
<p class="center">Rating <img alt="" src="OEBPS/images/11-2.jpg"/><img alt="" src="OEBPS/images/11-2.jpg"/></p>
<p class="center"><strong><em>Peter is made up of simple shapes, but his colouring is worked in intarsia</em></strong></p>
<p class="center">Peter Penguin is very good at fishing. He can catch fish of all different sizes. Big fish, little fish, enormous fish and tiny baby fish ... it all depends on how hungry he is and how many friends he has round for dinner.</p>
<p class="center">This is quite a simple project, although you will need to practise <br/>your intarsia technique, particularly wrapping the colours round each other where they change. Use plenty of stuffing so the penguin looks nice and plump.</p>
<div class="box">
<p class="extract"><strong>yarn</strong></p>
<p class="nonindent">Lightweight (DK) 100% wool</p>
<p class="nonindent">1 x 1¾oz (50g) ball in black (<strong>A</strong>)</p>
<p class="nonindent">1 x 1¾oz (50g) ball in white (<strong>B</strong>)</p>
<p class="nonindent">Small amount of yarn in yellow (<strong>C</strong>)</p>
<p class="extract"><strong>needles</strong></p>
<p class="nonindent">Size 6 (4mm) knitting needles</p>
<p class="extract"><strong>gauge</strong></p>
<p class="nonindent">22 sts and 30 rows to 4in (10cm)</p>
<p class="nonindent"><em>Don’t worry if the gauge is not exact – it doesn’t matter if Peter is a little bigger or smaller than shown</em></p>
<p class="extract"><strong>finished size</strong></p>
<p class="nonindent">Approx. 7in (18cm) tall</p>
</div>
<p class="center"><img alt="" src="OEBPS/images/80-1.jpg"/></p>
<p class="center"><img alt="" src="OEBPS/images/81-1.jpg"/></p>
<div class="block">
<p class="extract"><strong>KNITTING NOTES</strong></p>
<p class="nonindent">• The colourwork for this project is done using the intarsia method (see p. 108). When changing between the black and the white yarns, make sure you wrap the yarns around one another when changing from one colour to the next. This prevents holes appearing between colours.</p>
<p class="nonindent">• Peter is knitted from <br/>the head down.</p>
</div>
<p class="center"><img alt="" src="OEBPS/images/82-1.jpg"/></p>
<h2 class="section">Peter Penguin pattern</h2>
<p class="extract">HEAD AND BODY</p>
<p class="nonindent">Cast on 9 sts using <strong>yarn A</strong> and size 6 (4mm) <br/>knitting needles.</p>
<p class="nonindent"><strong>Row 1</strong> [kfb, k1] 4 times, k1.</p>
<p class="nonindent"><strong>Row 2</strong> P.</p>
<p class="nonindent"><strong>Row 3</strong> [kfb, k1, kfb] 4 times, k1.</p>
<p class="nonindent"><strong>Row 4</strong> P.</p>
<p class="nonindent"><strong>Row 5</strong> [kfb, k3, kfb] 4 times, k1.</p>
<p class="nonindent"><strong>Row 6</strong> P.</p>
<p class="nonindent"><strong>Row 7</strong> [kfb, k5, kfb] 4 times, k1.</p>
<p class="nonindent"><strong>Row 8</strong> P.</p>
<p class="nonindent"><strong>Row 9</strong> [kfb, k7, kfb] 4 times, k1. 45 sts.</p>
<p class="nonindent"><strong>Row 10</strong> P.</p>
<p class="nonindent">Beg colour changes.</p>
<p class="nonindent"><strong>Row 11</strong> <strong>A</strong> k16, <strong>B</strong> k13, <strong>A</strong> k16.</p>
<p class="nonindent"><strong>Row 12</strong> <strong>A</strong> p15, <strong>B</strong> p15, <strong>A</strong> p15.</p>
<p class="nonindent"><strong>Row 13</strong> <strong>A</strong> k14, <strong>B</strong> k17, <strong>A</strong> k14.</p>
<p class="nonindent"><strong>Row 14</strong> <strong>A</strong> p13, <strong>B</strong> p19, <strong>A</strong> p13.</p>
<p class="nonindent"><strong>Row 15</strong> <strong>A</strong> k12, <strong>B</strong> k21, <strong>A</strong> k12.</p>
<p class="nonindent"><strong>Row 16</strong> <strong>A</strong> p11 <strong>B</strong> p23, <strong>A</strong> p11.</p>
<p class="nonindent"><strong>Row 17</strong> <strong>A</strong> k11, <strong>B</strong> k23, <strong>A</strong> k11.</p>
<p class="nonindent"><strong>Row 18</strong> <strong>A</strong> p12, <strong>B</strong> p21, <strong>A</strong> p12.</p>
<p class="nonindent"><strong>Row 19</strong> <strong>A</strong> k13, <strong>B</strong> k19, <strong>A</strong> k13.</p>
<p class="nonindent"><strong>Row 20</strong> <strong>A</strong> p14, <strong>B</strong> p17, <strong>A</strong> p14.</p>
<p class="nonindent"><strong>Row 21</strong> <strong>A</strong> k15, <strong>B</strong> k15, <strong>A</strong> k15.</p>
<p class="nonindent"><strong>Row 22</strong> <strong>A</strong> p16, <strong>B</strong> p13, <strong>A</strong> p16.</p>
<p class="nonindent"><strong>Row 23</strong> <strong>A</strong> k.</p>
<p class="nonindent"><strong>Row 24</strong> P.</p>
<p class="nonindent"><strong>Row 25</strong> [k2tog, k7, k2tog] 4 times, k1.</p>
<p class="nonindent"><strong>Row 26</strong> P.</p>
<p class="nonindent"><strong>Row 27</strong> [k2tog, k5, k2tog] 4 times, k1. 29 sts.</p>
<p class="nonindent"><strong>Row 28</strong> P.</p>
<p class="nonindent"><strong>Row 29</strong> [kfb, k1] rep to last st, kfb. 44 sts.</p>
<p class="nonindent"><strong>Row 30</strong> P.</p>
<p class="nonindent"><strong>Row 31</strong> <strong>A</strong> k18, <strong>B</strong> k8, <strong>A</strong> k18.</p>
<p class="nonindent"><strong>Row 32</strong> <strong>A</strong> p17, <strong>B</strong> p10, <strong>A</strong> p17.</p>
<p class="nonindent"><strong>Row 33</strong> <strong>A</strong> k16, <strong>B</strong> k12, <strong>A</strong> k16.</p>
<p class="nonindent"><strong>Row 34</strong> <strong>A</strong> p15, <strong>B</strong> p14, <strong>A</strong> p15.</p>
<p class="nonindent"><strong>Row 35</strong> <strong>A</strong> kfb, k13, <strong>B</strong> k7, kfb, kfb, k7, <strong>A</strong> k13, kfb.</p>
<p class="nonindent"><strong>Row 36</strong> <strong>A</strong> p14, <strong>B</strong> p20, <strong>A</strong> p14.</p>
<p class="nonindent"><strong>Row 37</strong> <strong>A</strong> k13, <strong>B</strong> k22, <strong>A</strong> k13.</p>
<p class="nonindent"><strong>Row 38</strong> <strong>A</strong> p12, <strong>B</strong> p24, <strong>A</strong> p12.</p>
<p class="nonindent"><strong>Row 39</strong> <strong>A</strong> kfb, k10, <strong>B</strong> k12, kfb, kfb, k12, <strong>A</strong> k10, <br/>kfb. 52 sts.</p>
<p class="nonindent"><strong>Row 40</strong> <strong>A</strong> p11, <strong>B</strong> p30, <strong>A</strong> p11.</p>
<p class="nonindent"><strong>Row 41</strong> <strong>A</strong> k10, <strong>B</strong> k32, <strong>A</strong> k10.</p>
<p class="nonindent"><strong>Row 42</strong> <strong>A</strong> p9, <strong>B</strong> p34, <strong>A</strong> p9.</p>
<p class="nonindent"><strong>Row 43</strong> <strong>A</strong> k8, <strong>B</strong> k36, <strong>A</strong> k8.</p>
<p class="nonindent"><strong>Row 44</strong> <strong>A</strong> p7, <strong>B</strong> p38, <strong>A</strong> p7.</p>
<p class="nonindent"><strong>Row 45</strong> <strong>A</strong> k6, <strong>B</strong> k40, <strong>A</strong> k6.</p>
<p class="nonindent"><strong>Row 46</strong> <strong>A</strong> p5, <strong>B</strong> p42, <strong>A</strong> p5.</p>
<p class="nonindent"><strong>Row 47</strong> <strong>A</strong> k4, <strong>B</strong> k44, <strong>A</strong> k4.</p>
<p class="nonindent"><strong>Row 48</strong> <strong>A</strong> p3, <strong>B</strong> p46, <strong>A</strong> p3.</p>
<p class="nonindent"><strong>Row 49</strong> <strong>A</strong> k2, <strong>B</strong> k48, <strong>A</strong> k2.</p>
<p class="nonindent"><strong>Row 50 B</strong> p.</p>
<p class="nonindent"><strong>Row 51</strong> K.</p>
<p class="nonindent"><strong>Row 52</strong> P.</p>
<p class="nonindent"><strong>Row 53</strong> [k2tog, k9, skpo] 4 times.</p>
<p class="nonindent"><strong>Row 54</strong> P.</p>
<p class="nonindent"><strong>Row 55</strong> [k2tog, k7, skpo] 4 times.</p>
<p class="nonindent"><strong>Row 56</strong> P.</p>
<p class="nonindent"><strong>Row 57</strong> [k2tog, k5, skpo] 4 times.</p>
<p class="nonindent"><strong>Row 58</strong> P.</p>
<p class="nonindent"><strong>Row 59</strong> [k2tog, k3, skpo] 4 times.</p>
<p class="nonindent"><strong>Row 60</strong> P.</p>
<p class="nonindent"><strong>Row 61</strong> [k2tog, k1, skpo] 4 times. 12 sts.</p>
<p class="nonindent"><strong>Row 62</strong> P.</p>
<p class="nonindent">Thread yarn through rem sts.</p>
<p class="extract">BEAK (MAKE 2 PIECES)</p>
<p class="nonindent">Cast on 3 sts using <strong>yarn C</strong> and size 6 (4mm) <br/>knitting needles.</p>
<p class="nonindent"><strong>Row 1</strong> K1, kfb, kfb.</p>
<p class="nonindent"><strong>Row 2</strong> P.</p>
<p class="nonindent"><strong>Row 3</strong> K2, kfb, kfb, k1.</p>
<p class="nonindent"><strong>Row 4</strong> P.</p>
<p class="nonindent"><strong>Row 5</strong> K3, kfb, kfb, k2.</p>
<p class="nonindent"><strong>Row 6</strong> P.</p>
<p class="nonindent"><strong>Row 7</strong> K4, kfb, kfb, k3. 11 sts.</p>
<p class="nonindent"><strong>Row 8</strong> P.</p>
<p class="nonindent">Bind off.</p>
<p class="extract">WINGS (MAKE 2)</p>
<p class="nonindent">Cast on 3 sts using <strong>yarn A</strong> and size 6 (4mm) <br/>knitting needles.</p>
<p class="nonindent"><strong>Row 1</strong> K1, kfb, kfb.</p>
<p class="nonindent"><strong>Row 2</strong> P.</p>
<p class="nonindent"><strong>Row 3</strong> K2, kfb, kfb, k1.</p>
<p class="nonindent"><strong>Row 4</strong> P.</p>
<p class="nonindent">Cont until there are 17 sts.</p>
<p class="nonindent"><strong>Row 14</strong> P.</p>
<p class="nonindent">Cont in st st for 8 rows.</p>
<p class="nonindent"><strong>Row 23</strong> K2tog each end of row.</p>
<p class="nonindent"><strong>Row 24</strong> P2tog each end of row.</p>
<p class="nonindent">Rep these 2 rows until there are 3 sts.</p>
<p class="nonindent">P3tog.</p>
<p class="nonindent">Tie off yarn.</p>
<p class="center"><img alt="" src="OEBPS/images/82-2.jpg"/></p>
<p class="extract">FEET (MAKE 2)</p>
<p class="nonindent">Cast on 3 sts using <strong>yarn C</strong> and size 6 (4mm) <br/>knitting needles.</p>
<p class="nonindent"><strong>Row 1</strong> Kfb, kfb, k1.</p>
<p class="nonindent"><strong>Row 2</strong> P.</p>
<p class="nonindent"><strong>Row 3</strong> K1, kfb, kfb, k2.</p>
<p class="nonindent"><strong>Row 4</strong> P.</p>
<p class="nonindent"><strong>Row 5</strong> K2, kfb, kfb, k3.</p>
<p class="nonindent"><strong>Row 6</strong> P.</p>
<p class="nonindent"><strong>Row 7</strong> K3, kfb, kfb, k4.</p>
<p class="nonindent"><strong>Row 8</strong> P.</p>
<p class="nonindent"><strong>Row 9</strong> K4, kfb, kfb, k5.</p>
<p class="nonindent"><strong>Row 10</strong> P.</p>
<p class="nonindent"><strong>Row 11</strong> K5, kfb, kfb, k6. 15 sts.</p>
<p class="nonindent"><strong>Row 12</strong> P.</p>
<p class="nonindent"><strong>Row 13</strong> K5, skpo, k1, k2tog, k5.</p>
<p class="nonindent"><strong>Row 14</strong> P.</p>
<p class="nonindent"><strong>Row 15</strong> K4, skpo, k1, k2tog, k4.</p>
<p class="nonindent"><strong>Row 16</strong> P.</p>
<p class="nonindent"><strong>Row 17</strong> K3, skpo, k1, k2tog, k3.</p>
<p class="nonindent"><strong>Row 18</strong> P.</p>
<p class="nonindent"><strong>Row 19</strong> K2, skpo, k1, k2tog, k2.</p>
<p class="nonindent"><strong>Row 20</strong> P.</p>
<p class="nonindent"><strong>Row 21</strong> K1, skpo, k1, k2tog, k1.</p>
<p class="nonindent"><strong>Row 22</strong> P5tog.</p>
<p class="nonindent">Tie off yarn.</p>
<p class="center"><img alt="" src="OEBPS/images/83-1.jpg"/></p>
<p class="center"><img alt="" src="OEBPS/images/84-1.jpg"/></p>
<h2 class="section"><strong>MAKING UP</strong></h2>
<p class="extract">Body</p>
<p class="nonindent">Fold the body in half with knit sides (right sides) together. Sew up from each end leaving a gap of approx. 11/8in (3cm) in the middle.</p>
<p class="nonindent">Turn the right way out so the knit sides (right sides) are on the outside.</p>
<p class="nonindent">Fill with stuffing.</p>
<p class="nonindent">Sew up the 11/8in (3cm) gap.</p>
<p class="extract">Feet</p>
<p class="nonindent">Fold the feet in half and sew round the edges.</p>
<p class="nonindent">Position feet to the base of the body and sew <br/>them on tightly.</p>
<p class="extract">Wings</p>
<p class="nonindent">Fold the wings in half and sew round the edges.</p>
<p class="nonindent">Position the wings to each side of the body just <br/>below the neck, with the pointed part of the <br/>wings facing downwards.</p>
<p class="extract">Beak</p>
<p class="nonindent">Sew the two sides together and fill with stuffing.</p>
<p class="nonindent">Position the beak correctly at the bottom of the white part of the penguin’s face.</p>
<p class="nonindent">Sew on tightly.</p>
<p class="extract">Finishing touches</p>
<p class="nonindent">Embroider eyes using brown or black yarn (as shown in the photograph).</p>
<p class="center"><img alt="" src="OEBPS/images/85-1.jpg"/></p>
<p class="center"><img alt="" src="OEBPS/images/86-1.jpg"/></p>
<p class="center"><img alt="" src="OEBPS/images/87-1.jpg"/></p>
<p class="pagebreak"> </p>
<h1 class="section" id="sec13">The Owl and the Pussycat</h1>
<p class="center">Rating from M to <img alt="" src="OEBPS/images/11-2.jpg"/><img alt="" src="OEBPS/images/11-2.jpg"/></p>
<p class="center"><strong><em>See individual project patterns for more detail</em></strong></p>
<p class="center">The owl and the pussycat set out on their adventures to explore the secret islands. In their boat they packed lots of lovely food and treats made by all their friends. There was a delicious cake made by the three little pigs, carrot sandwiches from the bunnies, biscuit crumbs from all the naughty little mice, and a big pot of tea from the three bears. By the light of the moon they sailed away as they waved goodbye to the animals on the sand.</p>
<p class="center">There are various pieces involved in making this project. There are the owl and the pussycat, of course, and then there is their boat (pp. 94–95), complete with an anchor embroidered with their initials. The inside of the boat is reinforced with some lining material to give it some structure and help support the knitted characters.</p>
<p class="center"><img alt="" src="OEBPS/images/88-1.jpg"/></p>
<p class="center"><img alt="" src="OEBPS/images/89-1.jpg"/></p>
<h2 class="section">The Owl</h2>
<p class="center">Rating <img alt="" src="OEBPS/images/11-2.jpg"/><img alt="" src="OEBPS/images/11-2.jpg"/></p>
<p class="center"><strong><em>The owl is fairly easy, although you will need to use intarsia to give him his snowy-white front</em></strong></p>
<p class="center">I used two shades of variegated yarn to give the owl a look of tawny feathers contrasting with his white chest. His round eyes are made out of felt and stitched on – see p. 117 for the template. Take care with the owl’s finishing touches and give him beautiful big eyes. Fill him with plenty of stuffing to make his ears pointed and his belly nice and round.</p>
<div class="box">
<p class="extract"><strong>yarn</strong></p>
<p class="nonindent">Lightweight (DK) wool or wool mix yarn</p>
<p class="nonindent">1 x 1¾oz (50g) ball in variegated deep <br/>reds (<strong>A</strong>)</p>
<p class="nonindent">1 x 1¾oz (50g) ball in cream (<strong>B</strong>)</p>
<p class="nonindent">1 x 1¾oz (50g) ball in variegated bright <br/>reds (<strong>C</strong>)</p>
<p class="nonindent">Small amount of yellow (<strong>D</strong>)</p>
<p class="extract"><strong>needles</strong></p>
<p class="nonindent">Size 6 (4mm) knitting needles</p>
<p class="extract"><strong>gauge</strong></p>
<p class="nonindent">22 sts and 28 rows to 4in (10cm)</p>
<p class="nonindent"><em>Don’t worry if the gauge is not exact – it doesn’t matter if the owl is a little bigger or smaller than shown</em></p>
<p class="extract"><strong>finished size</strong></p>
<p class="nonindent">Approx. 8¼in (21cm) tall and 5in (13cm) wide (not including wings)</p>
</div>
<p class="center"><img alt="" src="OEBPS/images/90-1.jpg"/></p>
<h2 class="section">Owl pattern</h2>
<p class="extract">EARS</p>
<p class="nonindent">Cast on 5 sts using <strong>yarn</strong> <strong>A</strong> and size 6 (4mm) <br/>knitting needles.</p>
<p class="nonindent">Working in st st, inc 1 st at end of every row until there are 27 sts. Slip onto a spare needle.</p>
<p class="nonindent">Rep for 2nd ear.</p>
<p class="nonindent">Slip the sts of both ears onto 1 needle.</p>
<p class="nonindent">P across all 54 sts.</p>
<p class="extract">BODY</p>
<p class="nonindent">Cont with the 54 sts from the ears.</p>
<p class="nonindent"><strong>Row 1</strong> K.</p>
<p class="nonindent"><strong>Row 2</strong> P.</p>
<p class="nonindent">Rep these 2 rows 3 more times.</p>
<p class="nonindent"><strong>Row 9</strong> K13, skpo, k24, k2tog, k13.</p>
<p class="nonindent"><strong>Row 10</strong> P.</p>
<p class="nonindent"><strong>Row 11</strong> K13, skpo, k22, k2tog, k13. 50 sts.</p>
<p class="nonindent"><strong>Row 12</strong> P.</p>
<p class="nonindent"><strong>Row 13</strong> K13, kfb, k21, kfb, k14.</p>
<p class="nonindent"><strong>Row 14</strong> P.</p>
<p class="nonindent"><strong>Row 15</strong> K13, kfb, k23, kfb, k14.</p>
<p class="nonindent"><strong>Row 16</strong> P.</p>
<p class="nonindent"><strong>Row 17</strong> K13, kfb, k25, kfb, k14. 56 sts.</p>
<p class="nonindent"><strong>Row 18</strong> P.</p>
<p class="nonindent"><strong>Row 19</strong> [kfb, k12, kfb] rep 4 times.</p>
<p class="nonindent"><strong>Row 20</strong> P.</p>
<p class="nonindent"><strong>Row 21</strong> [kfb, k14, kfb] rep 4 times. 72 sts.</p>
<p class="nonindent"><strong>Row 22</strong> P.</p>
<p class="nonindent">Beg the colour changes.</p>
<p class="nonindent"><strong>Row 23</strong> K30 in <strong>A</strong>, k12 in <strong>B</strong>, k30 in <strong>A</strong>.</p>
<p class="nonindent"><strong>Row 24</strong> K29 in <strong>C</strong>, p14 in <strong>B</strong>, k29 in <strong>C</strong>.</p>
<p class="nonindent"><strong>Row 25</strong> K28 in <strong>C</strong>, k16 in <strong>B</strong>, k28 in <strong>C</strong>.</p>
<p class="nonindent"><strong>Row 26</strong> P27 in <strong>C</strong>, p18 in <strong>B</strong>, p27 in <strong>C</strong>.</p>
<p class="nonindent"><strong>Row 27</strong> K26 in <strong>C</strong>, k20 in <strong>B</strong>, k26 in <strong>C</strong>.</p>
<p class="nonindent"><strong>Row 28</strong> K25 in <strong>A</strong>, p22 in <strong>B</strong>, k25 in <strong>A</strong>.</p>
<p class="nonindent"><strong>Row 29</strong> K24 in <strong>A</strong>, k24 in <strong>B</strong>, k24 in <strong>A</strong>.</p>
<p class="nonindent"><strong>Row 30</strong> P23 in <strong>A</strong>, p26 in <strong>B</strong>, p23 in <strong>A</strong>.</p>
<p class="nonindent"><strong>Row 31</strong> K22 in <strong>A</strong>, k28 in <strong>B</strong>, k22 in <strong>A</strong>.</p>
<p class="nonindent"><strong>Row 32</strong> K21 in <strong>C</strong>, p30 in <strong>B</strong>, k21 in <strong>C</strong>.</p>
<p class="nonindent"><strong>Row 33</strong> K20 in <strong>C</strong>, k32 in <strong>B</strong>, k20 in <strong>C</strong>.</p>
<p class="nonindent"><strong>Row 34</strong> P20 in <strong>C</strong>, p32 in <strong>B</strong>, p20 in <strong>C</strong>.</p>
<p class="nonindent"><strong>Row 35</strong> K20 in <strong>C</strong>, k32 in <strong>B</strong>, k20 in <strong>C</strong>.</p>
<p class="nonindent"><strong>Row 36</strong> K20 in <strong>A</strong>, p32 in <strong>B</strong>, k20 in <strong>A</strong>.</p>
<p class="nonindent"><strong>Row 37</strong> K20 in <strong>A</strong>, k32 in <strong>B</strong>, k20 in <strong>A</strong>.</p>
<p class="nonindent"><strong>Row 38</strong> P20 in <strong>A</strong>, p32 in <strong>B</strong>, p20 in <strong>A</strong>.</p>
<p class="nonindent"><strong>Row 39</strong> K20 in <strong>A</strong>, k32 in <strong>B</strong>, k20 in <strong>A</strong>.</p>
<p class="nonindent"><strong>Row 40</strong> K20 in <strong>C</strong>, p32 in <strong>B</strong>, k20 in <strong>C</strong>.</p>
<p class="nonindent"><strong>Row 41</strong> K20 in <strong>C</strong>, k32 in <strong>B</strong>, k20 in <strong>C</strong>.</p>
<p class="nonindent"><strong>Row 42</strong> P20 in <strong>C</strong>, p32 in <strong>B</strong>, p20 in <strong>C</strong>.</p>
<p class="nonindent"><strong>Row 43</strong> K20 in <strong>C</strong>, k32 in <strong>B</strong>, k20 in <strong>C</strong>.</p>
<p class="nonindent"><strong>Row 44</strong> K21 in <strong>A</strong>, p30 in <strong>B</strong>, k21 in <strong>A</strong>.</p>
<p class="nonindent"><strong>Row 45</strong> K22 in <strong>A</strong>, k28 in <strong>B</strong>, k22 in <strong>A</strong>.</p>
<p class="nonindent"><strong>Row 46</strong> P23 in <strong>A</strong>, p26 in <strong>B</strong>, p23 in <strong>A</strong>.</p>
<p class="nonindent"><strong>Row 47</strong> K24 in <strong>A</strong>, k24 in <strong>B</strong>, k24 in <strong>A</strong>.</p>
<p class="nonindent"><strong>Row 48</strong> K25 in <strong>C</strong>, p22 in <strong>B</strong>, k25 in <strong>C</strong>.</p>
<p class="nonindent"><strong>Row 49</strong> K26 in <strong>C</strong>, k20 in <strong>B</strong>, k26 in <strong>C</strong>.</p>
<p class="nonindent"><strong>Row 50</strong> P27 in <strong>C</strong>, p18 in <strong>B,</strong> p27 in <strong>C</strong>.</p>
<p class="nonindent"><strong>Row 51</strong> K28 in <strong>C</strong>, k16 in <strong>B,</strong> k28 in <strong>C</strong>.</p>
<p class="nonindent"><strong>Row 52</strong> K29 in <strong>A</strong>, p14 in <strong>B,</strong> k29 in <strong>A</strong>.</p>
<p class="nonindent"><strong>Row 53</strong> K30 in <strong>A</strong>, k12 in <strong>B,</strong> k30 in <strong>A</strong>.</p>
<p class="nonindent"><strong>Row 54</strong> Cont in <strong>A</strong>, p.</p>
<p class="nonindent"><strong>Row 55</strong> [k2tog, k14, skpo] rep 4 times.</p>
<p class="nonindent"><strong>Row 56</strong> Change to <strong>C</strong>, k.</p>
<p class="nonindent"><strong>Row 57</strong> [k2tog, k12, skpo] rep 4 times.</p>
<p class="nonindent"><strong>Row 58</strong> P.</p>
<p class="nonindent"><strong>Row 59</strong> [k2tog] rep to end of row.</p>
<p class="nonindent"><strong>Row 60</strong> P.</p>
<p class="nonindent"><strong>Row 61</strong> [k2tog] rep to end of row.</p>
<p class="nonindent"><strong>Row 62</strong> P.</p>
<p class="nonindent">Thread yarn through rem sts.</p>
<p class="extract">WINGS (MAKE 2)</p>
<p class="nonindent">Cast on 12 sts using <strong>yarn</strong> <strong>A</strong> and size 6 (4mm) <br/>knitting needles.</p>
<p class="nonindent"><strong>Row 1</strong> K.</p>
<p class="nonindent"><strong>Row 2</strong> Kfb, p11.</p>
<p class="nonindent"><strong>Row 3</strong> K12, kfb.</p>
<p class="nonindent"><strong>Row 4</strong> Kfb, k13.</p>
<p class="nonindent"><strong>Row 5</strong> K13, k2tog.</p>
<p class="nonindent"><strong>Row 6</strong> P2tog, p12.</p>
<p class="nonindent"><strong>Row 7</strong> K11, k2tog.</p>
<p class="nonindent"><strong>Row 8</strong> Kfb, k11.</p>
<p class="nonindent"><strong>Row 9</strong> K12, kfb.</p>
<p class="nonindent"><strong>Row 10</strong> Kfb, p13.</p>
<p class="nonindent"><strong>Row 11</strong> K14, kfb.</p>
<p class="nonindent"><strong>Row 12</strong> K2tog, k14.</p>
<p class="nonindent"><strong>Row 13</strong> K13, k2tog.</p>
<p class="nonindent"><strong>Row 14</strong> P2tog, p12.</p>
<p class="nonindent"><strong>Row 15</strong> K11, k2tog.</p>
<p class="nonindent"><strong>Row 16</strong> Kfb, k11.</p>
<p class="nonindent"><strong>Row 17</strong> K12, kfb.</p>
<p class="nonindent"><strong>Row 18</strong> Kfb, p13.</p>
<p class="nonindent"><strong>Row 19</strong> K14, kfb.</p>
<p class="nonindent"><strong>Row 20</strong> K2tog, k14.</p>
<p class="nonindent"><strong>Row 21</strong> K13, k2tog.</p>
<p class="nonindent"><strong>Row 22</strong> P2tog, p12.</p>
<p class="nonindent"><strong>Row 23</strong> K11, k2tog.</p>
<p class="nonindent">Rep from row 8 to row 23.</p>
<p class="nonindent">Bind off.</p>
<p class="center"><img alt="" src="OEBPS/images/91-1.jpg"/></p>
<p class="extract">FEET (MAKE 2)</p>
<p class="nonindent">Cast on 3 sts using <strong>yarn D</strong> and size 6 (4mm) <br/>knitting needles.</p>
<p class="nonindent"><strong>Row 1</strong> Kfb, kfb, k1.</p>
<p class="nonindent"><strong>Row 2</strong> P.</p>
<p class="nonindent"><strong>Row 3</strong> K1, kfb, kfb, k2.</p>
<p class="nonindent"><strong>Row 4</strong> P.</p>
<p class="nonindent"><strong>Row 5</strong> K2, kfb, kfb, k3.</p>
<p class="nonindent"><strong>Row 6</strong> P.</p>
<p class="nonindent"><strong>Row 7</strong> K3, kfb, kfb, k4.</p>
<p class="nonindent"><strong>Row 8</strong> P.</p>
<p class="nonindent"><strong>Row 9</strong> K4, kfb, kfb, k5.</p>
<p class="nonindent"><strong>Row 10</strong> P.</p>
<p class="nonindent"><strong>Row 11</strong> K5, kfb, kfb, k6. 15 sts.</p>
<p class="nonindent"><strong>Row 12</strong> P.</p>
<p class="nonindent"><strong>Row 13</strong> K5, skpo, k1, k2tog, k5.</p>
<p class="nonindent"><strong>Row 14</strong> P.</p>
<p class="nonindent"><strong>Row 15</strong> K4, skpo, k1, k2tog, k4.</p>
<p class="nonindent"><strong>Row 16</strong> P.</p>
<p class="nonindent"><strong>Row 17</strong> K3, skpo, k1, k2tog, k3.</p>
<p class="nonindent"><strong>Row 18</strong> P.</p>
<p class="nonindent"><strong>Row 19</strong> K2, skpo, k1, k2tog, k2.</p>
<p class="nonindent"><strong>Row 20</strong> P.</p>
<p class="nonindent"><strong>Row 21</strong> K1, skpo, k1, k2tog, k1.</p>
<p class="nonindent"><strong>Row 22</strong> P5tog.</p>
<p class="nonindent">Tie off yarn.</p>
<p class="extract">BEAK (MAKE 2 PIECES)</p>
<p class="nonindent">Cast on 3 sts in <strong>yarn D</strong>.</p>
<p class="nonindent"><strong>Row 1</strong> Kfb, kfb, k1.</p>
<p class="nonindent"><strong>Row 2</strong> P.</p>
<p class="nonindent"><strong>Row 3</strong> K1, kfb, kfb, k2.</p>
<p class="nonindent"><strong>Row 4</strong> P.</p>
<p class="nonindent"><strong>Row 5</strong> K2, kfb, kfb, k3.</p>
<p class="nonindent"><strong>Row 6</strong> P.</p>
<p class="nonindent"><strong>Row 7</strong> K3, kfb, kfb, k4.</p>
<p class="nonindent"><strong>Row 8</strong> P.</p>
<p class="nonindent">Bind off.</p>
<h2 class="section"><strong>MAKING UP</strong></h2>
<p class="extract">Body</p>
<p class="nonindent">Fold both sides of the body together with the seam at the back and the cream tummy at the front.</p>
<p class="nonindent">Starting from the top of each ear, sew to the top of the back seam, then sew from the top and bottom of each end, leaving a gap of approx. 11/8in (3cm) in the middle.</p>
<p class="nonindent">Turn the right way out so the knit sides (right sides) are on the outside.</p>
<p class="nonindent">Fill with stuffing.</p>
<p class="nonindent">Sew up the 11/8in (3cm) gap.</p>
<p class="extract">Feet</p>
<p class="nonindent">Fold the feet in half and sew round the edges.</p>
<p class="nonindent">Position feet to the base of the body and sew them <br/>on tightly.</p>
<p class="extract">Wings</p>
<p class="nonindent">Fold the wings in half and sew round the edges.</p>
<p class="nonindent">Pull up at the top of each wing to slightly gather.</p>
<p class="nonindent">Stitch the wings to each side of the owl’s body using the white breast to help position them correctly.</p>
<p class="extract">Beak</p>
<p class="nonindent">Sew both pieces together and fill with stuffing.</p>
<p class="nonindent">Stitch the beak to the owl’s head using the shaping at the front of the head to position it correctly.</p>
<p class="extract">Finishing touches</p>
<p class="nonindent">Cut out two felt eyes using the template provided <br/>(see p. 117).</p>
<p class="nonindent">Position the eyes correctly to the owl’s face using the beak and ears to help space them evenly apart.</p>
<p class="nonindent">Stitch round the edge of the eyes using brown thread.</p>
<p class="nonindent">In the centre of the eye, embroider pupils using brown or black yarn (as shown in the photograph).</p>
<p class="nonindent">Use brown or black yarn to add a few stitches to the beak to make nostrils.</p>
<div class="block">
<p class="extract"><strong>KNITTING NOTES</strong></p>
<p class="nonindent">• You start knitting the owl from his ears and work down towards <br/>his feet.</p>
<p class="nonindent">• The colourwork for this project is done using the intarsia method (see p. 108). When knitting using two colours, make sure you wrap the yarns around one another when changing from one colour to the next. This prevents holes appearing between colours.</p>
</div>
<p class="center"><img alt="" src="OEBPS/images/93-1.jpg"/></p>
<h2 class="section">The Pussycat</h2>
<p class="center">Rating <img alt="" src="OEBPS/images/11-2.jpg"/></p>
<p class="center"><strong><em>The pussycat is quite easy to make, but take care over embroidering her features</em></strong></p>
<p class="center">I made the pussycat in two shades of variegated yarn to give her the look of tabby-striped fur. Use whatever colour you like – maybe a pure black cat with green eyes, or a stripy orange one to look like a favourite ginger puss.</p>
<div class="box">
<p class="extract"><strong>yarn</strong></p>
<p class="nonindent">Lightweight (DK) 100% wool</p>
<p class="nonindent">1 x 1¾oz (50g) ball in variegated browns (<strong>A</strong>)</p>
<p class="nonindent">1 x 1¾oz (50g) ball in variegated bright <br/>reds (<strong>B</strong>)</p>
<p class="extract"><strong>needles</strong></p>
<p class="nonindent">Size 6 (4mm) knitting needles</p>
<p class="extract"><strong>gauge</strong></p>
<p class="nonindent">22 sts and 28 rows to 4in (10cm)</p>
<p class="nonindent"><em>Don’t worry if the gauge is not exact – it doesn’t matter if the pussycat is a little bigger or smaller than shown</em></p>
<p class="extract"><strong>finished size</strong></p>
<p class="nonindent">7in (18cm) tall and 4¾in (12cm) wide (not including tail)</p>
</div>
<h2 class="section">Pussycat pattern</h2>
<p class="extract">HEAD AND BODY</p>
<p class="nonindent">Cast on 9 sts using <strong>yarn</strong> <strong>A</strong> and size 6 (4mm) <br/>knitting needles.</p>
<p class="nonindent"><strong>Row 1</strong> [kfb, k1] rep 4 times, k1.</p>
<p class="nonindent"><strong>Row 2</strong> P.</p>
<p class="nonindent"><strong>Row 3</strong> [kfb, k1, kfb] rep 4 times, k1. 21 sts.</p>
<p class="nonindent"><strong>Row 4</strong> P.</p>
<p class="nonindent"><strong>Row 5</strong> [kfb, k3, kfb] rep 4 times, k1. 29 sts.</p>
<p class="nonindent"><strong>Row 6</strong> P.</p>
<p class="nonindent"><strong>Row 7</strong> [kfb, k5, kfb] rep 4 times, k1. 31 sts.</p>
<p class="nonindent"><strong>Row 8</strong> P.</p>
<p class="nonindent"><strong>Row 9</strong> [kfb, k7, kfb] rep 4 times, k1. 45 sts.</p>
<p class="nonindent"><strong>Row 10</strong> P.</p>
<p class="nonindent"><strong>Row 11</strong> [kfb, k9, kfb] rep 4 times, k1. 53 sts.</p>
<p class="nonindent"><strong>Row 12</strong> P.</p>
<p class="nonindent">Cont in st st for 8 rows.</p>
<p class="nonindent"><strong>Row 21</strong> [kfb, k11, kfb] rep 4 times, k1. 61 sts.</p>
<p class="nonindent"><strong>Row 22</strong> P.</p>
<p class="nonindent"><strong>Row 23</strong> K.</p>
<p class="nonindent"><strong>Row 24</strong> P.</p>
<p class="nonindent"><strong>Row 25</strong> Change to <strong>yarn</strong> <strong>B</strong>, k.</p>
<p class="nonindent"><strong>Row 26</strong> P.</p>
<p class="nonindent"><strong>Row 27</strong> [kfb, k13, kfb] rep 4 times, k1. 69 sts.</p>
<p class="nonindent"><strong>Row 28</strong> P.</p>
<p class="nonindent"><strong>Row 29 A</strong>, k.</p>
<p class="nonindent"><strong>Row 30</strong> P.</p>
<p class="nonindent"><strong>Row 31 B</strong>, k.</p>
<p class="nonindent"><strong>Row 32</strong> P.</p>
<p class="nonindent"><strong>Row 33 A</strong>, k.</p>
<p class="nonindent"><strong>Row 34</strong> P.</p>
<p class="nonindent"><strong>Row 35</strong> K.</p>
<p class="nonindent"><strong>Row 36</strong> P.</p>
<p class="nonindent"><strong>Row 37 B</strong>, k.</p>
<p class="nonindent"><strong>Row 38</strong> P.</p>
<p class="nonindent"><strong>Row 39 A</strong>, k.</p>
<p class="nonindent"><strong>Row 40</strong> P.</p>
<p class="nonindent"><strong>Row 41 B</strong>, k.</p>
<p class="nonindent"><strong>Row 42</strong> P.</p>
<p class="nonindent"><strong>Row 43</strong> K.</p>
<p class="nonindent"><strong>Row 44</strong> P.</p>
<p class="nonindent">Rep from row 29 to row 41.</p>
<p class="nonindent"><strong>Row 57 B</strong>, [k2tog, k13, skpo] rep 4 times, k1.</p>
<p class="nonindent"><strong>Row 58</strong> P.</p>
<p class="nonindent"><strong>Row 59</strong> [k2tog, k11, skpo] rep 4 times, k1.</p>
<p class="nonindent"><strong>Row 60</strong> P.</p>
<p class="nonindent"><strong>Row 61 A</strong>, [k2tog] rep to last st, k1.</p>
<p class="nonindent"><strong>Row 62</strong> P.</p>
<p class="nonindent"><strong>Row 63 B</strong>, [k2tog] rep to last st, k1.</p>
<p class="nonindent"><strong>Row 64</strong> P. 14 sts.</p>
<p class="nonindent">Pull thread through rem sts.</p>
<p class="extract">EARS (MAKE 2)</p>
<p class="nonindent">Cast on 5 sts using <strong>yarn A</strong> and size 6 (4mm) <br/>knitting needles.</p>
<p class="nonindent"><strong>Row 1</strong> K1, kfb, kfb, k2.</p>
<p class="nonindent"><strong>Row 2</strong> P.</p>
<p class="nonindent"><strong>Row 3</strong> K2, kfb, kfb, k3.</p>
<p class="nonindent"><strong>Row 4</strong> P.</p>
<p class="nonindent"><strong>Row 5</strong> K3, kfb, kfb, k4.</p>
<p class="nonindent"><strong>Row 6</strong> P.</p>
<p class="nonindent"><strong>Row 7</strong> K4, kfb, kfb, k3.</p>
<p class="nonindent"><strong>Row 8</strong> P.</p>
<p class="nonindent">Bind off.</p>
<p class="extract">TAIL</p>
<p class="nonindent">Cast on 20 sts using <strong>yarn A</strong> and size 6 <br/>(4mm) knitting needles.</p>
<p class="nonindent"><strong>Row 1</strong> K.</p>
<p class="nonindent"><strong>Row 2</strong> P.</p>
<p class="nonindent"><strong>Row 3</strong> K.</p>
<p class="nonindent"><strong>Row 4</strong> P.</p>
<p class="nonindent"><strong>Row 5</strong> Change to <strong>yarn B</strong>, k.</p>
<p class="nonindent"><strong>Row 6</strong> P.</p>
<p class="nonindent"><strong>Row 7</strong> K.</p>
<p class="nonindent"><strong>Row 8</strong> P.</p>
<p class="nonindent">Rep rows 1 to 8, 4 more times.</p>
<p class="nonindent"><strong>Row 41</strong> Change to <strong>yarn A</strong>, k .</p>
<p class="nonindent"><strong>Row 42</strong> P.</p>
<p class="nonindent"><strong>Row 43</strong> [k2tog] rep to end of row.</p>
<p class="nonindent"><strong>Row 44</strong> [p2tog] rep to end of row.</p>
<p class="nonindent">Thread yarn through rem sts.</p>
<h2 class="section"><strong>MAKING UP</strong></h2>
<p class="extract">Body</p>
<p class="nonindent">Fold the pussycat in half with knit sides (right <br/>sides) together.</p>
<p class="nonindent">Making sure the stripes match up correctly, sew from each end of the cat, leaving a gap of approx. <br/>11/8 in (3cm) in the middle.</p>
<p class="nonindent">Turn the right way out so the knit sides (right sides) are on the outside. Fill with stuffing.</p>
<p class="nonindent">Sew up the 11/8in (3cm) gap.</p>
<p class="extract">Ears</p>
<p class="nonindent">Cut out two iron-on interfacing-lined ear pads (see <br/>p. 117 for template) and sew onto the purl side of the ear (see p. 113).</p>
<p class="nonindent">Stitch the ears to each side of the cat’s head <br/>using the shaping at the top to position them evenly apart.</p>
<p class="extract">Tail</p>
<p class="nonindent">Fold the tail in half with knit sides (right sides) together.</p>
<p class="nonindent">Making sure the stripes match up correctly, sew up the tail to make a tube with the shaped end closed.</p>
<p class="nonindent">Turn the right way out so the knit sides (right sides) are on the outside. Fill with stuffing.</p>
<p class="nonindent">Position the tail to the back of the cat using the seam as a centre guide.</p>
<p class="nonindent">Make a small stitch to attach the tail to the side <br/>of the cat.</p>
<p class="extract">Finishing touches</p>
<p class="nonindent">Embroider the nose using pink yarn and the mouth, eyes and whiskers using brown or black yarn (as shown in the photograph). Unravel the yarn if you want to create curly whiskers.</p>
<p class="center"><img alt="" src="OEBPS/images/95-1.jpg"/></p>
<div class="block">
<p class="extract"><strong>KNITTING NOTES</strong></p>
<p class="nonindent">• You start knitting the pussycat from her head downwards.</p>
<p class="nonindent">• The pussycat’s body is worked in stripes. It’s best to work these by carrying the yarn currently not being worked up the side. Avoid breaking the yarn at the end of each stripe; carrying the yarns up the side instead ensures an even, straight edge. Keep your gauge consistent and don’t pull the edge too tight.</p>
</div>
<h2 class="section">The Owl and the Pussycat’s Boat</h2>
<p class="center">Rating <img alt="" src="OEBPS/images/11-2.jpg"/></p>
<p class="center"><strong><em>The shapes of the boat are easy to make, although you may find the anchor a little fiddly</em></strong></p>
<p class="center">The boat features some garter-stitch ridges to look like the planks of a rowing boat. I used variegated greens for a pea-green <br/>boat, but you could use brown yarn to make it look more like a traditional wooden sailing boat.</p>
<div class="box">
<p class="extract"><strong>yarn</strong></p>
<p class="nonindent">Lightweight (DK) 100% wool</p>
<p class="nonindent">Boat – 2 x 1¾oz (50g) balls in variegated greens (<strong>A</strong>)</p>
<p class="nonindent">Anchor – small amount of grey (<strong>B</strong>)</p>
<p class="extract"><strong>needles</strong></p>
<p class="nonindent">Size 10½ (7mm) knitting needles</p>
<p class="nonindent">3 size 8 (5mm) double-pointed needles</p>
<p class="nonindent">Size E4 (3.5mm) crochet hook</p>
<p class="extract"><strong>gauge</strong></p>
<p class="nonindent">14 sts and 22 rows to 4in (10cm)</p>
<p class="nonindent"><em>Don’t worry if the gauge is not exact – it doesn’t matter if the boat is a little bigger or smaller than shown</em></p>
<p class="extract"><strong>finished size</strong></p>
<p class="nonindent">Approx. 12½in (32cm) long</p>
</div>
<h2 class="section">Boat pattern</h2>
<p class="extract">Note that the sides and ends of the boat are knitted using 2 strands of yarn together. This creates a more sturdy boat.</p>
<p class="extract">BOAT SIDES (MAKE 2)</p>
<p class="nonindent">Cast on 40 sts using <strong>yarn A</strong> and size 10½ (7mm) knitting needles.</p>
<p class="nonindent">K 4 rows.</p>
<p class="nonindent"><strong>Row 5</strong> P.</p>
<p class="nonindent"><strong>Row 6</strong> K2tog, k to last 2 sts, k2tog. 38 sts.</p>
<p class="nonindent"><strong>Row 7</strong> P.</p>
<p class="nonindent"><strong>Row 8</strong> K.</p>
<p class="nonindent"><strong>Row 9</strong> K.</p>
<p class="nonindent"><strong>Row 10</strong> K2tog, k to last 2 sts, k2tog. 36 sts.</p>
<p class="nonindent"><strong>Row 11</strong> P.</p>
<p class="nonindent"><strong>Row 12</strong> K.</p>
<p class="nonindent"><strong>Row 13</strong> P.</p>
<p class="nonindent"><strong>Row 14</strong> K.</p>
<p class="nonindent"><strong>Row 15</strong> K.</p>
<p class="nonindent"><strong>Row 16</strong> K2tog, k to last 2 sts, k2tog. 34 sts.</p>
<p class="nonindent"><strong>Row 17</strong> P.</p>
<p class="nonindent"><strong>Row 18</strong> K.</p>
<p class="nonindent"><strong>Row 19</strong> P.</p>
<p class="nonindent"><strong>Row 20</strong> K.</p>
<p class="nonindent"><strong>Row 21</strong> K.</p>
<p class="nonindent"><strong>Row 22</strong> K2tog, k to last 2 sts, k2tog. 32 sts.</p>
<p class="nonindent"><strong>Row 23</strong> P.</p>
<p class="nonindent"><strong>Row 24</strong> K.</p>
<p class="nonindent"><strong>Row 25</strong> P.</p>
<p class="nonindent"><strong>Row 26</strong> K.</p>
<p class="nonindent">Bind off.</p>
<p class="extract">BOAT ENDS (MAKE 2)</p>
<p class="nonindent">Cast on 8 sts using <strong>yarn A</strong> and size 10½ (7mm) knitting needles.</p>
<p class="nonindent">K 4 rows</p>
<p class="nonindent"><strong>Row 5</strong> P.</p>
<p class="nonindent"><strong>Row 6</strong> K.</p>
<p class="nonindent"><strong>Row 7</strong> P.</p>
<p class="nonindent"><strong>Row 8</strong> K.</p>
<p class="nonindent"><strong>Row 9</strong> K.</p>
<p class="nonindent"><strong>Row 10</strong> K.</p>
<p class="nonindent">Rep rows 5 to 10.</p>
<p class="nonindent"><strong>Row 17</strong> P.</p>
<p class="nonindent"><strong>Row 18</strong> K.</p>
<p class="nonindent"><strong>Row 19</strong> P.</p>
<p class="nonindent"><strong>Row 20</strong> K.</p>
<p class="nonindent">Bind off.</p>
<p class="extract">ANCHOR BOTTOM</p>
<p class="nonindent">Cast on 4 sts using <strong>yarn B</strong> and size 8 (5mm) <br/>double-pointed knitting needles.</p>
<p class="nonindent">Transfer 2 sts onto the 2nd needle.</p>
<p class="nonindent">Knit in the round for 4 rows.</p>
<p class="nonindent"><strong>Row 5</strong> [k1, kfb] twice. 6 sts.</p>
<p class="nonindent">Introduce the 3rd double-pointed needle and put <br/>2 sts on each needle.</p>
<p class="nonindent"><strong>Row 6</strong> K.</p>
<p class="nonindent"><strong>Row 7</strong> K.</p>
<p class="nonindent"><strong>Row 8</strong> K.</p>
<p class="nonindent"><strong>Row 9</strong> [k1, kfb] 3 times. 9 sts.</p>
<p class="nonindent"><strong>Row 10</strong> K.</p>
<p class="nonindent"><strong>Row 11</strong> K.</p>
<p class="nonindent"><strong>Row 12</strong> [k2, kfb] 3 times. 12 sts.</p>
<p class="nonindent">Knit 4 rows.</p>
<p class="nonindent"><strong>Row 17</strong> [k2, k2tog] 3 times. 9 sts.</p>
<p class="nonindent"><strong>Row 18</strong> K.</p>
<p class="nonindent"><strong>Row 19</strong> K.</p>
<p class="nonindent"><strong>Row 20</strong> [k1, k2tog] 3 times. 6 sts.</p>
<p class="nonindent"><strong>Row 21</strong> K.</p>
<p class="nonindent"><strong>Row 22</strong> K.</p>
<p class="nonindent"><strong>Row 23</strong> K.</p>
<p class="nonindent"><strong>Row 24</strong> [k1, k2tog] 2 times. 4 sts.</p>
<p class="nonindent">Put aside the 3rd needle and put 2 sts on <br/>the rem 2 needles.</p>
<p class="nonindent">Knit in the round for 4 rows.</p>
<p class="nonindent">Bind off.</p>
<p class="extract">ANCHOR TOP</p>
<p class="nonindent">Pick up 4 sts from the top of the anchor bottom <br/>(2 sts on each needle).</p>
<p class="nonindent">Knit in the round for 10 rows.</p>
<p class="nonindent">Transfer 2 sts onto a holding needle. Save these <br/>for later.</p>
<p class="nonindent"><strong>Row 11</strong> P2.</p>
<p class="nonindent"><strong>Row 12</strong> K2.</p>
<p class="nonindent">Rep rows 11 and 12, 10 more times.</p>
<p class="nonindent">Join the 2 sts left on the holding needle to those on <br/>the knitting needle to create a ring.</p>
<p class="nonindent">Bind off all sts, leaving length of yarn to crochet the anchor chain.</p>
<p class="extract">ANCHOR CHAIN</p>
<p class="nonindent">Using 1 end of yarn and a size E4 (3.5mm) crochet hook, make a crochet chain approx. 4in (10cm) long.</p>
<p class="nonindent">Loop through the anchor top ring.</p>
<p class="nonindent">Tie off yarn.</p>
<h2 class="section"><strong>MAKING UP</strong></h2>
<p class="nonindent">Sew together the bottom of both boat sides.</p>
<p class="nonindent">Sew a boat end to each end.</p>
<p class="nonindent">Cut out a 11/8 in (3cm) wide strip of iron-on interfacing-lined fabric to reinforce the inside of the boat. Measure round the inside of the boat and cut a piece of fabric the same length. (A thick ribbon instead of a strip of fabric would work too.) Sew neatly round the inside top for an extra detail. This also adds support to the boat sides.</p>
<p class="nonindent">Attach the anchor chain to the end of the boat.</p>
<p class="nonindent">Embroider ‘O&amp;P’ on the anchor using yellow yarn.</p>
<p class="center"><img alt="" src="OEBPS/images/97-1.jpg"/></p>
<div class="block">
<p class="extract"><strong>KNITTING NOTES</strong></p>
<p class="nonindent">You will be knitting with 2 strands of yarn throughout for the 2 sides and ends of the boat.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c01.vue?743fcdaf